/*! For license information please see bundle.scripts.js.LICENSE.txt */

(() => {
  var e = {
      711: function (e) {
        e.exports = (function (e) {
          function t(i) {
            if (n[i]) return n[i].exports;
            var r = (n[i] = { exports: {}, id: i, loaded: !1 });
            return (
              e[i].call(r.exports, r, r.exports, t), (r.loaded = !0), r.exports
            );
          }
          var n = {};
          return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
        })([
          function (e, t, n) {
            "use strict";
            function i(e) {
              return e && e.__esModule ? e : { default: e };
            }
            var r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var i in n)
                      Object.prototype.hasOwnProperty.call(n, i) &&
                        (e[i] = n[i]);
                  }
                  return e;
                },
              o = (i(n(1)), n(6)),
              a = i(o),
              s = i(n(7)),
              l = i(n(8)),
              c = i(n(9)),
              u = i(n(10)),
              d = i(n(11)),
              p = i(n(14)),
              f = [],
              h = !1,
              m = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1,
              },
              g = function () {
                if (
                  (arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0] &&
                    (h = !0),
                  h)
                )
                  return (
                    (f = (0, d.default)(f, m)), (0, u.default)(f, m.once), f
                  );
              },
              v = function () {
                (f = (0, p.default)()), g();
              };
            e.exports = {
              init: function (e) {
                (m = r(m, e)), (f = (0, p.default)());
                var t = document.all && !window.atob;
                return (function (e) {
                  return (
                    !0 === e ||
                    ("mobile" === e && c.default.mobile()) ||
                    ("phone" === e && c.default.phone()) ||
                    ("tablet" === e && c.default.tablet()) ||
                    ("function" == typeof e && !0 === e())
                  );
                })(m.disable) || t
                  ? void f.forEach(function (e, t) {
                      e.node.removeAttribute("data-aos"),
                        e.node.removeAttribute("data-aos-easing"),
                        e.node.removeAttribute("data-aos-duration"),
                        e.node.removeAttribute("data-aos-delay");
                    })
                  : (m.disableMutationObserver ||
                      l.default.isSupported() ||
                      (console.info(
                        '\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '
                      ),
                      (m.disableMutationObserver = !0)),
                    document
                      .querySelector("body")
                      .setAttribute("data-aos-easing", m.easing),
                    document
                      .querySelector("body")
                      .setAttribute("data-aos-duration", m.duration),
                    document
                      .querySelector("body")
                      .setAttribute("data-aos-delay", m.delay),
                    "DOMContentLoaded" === m.startEvent &&
                    ["complete", "interactive"].indexOf(document.readyState) >
                      -1
                      ? g(!0)
                      : "load" === m.startEvent
                      ? window.addEventListener(m.startEvent, function () {
                          g(!0);
                        })
                      : document.addEventListener(m.startEvent, function () {
                          g(!0);
                        }),
                    window.addEventListener(
                      "resize",
                      (0, s.default)(g, m.debounceDelay, !0)
                    ),
                    window.addEventListener(
                      "orientationchange",
                      (0, s.default)(g, m.debounceDelay, !0)
                    ),
                    window.addEventListener(
                      "scroll",
                      (0, a.default)(function () {
                        (0, u.default)(f, m.once);
                      }, m.throttleDelay)
                    ),
                    m.disableMutationObserver ||
                      l.default.ready("[data-aos]", v),
                    f);
              },
              refresh: g,
              refreshHard: v,
            };
          },
          function (e, t) {},
          ,
          ,
          ,
          ,
          function (e, t) {
            (function (t) {
              "use strict";
              function n(e, t, n) {
                function r(t) {
                  var n = p,
                    i = f;
                  return (p = f = void 0), (y = t), (m = e.apply(i, n));
                }
                function a(e) {
                  return (y = e), (g = setTimeout(c, t)), C ? r(e) : m;
                }
                function l(e) {
                  var n = e - v;
                  return void 0 === v || n >= t || n < 0 || (T && e - y >= h);
                }
                function c() {
                  var e = x();
                  return l(e)
                    ? u(e)
                    : void (g = setTimeout(
                        c,
                        (function (e) {
                          var n = t - (e - v);
                          return T ? w(n, h - (e - y)) : n;
                        })(e)
                      ));
                }
                function u(e) {
                  return (g = void 0), S && p ? r(e) : ((p = f = void 0), m);
                }
                function d() {
                  var e = x(),
                    n = l(e);
                  if (((p = arguments), (f = this), (v = e), n)) {
                    if (void 0 === g) return a(v);
                    if (T) return (g = setTimeout(c, t)), r(v);
                  }
                  return void 0 === g && (g = setTimeout(c, t)), m;
                }
                var p,
                  f,
                  h,
                  m,
                  g,
                  v,
                  y = 0,
                  C = !1,
                  T = !1,
                  S = !0;
                if ("function" != typeof e) throw new TypeError(s);
                return (
                  (t = o(t) || 0),
                  i(n) &&
                    ((C = !!n.leading),
                    (h = (T = "maxWait" in n) ? b(o(n.maxWait) || 0, t) : h),
                    (S = "trailing" in n ? !!n.trailing : S)),
                  (d.cancel = function () {
                    void 0 !== g && clearTimeout(g),
                      (y = 0),
                      (p = v = f = g = void 0);
                  }),
                  (d.flush = function () {
                    return void 0 === g ? m : u(x());
                  }),
                  d
                );
              }
              function i(e) {
                var t = void 0 === e ? "undefined" : a(e);
                return !!e && ("object" == t || "function" == t);
              }
              function r(e) {
                return (
                  "symbol" == (void 0 === e ? "undefined" : a(e)) ||
                  ((function (e) {
                    return (
                      !!e && "object" == (void 0 === e ? "undefined" : a(e))
                    );
                  })(e) &&
                    y.call(e) == c)
                );
              }
              function o(e) {
                if ("number" == typeof e) return e;
                if (r(e)) return l;
                if (i(e)) {
                  var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                  e = i(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(u, "");
                var n = p.test(e);
                return n || f.test(e)
                  ? h(e.slice(2), n ? 2 : 8)
                  : d.test(e)
                  ? l
                  : +e;
              }
              var a =
                  "function" == typeof Symbol &&
                  "symbol" == typeof Symbol.iterator
                    ? function (e) {
                        return typeof e;
                      }
                    : function (e) {
                        return e &&
                          "function" == typeof Symbol &&
                          e.constructor === Symbol &&
                          e !== Symbol.prototype
                          ? "symbol"
                          : typeof e;
                      },
                s = "Expected a function",
                l = NaN,
                c = "[object Symbol]",
                u = /^\s+|\s+$/g,
                d = /^[-+]0x[0-9a-f]+$/i,
                p = /^0b[01]+$/i,
                f = /^0o[0-7]+$/i,
                h = parseInt,
                m =
                  "object" == (void 0 === t ? "undefined" : a(t)) &&
                  t &&
                  t.Object === Object &&
                  t,
                g =
                  "object" ==
                    ("undefined" == typeof self ? "undefined" : a(self)) &&
                  self &&
                  self.Object === Object &&
                  self,
                v = m || g || Function("return this")(),
                y = Object.prototype.toString,
                b = Math.max,
                w = Math.min,
                x = function () {
                  return v.Date.now();
                };
              e.exports = function (e, t, r) {
                var o = !0,
                  a = !0;
                if ("function" != typeof e) throw new TypeError(s);
                return (
                  i(r) &&
                    ((o = "leading" in r ? !!r.leading : o),
                    (a = "trailing" in r ? !!r.trailing : a)),
                  n(e, t, { leading: o, maxWait: t, trailing: a })
                );
              };
            }.call(
              t,
              (function () {
                return this;
              })()
            ));
          },
          function (e, t) {
            (function (t) {
              "use strict";
              function n(e) {
                var t = void 0 === e ? "undefined" : o(e);
                return !!e && ("object" == t || "function" == t);
              }
              function i(e) {
                return (
                  "symbol" == (void 0 === e ? "undefined" : o(e)) ||
                  ((function (e) {
                    return (
                      !!e && "object" == (void 0 === e ? "undefined" : o(e))
                    );
                  })(e) &&
                    v.call(e) == l)
                );
              }
              function r(e) {
                if ("number" == typeof e) return e;
                if (i(e)) return s;
                if (n(e)) {
                  var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                  e = n(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = d.test(e);
                return r || p.test(e)
                  ? f(e.slice(2), r ? 2 : 8)
                  : u.test(e)
                  ? s
                  : +e;
              }
              var o =
                  "function" == typeof Symbol &&
                  "symbol" == typeof Symbol.iterator
                    ? function (e) {
                        return typeof e;
                      }
                    : function (e) {
                        return e &&
                          "function" == typeof Symbol &&
                          e.constructor === Symbol &&
                          e !== Symbol.prototype
                          ? "symbol"
                          : typeof e;
                      },
                a = "Expected a function",
                s = NaN,
                l = "[object Symbol]",
                c = /^\s+|\s+$/g,
                u = /^[-+]0x[0-9a-f]+$/i,
                d = /^0b[01]+$/i,
                p = /^0o[0-7]+$/i,
                f = parseInt,
                h =
                  "object" == (void 0 === t ? "undefined" : o(t)) &&
                  t &&
                  t.Object === Object &&
                  t,
                m =
                  "object" ==
                    ("undefined" == typeof self ? "undefined" : o(self)) &&
                  self &&
                  self.Object === Object &&
                  self,
                g = h || m || Function("return this")(),
                v = Object.prototype.toString,
                y = Math.max,
                b = Math.min,
                w = function () {
                  return g.Date.now();
                };
              e.exports = function (e, t, i) {
                function o(t) {
                  var n = p,
                    i = f;
                  return (p = f = void 0), (x = t), (m = e.apply(i, n));
                }
                function s(e) {
                  return (x = e), (g = setTimeout(c, t)), C ? o(e) : m;
                }
                function l(e) {
                  var n = e - v;
                  return void 0 === v || n >= t || n < 0 || (T && e - x >= h);
                }
                function c() {
                  var e = w();
                  return l(e)
                    ? u(e)
                    : void (g = setTimeout(
                        c,
                        (function (e) {
                          var n = t - (e - v);
                          return T ? b(n, h - (e - x)) : n;
                        })(e)
                      ));
                }
                function u(e) {
                  return (g = void 0), S && p ? o(e) : ((p = f = void 0), m);
                }
                function d() {
                  var e = w(),
                    n = l(e);
                  if (((p = arguments), (f = this), (v = e), n)) {
                    if (void 0 === g) return s(v);
                    if (T) return (g = setTimeout(c, t)), o(v);
                  }
                  return void 0 === g && (g = setTimeout(c, t)), m;
                }
                var p,
                  f,
                  h,
                  m,
                  g,
                  v,
                  x = 0,
                  C = !1,
                  T = !1,
                  S = !0;
                if ("function" != typeof e) throw new TypeError(a);
                return (
                  (t = r(t) || 0),
                  n(i) &&
                    ((C = !!i.leading),
                    (h = (T = "maxWait" in i) ? y(r(i.maxWait) || 0, t) : h),
                    (S = "trailing" in i ? !!i.trailing : S)),
                  (d.cancel = function () {
                    void 0 !== g && clearTimeout(g),
                      (x = 0),
                      (p = v = f = g = void 0);
                  }),
                  (d.flush = function () {
                    return void 0 === g ? m : u(w());
                  }),
                  d
                );
              };
            }.call(
              t,
              (function () {
                return this;
              })()
            ));
          },
          function (e, t) {
            "use strict";
            function n(e) {
              var t = void 0,
                i = void 0;
              for (t = 0; t < e.length; t += 1) {
                if ((i = e[t]).dataset && i.dataset.aos) return !0;
                if (i.children && n(i.children)) return !0;
              }
              return !1;
            }
            function i() {
              return (
                window.MutationObserver ||
                window.WebKitMutationObserver ||
                window.MozMutationObserver
              );
            }
            function r(e) {
              e &&
                e.forEach(function (e) {
                  var t = Array.prototype.slice.call(e.addedNodes),
                    i = Array.prototype.slice.call(e.removedNodes);
                  if (n(t.concat(i))) return o();
                });
            }
            Object.defineProperty(t, "__esModule", { value: !0 });
            var o = function () {};
            t.default = {
              isSupported: function () {
                return !!i();
              },
              ready: function (e, t) {
                var n = window.document,
                  a = new (i())(r);
                (o = t),
                  a.observe(n.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0,
                  });
              },
            };
          },
          function (e, t) {
            "use strict";
            function n() {
              return (
                navigator.userAgent || navigator.vendor || window.opera || ""
              );
            }
            Object.defineProperty(t, "__esModule", { value: !0 });
            var i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    (i.enumerable = i.enumerable || !1),
                      (i.configurable = !0),
                      "value" in i && (i.writable = !0),
                      Object.defineProperty(e, i.key, i);
                  }
                }
                return function (t, n, i) {
                  return n && e(t.prototype, n), i && e(t, i), t;
                };
              })(),
              r =
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
              o =
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
              a =
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
              s =
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
              l = (function () {
                function e() {
                  !(function (e, t) {
                    if (!(e instanceof t))
                      throw new TypeError("Cannot call a class as a function");
                  })(this, e);
                }
                return (
                  i(e, [
                    {
                      key: "phone",
                      value: function () {
                        var e = n();
                        return !(!r.test(e) && !o.test(e.substr(0, 4)));
                      },
                    },
                    {
                      key: "mobile",
                      value: function () {
                        var e = n();
                        return !(!a.test(e) && !s.test(e.substr(0, 4)));
                      },
                    },
                    {
                      key: "tablet",
                      value: function () {
                        return this.mobile() && !this.phone();
                      },
                    },
                  ]),
                  e
                );
              })();
            t.default = new l();
          },
          function (e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", { value: !0 });
            t.default = function (e, t) {
              var n = window.pageYOffset,
                i = window.innerHeight;
              e.forEach(function (e, r) {
                !(function (e, t, n) {
                  var i = e.node.getAttribute("data-aos-once");
                  t > e.position
                    ? e.node.classList.add("aos-animate")
                    : void 0 !== i &&
                      ("false" === i || (!n && "true" !== i)) &&
                      e.node.classList.remove("aos-animate");
                })(e, i + n, t);
              });
            };
          },
          function (e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", { value: !0 });
            var i = (function (e) {
              return e && e.__esModule ? e : { default: e };
            })(n(12));
            t.default = function (e, t) {
              return (
                e.forEach(function (e, n) {
                  e.node.classList.add("aos-init"),
                    (e.position = (0, i.default)(e.node, t.offset));
                }),
                e
              );
            };
          },
          function (e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", { value: !0 });
            var i = (function (e) {
              return e && e.__esModule ? e : { default: e };
            })(n(13));
            t.default = function (e, t) {
              var n = 0,
                r = 0,
                o = window.innerHeight,
                a = {
                  offset: e.getAttribute("data-aos-offset"),
                  anchor: e.getAttribute("data-aos-anchor"),
                  anchorPlacement: e.getAttribute("data-aos-anchor-placement"),
                };
              switch (
                (a.offset && !isNaN(a.offset) && (r = parseInt(a.offset)),
                a.anchor &&
                  document.querySelectorAll(a.anchor) &&
                  (e = document.querySelectorAll(a.anchor)[0]),
                (n = (0, i.default)(e).top),
                a.anchorPlacement)
              ) {
                case "top-bottom":
                  break;
                case "center-bottom":
                  n += e.offsetHeight / 2;
                  break;
                case "bottom-bottom":
                  n += e.offsetHeight;
                  break;
                case "top-center":
                  n += o / 2;
                  break;
                case "bottom-center":
                  n += o / 2 + e.offsetHeight;
                  break;
                case "center-center":
                  n += o / 2 + e.offsetHeight / 2;
                  break;
                case "top-top":
                  n += o;
                  break;
                case "bottom-top":
                  n += e.offsetHeight + o;
                  break;
                case "center-top":
                  n += e.offsetHeight / 2 + o;
              }
              return (
                a.anchorPlacement || a.offset || isNaN(t) || (r = t), n + r
              );
            };
          },
          function (e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", { value: !0 });
            t.default = function (e) {
              for (
                var t = 0, n = 0;
                e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);

              )
                (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)),
                  (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)),
                  (e = e.offsetParent);
              return { top: n, left: t };
            };
          },
          function (e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", { value: !0 });
            t.default = function (e) {
              return (
                (e = e || document.querySelectorAll("[data-aos]")),
                Array.prototype.map.call(e, function (e) {
                  return { node: e };
                })
              );
            };
          },
        ]);
      },
      755: function (e, t) {
        var n;
        !(function (t, n) {
          "use strict";
          "object" == typeof e.exports
            ? (e.exports = t.document
                ? n(t, !0)
                : function (e) {
                    if (!e.document)
                      throw new Error(
                        "jQuery requires a window with a document"
                      );
                    return n(e);
                  })
            : n(t);
        })("undefined" != typeof window ? window : this, function (i, r) {
          "use strict";
          var o = [],
            a = Object.getPrototypeOf,
            s = o.slice,
            l = o.flat
              ? function (e) {
                  return o.flat.call(e);
                }
              : function (e) {
                  return o.concat.apply([], e);
                },
            c = o.push,
            u = o.indexOf,
            d = {},
            p = d.toString,
            f = d.hasOwnProperty,
            h = f.toString,
            m = h.call(Object),
            g = {},
            v = function (e) {
              return (
                "function" == typeof e &&
                "number" != typeof e.nodeType &&
                "function" != typeof e.item
              );
            },
            y = function (e) {
              return null != e && e === e.window;
            },
            b = i.document,
            w = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function x(e, t, n) {
            var i,
              r,
              o = (n = n || b).createElement("script");
            if (((o.text = e), t))
              for (i in w)
                (r = t[i] || (t.getAttribute && t.getAttribute(i))) &&
                  o.setAttribute(i, r);
            n.head.appendChild(o).parentNode.removeChild(o);
          }
          function C(e) {
            return null == e
              ? e + ""
              : "object" == typeof e || "function" == typeof e
              ? d[p.call(e)] || "object"
              : typeof e;
          }
          var T = "3.6.0",
            S = function (e, t) {
              return new S.fn.init(e, t);
            };
          function E(e) {
            var t = !!e && "length" in e && e.length,
              n = C(e);
            return (
              !v(e) &&
              !y(e) &&
              ("array" === n ||
                0 === t ||
                ("number" == typeof t && t > 0 && t - 1 in e))
            );
          }
          (S.fn = S.prototype =
            {
              jquery: T,
              constructor: S,
              length: 0,
              toArray: function () {
                return s.call(this);
              },
              get: function (e) {
                return null == e
                  ? s.call(this)
                  : e < 0
                  ? this[e + this.length]
                  : this[e];
              },
              pushStack: function (e) {
                var t = S.merge(this.constructor(), e);
                return (t.prevObject = this), t;
              },
              each: function (e) {
                return S.each(this, e);
              },
              map: function (e) {
                return this.pushStack(
                  S.map(this, function (t, n) {
                    return e.call(t, n, t);
                  })
                );
              },
              slice: function () {
                return this.pushStack(s.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  S.grep(this, function (e, t) {
                    return (t + 1) % 2;
                  })
                );
              },
              odd: function () {
                return this.pushStack(
                  S.grep(this, function (e, t) {
                    return t % 2;
                  })
                );
              },
              eq: function (e) {
                var t = this.length,
                  n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: c,
              sort: o.sort,
              splice: o.splice,
            }),
            (S.extend = S.fn.extend =
              function () {
                var e,
                  t,
                  n,
                  i,
                  r,
                  o,
                  a = arguments[0] || {},
                  s = 1,
                  l = arguments.length,
                  c = !1;
                for (
                  "boolean" == typeof a &&
                    ((c = a), (a = arguments[s] || {}), s++),
                    "object" == typeof a || v(a) || (a = {}),
                    s === l && ((a = this), s--);
                  s < l;
                  s++
                )
                  if (null != (e = arguments[s]))
                    for (t in e)
                      (i = e[t]),
                        "__proto__" !== t &&
                          a !== i &&
                          (c &&
                          i &&
                          (S.isPlainObject(i) || (r = Array.isArray(i)))
                            ? ((n = a[t]),
                              (o =
                                r && !Array.isArray(n)
                                  ? []
                                  : r || S.isPlainObject(n)
                                  ? n
                                  : {}),
                              (r = !1),
                              (a[t] = S.extend(c, o, i)))
                            : void 0 !== i && (a[t] = i));
                return a;
              }),
            S.extend({
              expando: "jQuery" + (T + Math.random()).replace(/\D/g, ""),
              isReady: !0,
              error: function (e) {
                throw new Error(e);
              },
              noop: function () {},
              isPlainObject: function (e) {
                var t, n;
                return !(
                  !e ||
                  "[object Object]" !== p.call(e) ||
                  ((t = a(e)) &&
                    ("function" !=
                      typeof (n = f.call(t, "constructor") && t.constructor) ||
                      h.call(n) !== m))
                );
              },
              isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
              },
              globalEval: function (e, t, n) {
                x(e, { nonce: t && t.nonce }, n);
              },
              each: function (e, t) {
                var n,
                  i = 0;
                if (E(e))
                  for (
                    n = e.length;
                    i < n && !1 !== t.call(e[i], i, e[i]);
                    i++
                  );
                else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                return e;
              },
              makeArray: function (e, t) {
                var n = t || [];
                return (
                  null != e &&
                    (E(Object(e))
                      ? S.merge(n, "string" == typeof e ? [e] : e)
                      : c.call(n, e)),
                  n
                );
              },
              inArray: function (e, t, n) {
                return null == t ? -1 : u.call(t, e, n);
              },
              merge: function (e, t) {
                for (var n = +t.length, i = 0, r = e.length; i < n; i++)
                  e[r++] = t[i];
                return (e.length = r), e;
              },
              grep: function (e, t, n) {
                for (var i = [], r = 0, o = e.length, a = !n; r < o; r++)
                  !t(e[r], r) !== a && i.push(e[r]);
                return i;
              },
              map: function (e, t, n) {
                var i,
                  r,
                  o = 0,
                  a = [];
                if (E(e))
                  for (i = e.length; o < i; o++)
                    null != (r = t(e[o], o, n)) && a.push(r);
                else for (o in e) null != (r = t(e[o], o, n)) && a.push(r);
                return l(a);
              },
              guid: 1,
              support: g,
            }),
            "function" == typeof Symbol &&
              (S.fn[Symbol.iterator] = o[Symbol.iterator]),
            S.each(
              "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                " "
              ),
              function (e, t) {
                d["[object " + t + "]"] = t.toLowerCase();
              }
            );
          var k = (function (e) {
            var t,
              n,
              i,
              r,
              o,
              a,
              s,
              l,
              c,
              u,
              d,
              p,
              f,
              h,
              m,
              g,
              v,
              y,
              b,
              w = "sizzle" + 1 * new Date(),
              x = e.document,
              C = 0,
              T = 0,
              S = le(),
              E = le(),
              k = le(),
              L = le(),
              P = function (e, t) {
                return e === t && (d = !0), 0;
              },
              O = {}.hasOwnProperty,
              M = [],
              A = M.pop,
              I = M.push,
              j = M.push,
              _ = M.slice,
              D = function (e, t) {
                for (var n = 0, i = e.length; n < i; n++)
                  if (e[n] === t) return n;
                return -1;
              },
              N =
                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              q = "[\\x20\\t\\r\\n\\f]",
              $ =
                "(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              z =
                "\\[[\\x20\\t\\r\\n\\f]*(" +
                $ +
                ")(?:" +
                q +
                "*([*^$|!~]?=)" +
                q +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                $ +
                "))|)" +
                q +
                "*\\]",
              H =
                ":(" +
                $ +
                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                z +
                ")*)|.*)\\)|)",
              B = new RegExp(q + "+", "g"),
              F = new RegExp(
                "^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$",
                "g"
              ),
              R = new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"),
              W = new RegExp(
                "^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"
              ),
              G = new RegExp(q + "|>"),
              V = new RegExp(H),
              X = new RegExp("^" + $ + "$"),
              Y = {
                ID: new RegExp("^#(" + $ + ")"),
                CLASS: new RegExp("^\\.(" + $ + ")"),
                TAG: new RegExp("^(" + $ + "|[*])"),
                ATTR: new RegExp("^" + z),
                PSEUDO: new RegExp("^" + H),
                CHILD: new RegExp(
                  "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)",
                  "i"
                ),
                bool: new RegExp("^(?:" + N + ")$", "i"),
                needsContext: new RegExp(
                  "^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)",
                  "i"
                ),
              },
              U = /HTML$/i,
              K = /^(?:input|select|textarea|button)$/i,
              J = /^h\d$/i,
              Q = /^[^{]+\{\s*\[native \w/,
              Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              ee = /[+~]/,
              te = new RegExp(
                "\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])",
                "g"
              ),
              ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return (
                  t ||
                  (n < 0
                    ? String.fromCharCode(n + 65536)
                    : String.fromCharCode(
                        (n >> 10) | 55296,
                        (1023 & n) | 56320
                      ))
                );
              },
              ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              re = function (e, t) {
                return t
                  ? "\0" === e
                    ? "�"
                    : e.slice(0, -1) +
                      "\\" +
                      e.charCodeAt(e.length - 1).toString(16) +
                      " "
                  : "\\" + e;
              },
              oe = function () {
                p();
              },
              ae = we(
                function (e) {
                  return (
                    !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                  );
                },
                { dir: "parentNode", next: "legend" }
              );
            try {
              j.apply((M = _.call(x.childNodes)), x.childNodes),
                M[x.childNodes.length].nodeType;
            } catch (e) {
              j = {
                apply: M.length
                  ? function (e, t) {
                      I.apply(e, _.call(t));
                    }
                  : function (e, t) {
                      for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                      e.length = n - 1;
                    },
              };
            }
            function se(e, t, i, r) {
              var o,
                s,
                c,
                u,
                d,
                h,
                v,
                y = t && t.ownerDocument,
                x = t ? t.nodeType : 9;
              if (
                ((i = i || []),
                "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))
              )
                return i;
              if (!r && (p(t), (t = t || f), m)) {
                if (11 !== x && (d = Z.exec(e)))
                  if ((o = d[1])) {
                    if (9 === x) {
                      if (!(c = t.getElementById(o))) return i;
                      if (c.id === o) return i.push(c), i;
                    } else if (
                      y &&
                      (c = y.getElementById(o)) &&
                      b(t, c) &&
                      c.id === o
                    )
                      return i.push(c), i;
                  } else {
                    if (d[2]) return j.apply(i, t.getElementsByTagName(e)), i;
                    if (
                      (o = d[3]) &&
                      n.getElementsByClassName &&
                      t.getElementsByClassName
                    )
                      return j.apply(i, t.getElementsByClassName(o)), i;
                  }
                if (
                  n.qsa &&
                  !L[e + " "] &&
                  (!g || !g.test(e)) &&
                  (1 !== x || "object" !== t.nodeName.toLowerCase())
                ) {
                  if (((v = e), (y = t), 1 === x && (G.test(e) || W.test(e)))) {
                    for (
                      ((y = (ee.test(e) && ve(t.parentNode)) || t) === t &&
                        n.scope) ||
                        ((u = t.getAttribute("id"))
                          ? (u = u.replace(ie, re))
                          : t.setAttribute("id", (u = w))),
                        s = (h = a(e)).length;
                      s--;

                    )
                      h[s] = (u ? "#" + u : ":scope") + " " + be(h[s]);
                    v = h.join(",");
                  }
                  try {
                    return j.apply(i, y.querySelectorAll(v)), i;
                  } catch (t) {
                    L(e, !0);
                  } finally {
                    u === w && t.removeAttribute("id");
                  }
                }
              }
              return l(e.replace(F, "$1"), t, i, r);
            }
            function le() {
              var e = [];
              return function t(n, r) {
                return (
                  e.push(n + " ") > i.cacheLength && delete t[e.shift()],
                  (t[n + " "] = r)
                );
              };
            }
            function ce(e) {
              return (e[w] = !0), e;
            }
            function ue(e) {
              var t = f.createElement("fieldset");
              try {
                return !!e(t);
              } catch (e) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
              }
            }
            function de(e, t) {
              for (var n = e.split("|"), r = n.length; r--; )
                i.attrHandle[n[r]] = t;
            }
            function pe(e, t) {
              var n = t && e,
                i =
                  n &&
                  1 === e.nodeType &&
                  1 === t.nodeType &&
                  e.sourceIndex - t.sourceIndex;
              if (i) return i;
              if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
              return e ? 1 : -1;
            }
            function fe(e) {
              return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
              };
            }
            function he(e) {
              return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
              };
            }
            function me(e) {
              return function (t) {
                return "form" in t
                  ? t.parentNode && !1 === t.disabled
                    ? "label" in t
                      ? "label" in t.parentNode
                        ? t.parentNode.disabled === e
                        : t.disabled === e
                      : t.isDisabled === e ||
                        (t.isDisabled !== !e && ae(t) === e)
                    : t.disabled === e
                  : "label" in t && t.disabled === e;
              };
            }
            function ge(e) {
              return ce(function (t) {
                return (
                  (t = +t),
                  ce(function (n, i) {
                    for (var r, o = e([], n.length, t), a = o.length; a--; )
                      n[(r = o[a])] && (n[r] = !(i[r] = n[r]));
                  })
                );
              });
            }
            function ve(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            for (t in ((n = se.support = {}),
            (o = se.isXML =
              function (e) {
                var t = e && e.namespaceURI,
                  n = e && (e.ownerDocument || e).documentElement;
                return !U.test(t || (n && n.nodeName) || "HTML");
              }),
            (p = se.setDocument =
              function (e) {
                var t,
                  r,
                  a = e ? e.ownerDocument || e : x;
                return a != f && 9 === a.nodeType && a.documentElement
                  ? ((h = (f = a).documentElement),
                    (m = !o(f)),
                    x != f &&
                      (r = f.defaultView) &&
                      r.top !== r &&
                      (r.addEventListener
                        ? r.addEventListener("unload", oe, !1)
                        : r.attachEvent && r.attachEvent("onunload", oe)),
                    (n.scope = ue(function (e) {
                      return (
                        h.appendChild(e).appendChild(f.createElement("div")),
                        void 0 !== e.querySelectorAll &&
                          !e.querySelectorAll(":scope fieldset div").length
                      );
                    })),
                    (n.attributes = ue(function (e) {
                      return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (n.getElementsByTagName = ue(function (e) {
                      return (
                        e.appendChild(f.createComment("")),
                        !e.getElementsByTagName("*").length
                      );
                    })),
                    (n.getElementsByClassName = Q.test(
                      f.getElementsByClassName
                    )),
                    (n.getById = ue(function (e) {
                      return (
                        (h.appendChild(e).id = w),
                        !f.getElementsByName || !f.getElementsByName(w).length
                      );
                    })),
                    n.getById
                      ? ((i.filter.ID = function (e) {
                          var t = e.replace(te, ne);
                          return function (e) {
                            return e.getAttribute("id") === t;
                          };
                        }),
                        (i.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && m) {
                            var n = t.getElementById(e);
                            return n ? [n] : [];
                          }
                        }))
                      : ((i.filter.ID = function (e) {
                          var t = e.replace(te, ne);
                          return function (e) {
                            var n =
                              void 0 !== e.getAttributeNode &&
                              e.getAttributeNode("id");
                            return n && n.value === t;
                          };
                        }),
                        (i.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && m) {
                            var n,
                              i,
                              r,
                              o = t.getElementById(e);
                            if (o) {
                              if (
                                (n = o.getAttributeNode("id")) &&
                                n.value === e
                              )
                                return [o];
                              for (
                                r = t.getElementsByName(e), i = 0;
                                (o = r[i++]);

                              )
                                if (
                                  (n = o.getAttributeNode("id")) &&
                                  n.value === e
                                )
                                  return [o];
                            }
                            return [];
                          }
                        })),
                    (i.find.TAG = n.getElementsByTagName
                      ? function (e, t) {
                          return void 0 !== t.getElementsByTagName
                            ? t.getElementsByTagName(e)
                            : n.qsa
                            ? t.querySelectorAll(e)
                            : void 0;
                        }
                      : function (e, t) {
                          var n,
                            i = [],
                            r = 0,
                            o = t.getElementsByTagName(e);
                          if ("*" === e) {
                            for (; (n = o[r++]); )
                              1 === n.nodeType && i.push(n);
                            return i;
                          }
                          return o;
                        }),
                    (i.find.CLASS =
                      n.getElementsByClassName &&
                      function (e, t) {
                        if (void 0 !== t.getElementsByClassName && m)
                          return t.getElementsByClassName(e);
                      }),
                    (v = []),
                    (g = []),
                    (n.qsa = Q.test(f.querySelectorAll)) &&
                      (ue(function (e) {
                        var t;
                        (h.appendChild(e).innerHTML =
                          "<a id='" +
                          w +
                          "'></a><select id='" +
                          w +
                          "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                          e.querySelectorAll("[msallowcapture^='']").length &&
                            g.push("[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),
                          e.querySelectorAll("[selected]").length ||
                            g.push(
                              "\\[[\\x20\\t\\r\\n\\f]*(?:value|" + N + ")"
                            ),
                          e.querySelectorAll("[id~=" + w + "-]").length ||
                            g.push("~="),
                          (t = f.createElement("input")).setAttribute(
                            "name",
                            ""
                          ),
                          e.appendChild(t),
                          e.querySelectorAll("[name='']").length ||
                            g.push(
                              "\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"
                            ),
                          e.querySelectorAll(":checked").length ||
                            g.push(":checked"),
                          e.querySelectorAll("a#" + w + "+*").length ||
                            g.push(".#.+[+~]"),
                          e.querySelectorAll("\\\f"),
                          g.push("[\\r\\n\\f]");
                      }),
                      ue(function (e) {
                        e.innerHTML =
                          "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var t = f.createElement("input");
                        t.setAttribute("type", "hidden"),
                          e.appendChild(t).setAttribute("name", "D"),
                          e.querySelectorAll("[name=d]").length &&
                            g.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="),
                          2 !== e.querySelectorAll(":enabled").length &&
                            g.push(":enabled", ":disabled"),
                          (h.appendChild(e).disabled = !0),
                          2 !== e.querySelectorAll(":disabled").length &&
                            g.push(":enabled", ":disabled"),
                          e.querySelectorAll("*,:x"),
                          g.push(",.*:");
                      })),
                    (n.matchesSelector = Q.test(
                      (y =
                        h.matches ||
                        h.webkitMatchesSelector ||
                        h.mozMatchesSelector ||
                        h.oMatchesSelector ||
                        h.msMatchesSelector)
                    )) &&
                      ue(function (e) {
                        (n.disconnectedMatch = y.call(e, "*")),
                          y.call(e, "[s!='']:x"),
                          v.push("!=", H);
                      }),
                    (g = g.length && new RegExp(g.join("|"))),
                    (v = v.length && new RegExp(v.join("|"))),
                    (t = Q.test(h.compareDocumentPosition)),
                    (b =
                      t || Q.test(h.contains)
                        ? function (e, t) {
                            var n = 9 === e.nodeType ? e.documentElement : e,
                              i = t && t.parentNode;
                            return (
                              e === i ||
                              !(
                                !i ||
                                1 !== i.nodeType ||
                                !(n.contains
                                  ? n.contains(i)
                                  : e.compareDocumentPosition &&
                                    16 & e.compareDocumentPosition(i))
                              )
                            );
                          }
                        : function (e, t) {
                            if (t)
                              for (; (t = t.parentNode); )
                                if (t === e) return !0;
                            return !1;
                          }),
                    (P = t
                      ? function (e, t) {
                          if (e === t) return (d = !0), 0;
                          var i =
                            !e.compareDocumentPosition -
                            !t.compareDocumentPosition;
                          return (
                            i ||
                            (1 &
                              (i =
                                (e.ownerDocument || e) == (t.ownerDocument || t)
                                  ? e.compareDocumentPosition(t)
                                  : 1) ||
                            (!n.sortDetached &&
                              t.compareDocumentPosition(e) === i)
                              ? e == f || (e.ownerDocument == x && b(x, e))
                                ? -1
                                : t == f || (t.ownerDocument == x && b(x, t))
                                ? 1
                                : u
                                ? D(u, e) - D(u, t)
                                : 0
                              : 4 & i
                              ? -1
                              : 1)
                          );
                        }
                      : function (e, t) {
                          if (e === t) return (d = !0), 0;
                          var n,
                            i = 0,
                            r = e.parentNode,
                            o = t.parentNode,
                            a = [e],
                            s = [t];
                          if (!r || !o)
                            return e == f
                              ? -1
                              : t == f
                              ? 1
                              : r
                              ? -1
                              : o
                              ? 1
                              : u
                              ? D(u, e) - D(u, t)
                              : 0;
                          if (r === o) return pe(e, t);
                          for (n = e; (n = n.parentNode); ) a.unshift(n);
                          for (n = t; (n = n.parentNode); ) s.unshift(n);
                          for (; a[i] === s[i]; ) i++;
                          return i
                            ? pe(a[i], s[i])
                            : a[i] == x
                            ? -1
                            : s[i] == x
                            ? 1
                            : 0;
                        }),
                    f)
                  : f;
              }),
            (se.matches = function (e, t) {
              return se(e, null, null, t);
            }),
            (se.matchesSelector = function (e, t) {
              if (
                (p(e),
                n.matchesSelector &&
                  m &&
                  !L[t + " "] &&
                  (!v || !v.test(t)) &&
                  (!g || !g.test(t)))
              )
                try {
                  var i = y.call(e, t);
                  if (
                    i ||
                    n.disconnectedMatch ||
                    (e.document && 11 !== e.document.nodeType)
                  )
                    return i;
                } catch (e) {
                  L(t, !0);
                }
              return se(t, f, null, [e]).length > 0;
            }),
            (se.contains = function (e, t) {
              return (e.ownerDocument || e) != f && p(e), b(e, t);
            }),
            (se.attr = function (e, t) {
              (e.ownerDocument || e) != f && p(e);
              var r = i.attrHandle[t.toLowerCase()],
                o =
                  r && O.call(i.attrHandle, t.toLowerCase())
                    ? r(e, t, !m)
                    : void 0;
              return void 0 !== o
                ? o
                : n.attributes || !m
                ? e.getAttribute(t)
                : (o = e.getAttributeNode(t)) && o.specified
                ? o.value
                : null;
            }),
            (se.escape = function (e) {
              return (e + "").replace(ie, re);
            }),
            (se.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (se.uniqueSort = function (e) {
              var t,
                i = [],
                r = 0,
                o = 0;
              if (
                ((d = !n.detectDuplicates),
                (u = !n.sortStable && e.slice(0)),
                e.sort(P),
                d)
              ) {
                for (; (t = e[o++]); ) t === e[o] && (r = i.push(o));
                for (; r--; ) e.splice(i[r], 1);
              }
              return (u = null), e;
            }),
            (r = se.getText =
              function (e) {
                var t,
                  n = "",
                  i = 0,
                  o = e.nodeType;
                if (o) {
                  if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += r(e);
                  } else if (3 === o || 4 === o) return e.nodeValue;
                } else for (; (t = e[i++]); ) n += r(t);
                return n;
              }),
            (i = se.selectors =
              {
                cacheLength: 50,
                createPseudo: ce,
                match: Y,
                attrHandle: {},
                find: {},
                relative: {
                  ">": { dir: "parentNode", first: !0 },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: !0 },
                  "~": { dir: "previousSibling" },
                },
                preFilter: {
                  ATTR: function (e) {
                    return (
                      (e[1] = e[1].replace(te, ne)),
                      (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                      "~=" === e[2] && (e[3] = " " + e[3] + " "),
                      e.slice(0, 4)
                    );
                  },
                  CHILD: function (e) {
                    return (
                      (e[1] = e[1].toLowerCase()),
                      "nth" === e[1].slice(0, 3)
                        ? (e[3] || se.error(e[0]),
                          (e[4] = +(e[4]
                            ? e[5] + (e[6] || 1)
                            : 2 * ("even" === e[3] || "odd" === e[3]))),
                          (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                        : e[3] && se.error(e[0]),
                      e
                    );
                  },
                  PSEUDO: function (e) {
                    var t,
                      n = !e[6] && e[2];
                    return Y.CHILD.test(e[0])
                      ? null
                      : (e[3]
                          ? (e[2] = e[4] || e[5] || "")
                          : n &&
                            V.test(n) &&
                            (t = a(n, !0)) &&
                            (t = n.indexOf(")", n.length - t) - n.length) &&
                            ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                        e.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                      ? function () {
                          return !0;
                        }
                      : function (e) {
                          return e.nodeName && e.nodeName.toLowerCase() === t;
                        };
                  },
                  CLASS: function (e) {
                    var t = S[e + " "];
                    return (
                      t ||
                      ((t = new RegExp(
                        "(^|[\\x20\\t\\r\\n\\f])" + e + "(" + q + "|$)"
                      )) &&
                        S(e, function (e) {
                          return t.test(
                            ("string" == typeof e.className && e.className) ||
                              (void 0 !== e.getAttribute &&
                                e.getAttribute("class")) ||
                              ""
                          );
                        }))
                    );
                  },
                  ATTR: function (e, t, n) {
                    return function (i) {
                      var r = se.attr(i, e);
                      return null == r
                        ? "!=" === t
                        : !t ||
                            ((r += ""),
                            "=" === t
                              ? r === n
                              : "!=" === t
                              ? r !== n
                              : "^=" === t
                              ? n && 0 === r.indexOf(n)
                              : "*=" === t
                              ? n && r.indexOf(n) > -1
                              : "$=" === t
                              ? n && r.slice(-n.length) === n
                              : "~=" === t
                              ? (" " + r.replace(B, " ") + " ").indexOf(n) > -1
                              : "|=" === t &&
                                (r === n ||
                                  r.slice(0, n.length + 1) === n + "-"));
                    };
                  },
                  CHILD: function (e, t, n, i, r) {
                    var o = "nth" !== e.slice(0, 3),
                      a = "last" !== e.slice(-4),
                      s = "of-type" === t;
                    return 1 === i && 0 === r
                      ? function (e) {
                          return !!e.parentNode;
                        }
                      : function (t, n, l) {
                          var c,
                            u,
                            d,
                            p,
                            f,
                            h,
                            m = o !== a ? "nextSibling" : "previousSibling",
                            g = t.parentNode,
                            v = s && t.nodeName.toLowerCase(),
                            y = !l && !s,
                            b = !1;
                          if (g) {
                            if (o) {
                              for (; m; ) {
                                for (p = t; (p = p[m]); )
                                  if (
                                    s
                                      ? p.nodeName.toLowerCase() === v
                                      : 1 === p.nodeType
                                  )
                                    return !1;
                                h = m = "only" === e && !h && "nextSibling";
                              }
                              return !0;
                            }
                            if (
                              ((h = [a ? g.firstChild : g.lastChild]), a && y)
                            ) {
                              for (
                                b =
                                  (f =
                                    (c =
                                      (u =
                                        (d = (p = g)[w] || (p[w] = {}))[
                                          p.uniqueID
                                        ] || (d[p.uniqueID] = {}))[e] ||
                                      [])[0] === C && c[1]) && c[2],
                                  p = f && g.childNodes[f];
                                (p =
                                  (++f && p && p[m]) || (b = f = 0) || h.pop());

                              )
                                if (1 === p.nodeType && ++b && p === t) {
                                  u[e] = [C, f, b];
                                  break;
                                }
                            } else if (
                              (y &&
                                (b = f =
                                  (c =
                                    (u =
                                      (d = (p = t)[w] || (p[w] = {}))[
                                        p.uniqueID
                                      ] || (d[p.uniqueID] = {}))[e] ||
                                    [])[0] === C && c[1]),
                              !1 === b)
                            )
                              for (
                                ;
                                (p =
                                  (++f && p && p[m]) ||
                                  (b = f = 0) ||
                                  h.pop()) &&
                                ((s
                                  ? p.nodeName.toLowerCase() !== v
                                  : 1 !== p.nodeType) ||
                                  !++b ||
                                  (y &&
                                    ((u =
                                      (d = p[w] || (p[w] = {}))[p.uniqueID] ||
                                      (d[p.uniqueID] = {}))[e] = [C, b]),
                                  p !== t));

                              );
                            return (b -= r) === i || (b % i == 0 && b / i >= 0);
                          }
                        };
                  },
                  PSEUDO: function (e, t) {
                    var n,
                      r =
                        i.pseudos[e] ||
                        i.setFilters[e.toLowerCase()] ||
                        se.error("unsupported pseudo: " + e);
                    return r[w]
                      ? r(t)
                      : r.length > 1
                      ? ((n = [e, e, "", t]),
                        i.setFilters.hasOwnProperty(e.toLowerCase())
                          ? ce(function (e, n) {
                              for (var i, o = r(e, t), a = o.length; a--; )
                                e[(i = D(e, o[a]))] = !(n[i] = o[a]);
                            })
                          : function (e) {
                              return r(e, 0, n);
                            })
                      : r;
                  },
                },
                pseudos: {
                  not: ce(function (e) {
                    var t = [],
                      n = [],
                      i = s(e.replace(F, "$1"));
                    return i[w]
                      ? ce(function (e, t, n, r) {
                          for (
                            var o, a = i(e, null, r, []), s = e.length;
                            s--;

                          )
                            (o = a[s]) && (e[s] = !(t[s] = o));
                        })
                      : function (e, r, o) {
                          return (
                            (t[0] = e),
                            i(t, null, o, n),
                            (t[0] = null),
                            !n.pop()
                          );
                        };
                  }),
                  has: ce(function (e) {
                    return function (t) {
                      return se(e, t).length > 0;
                    };
                  }),
                  contains: ce(function (e) {
                    return (
                      (e = e.replace(te, ne)),
                      function (t) {
                        return (t.textContent || r(t)).indexOf(e) > -1;
                      }
                    );
                  }),
                  lang: ce(function (e) {
                    return (
                      X.test(e || "") || se.error("unsupported lang: " + e),
                      (e = e.replace(te, ne).toLowerCase()),
                      function (t) {
                        var n;
                        do {
                          if (
                            (n = m
                              ? t.lang
                              : t.getAttribute("xml:lang") ||
                                t.getAttribute("lang"))
                          )
                            return (
                              (n = n.toLowerCase()) === e ||
                              0 === n.indexOf(e + "-")
                            );
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                  },
                  root: function (e) {
                    return e === h;
                  },
                  focus: function (e) {
                    return (
                      e === f.activeElement &&
                      (!f.hasFocus || f.hasFocus()) &&
                      !!(e.type || e.href || ~e.tabIndex)
                    );
                  },
                  enabled: me(!1),
                  disabled: me(!0),
                  checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return (
                      ("input" === t && !!e.checked) ||
                      ("option" === t && !!e.selected)
                    );
                  },
                  selected: function (e) {
                    return (
                      e.parentNode && e.parentNode.selectedIndex,
                      !0 === e.selected
                    );
                  },
                  empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                      if (e.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (e) {
                    return !i.pseudos.empty(e);
                  },
                  header: function (e) {
                    return J.test(e.nodeName);
                  },
                  input: function (e) {
                    return K.test(e.nodeName);
                  },
                  button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return (
                      ("input" === t && "button" === e.type) || "button" === t
                    );
                  },
                  text: function (e) {
                    var t;
                    return (
                      "input" === e.nodeName.toLowerCase() &&
                      "text" === e.type &&
                      (null == (t = e.getAttribute("type")) ||
                        "text" === t.toLowerCase())
                    );
                  },
                  first: ge(function () {
                    return [0];
                  }),
                  last: ge(function (e, t) {
                    return [t - 1];
                  }),
                  eq: ge(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                  }),
                  even: ge(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  odd: ge(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  lt: ge(function (e, t, n) {
                    for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0; )
                      e.push(i);
                    return e;
                  }),
                  gt: ge(function (e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                    return e;
                  }),
                },
              }),
            (i.pseudos.nth = i.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              i.pseudos[t] = fe(t);
            for (t in { submit: !0, reset: !0 }) i.pseudos[t] = he(t);
            function ye() {}
            function be(e) {
              for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
              return i;
            }
            function we(e, t, n) {
              var i = t.dir,
                r = t.next,
                o = r || i,
                a = n && "parentNode" === o,
                s = T++;
              return t.first
                ? function (t, n, r) {
                    for (; (t = t[i]); )
                      if (1 === t.nodeType || a) return e(t, n, r);
                    return !1;
                  }
                : function (t, n, l) {
                    var c,
                      u,
                      d,
                      p = [C, s];
                    if (l) {
                      for (; (t = t[i]); )
                        if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                    } else
                      for (; (t = t[i]); )
                        if (1 === t.nodeType || a)
                          if (
                            ((u =
                              (d = t[w] || (t[w] = {}))[t.uniqueID] ||
                              (d[t.uniqueID] = {})),
                            r && r === t.nodeName.toLowerCase())
                          )
                            t = t[i] || t;
                          else {
                            if ((c = u[o]) && c[0] === C && c[1] === s)
                              return (p[2] = c[2]);
                            if (((u[o] = p), (p[2] = e(t, n, l)))) return !0;
                          }
                    return !1;
                  };
            }
            function xe(e) {
              return e.length > 1
                ? function (t, n, i) {
                    for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
                    return !0;
                  }
                : e[0];
            }
            function Ce(e, t, n, i, r) {
              for (
                var o, a = [], s = 0, l = e.length, c = null != t;
                s < l;
                s++
              )
                (o = e[s]) &&
                  ((n && !n(o, i, r)) || (a.push(o), c && t.push(s)));
              return a;
            }
            function Te(e, t, n, i, r, o) {
              return (
                i && !i[w] && (i = Te(i)),
                r && !r[w] && (r = Te(r, o)),
                ce(function (o, a, s, l) {
                  var c,
                    u,
                    d,
                    p = [],
                    f = [],
                    h = a.length,
                    m =
                      o ||
                      (function (e, t, n) {
                        for (var i = 0, r = t.length; i < r; i++)
                          se(e, t[i], n);
                        return n;
                      })(t || "*", s.nodeType ? [s] : s, []),
                    g = !e || (!o && t) ? m : Ce(m, p, e, s, l),
                    v = n ? (r || (o ? e : h || i) ? [] : a) : g;
                  if ((n && n(g, v, s, l), i))
                    for (c = Ce(v, f), i(c, [], s, l), u = c.length; u--; )
                      (d = c[u]) && (v[f[u]] = !(g[f[u]] = d));
                  if (o) {
                    if (r || e) {
                      if (r) {
                        for (c = [], u = v.length; u--; )
                          (d = v[u]) && c.push((g[u] = d));
                        r(null, (v = []), c, l);
                      }
                      for (u = v.length; u--; )
                        (d = v[u]) &&
                          (c = r ? D(o, d) : p[u]) > -1 &&
                          (o[c] = !(a[c] = d));
                    }
                  } else (v = Ce(v === a ? v.splice(h, v.length) : v)), r ? r(null, a, v, l) : j.apply(a, v);
                })
              );
            }
            function Se(e) {
              for (
                var t,
                  n,
                  r,
                  o = e.length,
                  a = i.relative[e[0].type],
                  s = a || i.relative[" "],
                  l = a ? 1 : 0,
                  u = we(
                    function (e) {
                      return e === t;
                    },
                    s,
                    !0
                  ),
                  d = we(
                    function (e) {
                      return D(t, e) > -1;
                    },
                    s,
                    !0
                  ),
                  p = [
                    function (e, n, i) {
                      var r =
                        (!a && (i || n !== c)) ||
                        ((t = n).nodeType ? u(e, n, i) : d(e, n, i));
                      return (t = null), r;
                    },
                  ];
                l < o;
                l++
              )
                if ((n = i.relative[e[l].type])) p = [we(xe(p), n)];
                else {
                  if ((n = i.filter[e[l].type].apply(null, e[l].matches))[w]) {
                    for (r = ++l; r < o && !i.relative[e[r].type]; r++);
                    return Te(
                      l > 1 && xe(p),
                      l > 1 &&
                        be(
                          e
                            .slice(0, l - 1)
                            .concat({ value: " " === e[l - 2].type ? "*" : "" })
                        ).replace(F, "$1"),
                      n,
                      l < r && Se(e.slice(l, r)),
                      r < o && Se((e = e.slice(r))),
                      r < o && be(e)
                    );
                  }
                  p.push(n);
                }
              return xe(p);
            }
            return (
              (ye.prototype = i.filters = i.pseudos),
              (i.setFilters = new ye()),
              (a = se.tokenize =
                function (e, t) {
                  var n,
                    r,
                    o,
                    a,
                    s,
                    l,
                    c,
                    u = E[e + " "];
                  if (u) return t ? 0 : u.slice(0);
                  for (s = e, l = [], c = i.preFilter; s; ) {
                    for (a in ((n && !(r = R.exec(s))) ||
                      (r && (s = s.slice(r[0].length) || s), l.push((o = []))),
                    (n = !1),
                    (r = W.exec(s)) &&
                      ((n = r.shift()),
                      o.push({ value: n, type: r[0].replace(F, " ") }),
                      (s = s.slice(n.length))),
                    i.filter))
                      !(r = Y[a].exec(s)) ||
                        (c[a] && !(r = c[a](r))) ||
                        ((n = r.shift()),
                        o.push({ value: n, type: a, matches: r }),
                        (s = s.slice(n.length)));
                    if (!n) break;
                  }
                  return t ? s.length : s ? se.error(e) : E(e, l).slice(0);
                }),
              (s = se.compile =
                function (e, t) {
                  var n,
                    r = [],
                    o = [],
                    s = k[e + " "];
                  if (!s) {
                    for (t || (t = a(e)), n = t.length; n--; )
                      (s = Se(t[n]))[w] ? r.push(s) : o.push(s);
                    (s = k(
                      e,
                      (function (e, t) {
                        var n = t.length > 0,
                          r = e.length > 0,
                          o = function (o, a, s, l, u) {
                            var d,
                              h,
                              g,
                              v = 0,
                              y = "0",
                              b = o && [],
                              w = [],
                              x = c,
                              T = o || (r && i.find.TAG("*", u)),
                              S = (C += null == x ? 1 : Math.random() || 0.1),
                              E = T.length;
                            for (
                              u && (c = a == f || a || u);
                              y !== E && null != (d = T[y]);
                              y++
                            ) {
                              if (r && d) {
                                for (
                                  h = 0,
                                    a ||
                                      d.ownerDocument == f ||
                                      (p(d), (s = !m));
                                  (g = e[h++]);

                                )
                                  if (g(d, a || f, s)) {
                                    l.push(d);
                                    break;
                                  }
                                u && (C = S);
                              }
                              n && ((d = !g && d) && v--, o && b.push(d));
                            }
                            if (((v += y), n && y !== v)) {
                              for (h = 0; (g = t[h++]); ) g(b, w, a, s);
                              if (o) {
                                if (v > 0)
                                  for (; y--; )
                                    b[y] || w[y] || (w[y] = A.call(l));
                                w = Ce(w);
                              }
                              j.apply(l, w),
                                u &&
                                  !o &&
                                  w.length > 0 &&
                                  v + t.length > 1 &&
                                  se.uniqueSort(l);
                            }
                            return u && ((C = S), (c = x)), b;
                          };
                        return n ? ce(o) : o;
                      })(o, r)
                    )),
                      (s.selector = e);
                  }
                  return s;
                }),
              (l = se.select =
                function (e, t, n, r) {
                  var o,
                    l,
                    c,
                    u,
                    d,
                    p = "function" == typeof e && e,
                    f = !r && a((e = p.selector || e));
                  if (((n = n || []), 1 === f.length)) {
                    if (
                      (l = f[0] = f[0].slice(0)).length > 2 &&
                      "ID" === (c = l[0]).type &&
                      9 === t.nodeType &&
                      m &&
                      i.relative[l[1].type]
                    ) {
                      if (
                        !(t = (i.find.ID(c.matches[0].replace(te, ne), t) ||
                          [])[0])
                      )
                        return n;
                      p && (t = t.parentNode),
                        (e = e.slice(l.shift().value.length));
                    }
                    for (
                      o = Y.needsContext.test(e) ? 0 : l.length;
                      o-- && ((c = l[o]), !i.relative[(u = c.type)]);

                    )
                      if (
                        (d = i.find[u]) &&
                        (r = d(
                          c.matches[0].replace(te, ne),
                          (ee.test(l[0].type) && ve(t.parentNode)) || t
                        ))
                      ) {
                        if ((l.splice(o, 1), !(e = r.length && be(l))))
                          return j.apply(n, r), n;
                        break;
                      }
                  }
                  return (
                    (p || s(e, f))(
                      r,
                      t,
                      !m,
                      n,
                      !t || (ee.test(e) && ve(t.parentNode)) || t
                    ),
                    n
                  );
                }),
              (n.sortStable = w.split("").sort(P).join("") === w),
              (n.detectDuplicates = !!d),
              p(),
              (n.sortDetached = ue(function (e) {
                return (
                  1 & e.compareDocumentPosition(f.createElement("fieldset"))
                );
              })),
              ue(function (e) {
                return (
                  (e.innerHTML = "<a href='#'></a>"),
                  "#" === e.firstChild.getAttribute("href")
                );
              }) ||
                de("type|href|height|width", function (e, t, n) {
                  if (!n)
                    return e.getAttribute(
                      t,
                      "type" === t.toLowerCase() ? 1 : 2
                    );
                }),
              (n.attributes &&
                ue(function (e) {
                  return (
                    (e.innerHTML = "<input/>"),
                    e.firstChild.setAttribute("value", ""),
                    "" === e.firstChild.getAttribute("value")
                  );
                })) ||
                de("value", function (e, t, n) {
                  if (!n && "input" === e.nodeName.toLowerCase())
                    return e.defaultValue;
                }),
              ue(function (e) {
                return null == e.getAttribute("disabled");
              }) ||
                de(N, function (e, t, n) {
                  var i;
                  if (!n)
                    return !0 === e[t]
                      ? t.toLowerCase()
                      : (i = e.getAttributeNode(t)) && i.specified
                      ? i.value
                      : null;
                }),
              se
            );
          })(i);
          (S.find = k),
            (S.expr = k.selectors),
            (S.expr[":"] = S.expr.pseudos),
            (S.uniqueSort = S.unique = k.uniqueSort),
            (S.text = k.getText),
            (S.isXMLDoc = k.isXML),
            (S.contains = k.contains),
            (S.escapeSelector = k.escape);
          var L = function (e, t, n) {
              for (
                var i = [], r = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;

              )
                if (1 === e.nodeType) {
                  if (r && S(e).is(n)) break;
                  i.push(e);
                }
              return i;
            },
            P = function (e, t) {
              for (var n = []; e; e = e.nextSibling)
                1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            O = S.expr.match.needsContext;
          function M(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          var A =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function I(e, t, n) {
            return v(t)
              ? S.grep(e, function (e, i) {
                  return !!t.call(e, i, e) !== n;
                })
              : t.nodeType
              ? S.grep(e, function (e) {
                  return (e === t) !== n;
                })
              : "string" != typeof t
              ? S.grep(e, function (e) {
                  return u.call(t, e) > -1 !== n;
                })
              : S.filter(t, e, n);
          }
          (S.filter = function (e, t, n) {
            var i = t[0];
            return (
              n && (e = ":not(" + e + ")"),
              1 === t.length && 1 === i.nodeType
                ? S.find.matchesSelector(i, e)
                  ? [i]
                  : []
                : S.find.matches(
                    e,
                    S.grep(t, function (e) {
                      return 1 === e.nodeType;
                    })
                  )
            );
          }),
            S.fn.extend({
              find: function (e) {
                var t,
                  n,
                  i = this.length,
                  r = this;
                if ("string" != typeof e)
                  return this.pushStack(
                    S(e).filter(function () {
                      for (t = 0; t < i; t++)
                        if (S.contains(r[t], this)) return !0;
                    })
                  );
                for (n = this.pushStack([]), t = 0; t < i; t++)
                  S.find(e, r[t], n);
                return i > 1 ? S.uniqueSort(n) : n;
              },
              filter: function (e) {
                return this.pushStack(I(this, e || [], !1));
              },
              not: function (e) {
                return this.pushStack(I(this, e || [], !0));
              },
              is: function (e) {
                return !!I(
                  this,
                  "string" == typeof e && O.test(e) ? S(e) : e || [],
                  !1
                ).length;
              },
            });
          var j,
            _ = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((S.fn.init = function (e, t, n) {
            var i, r;
            if (!e) return this;
            if (((n = n || j), "string" == typeof e)) {
              if (
                !(i =
                  "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                    ? [null, e, null]
                    : _.exec(e)) ||
                (!i[1] && t)
              )
                return !t || t.jquery
                  ? (t || n).find(e)
                  : this.constructor(t).find(e);
              if (i[1]) {
                if (
                  ((t = t instanceof S ? t[0] : t),
                  S.merge(
                    this,
                    S.parseHTML(
                      i[1],
                      t && t.nodeType ? t.ownerDocument || t : b,
                      !0
                    )
                  ),
                  A.test(i[1]) && S.isPlainObject(t))
                )
                  for (i in t) v(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
              }
              return (
                (r = b.getElementById(i[2])) &&
                  ((this[0] = r), (this.length = 1)),
                this
              );
            }
            return e.nodeType
              ? ((this[0] = e), (this.length = 1), this)
              : v(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(S)
              : S.makeArray(e, this);
          }).prototype = S.fn),
            (j = S(b));
          var D = /^(?:parents|prev(?:Until|All))/,
            N = { children: !0, contents: !0, next: !0, prev: !0 };
          function q(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
          }
          S.fn.extend({
            has: function (e) {
              var t = S(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++)
                  if (S.contains(this, t[e])) return !0;
              });
            },
            closest: function (e, t) {
              var n,
                i = 0,
                r = this.length,
                o = [],
                a = "string" != typeof e && S(e);
              if (!O.test(e))
                for (; i < r; i++)
                  for (n = this[i]; n && n !== t; n = n.parentNode)
                    if (
                      n.nodeType < 11 &&
                      (a
                        ? a.index(n) > -1
                        : 1 === n.nodeType && S.find.matchesSelector(n, e))
                    ) {
                      o.push(n);
                      break;
                    }
              return this.pushStack(o.length > 1 ? S.uniqueSort(o) : o);
            },
            index: function (e) {
              return e
                ? "string" == typeof e
                  ? u.call(S(e), this[0])
                  : u.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (e, t) {
              return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
            },
            addBack: function (e) {
              return this.add(
                null == e ? this.prevObject : this.prevObject.filter(e)
              );
            },
          }),
            S.each(
              {
                parent: function (e) {
                  var t = e.parentNode;
                  return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                  return L(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                  return L(e, "parentNode", n);
                },
                next: function (e) {
                  return q(e, "nextSibling");
                },
                prev: function (e) {
                  return q(e, "previousSibling");
                },
                nextAll: function (e) {
                  return L(e, "nextSibling");
                },
                prevAll: function (e) {
                  return L(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                  return L(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                  return L(e, "previousSibling", n);
                },
                siblings: function (e) {
                  return P((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                  return P(e.firstChild);
                },
                contents: function (e) {
                  return null != e.contentDocument && a(e.contentDocument)
                    ? e.contentDocument
                    : (M(e, "template") && (e = e.content || e),
                      S.merge([], e.childNodes));
                },
              },
              function (e, t) {
                S.fn[e] = function (n, i) {
                  var r = S.map(this, t, n);
                  return (
                    "Until" !== e.slice(-5) && (i = n),
                    i && "string" == typeof i && (r = S.filter(i, r)),
                    this.length > 1 &&
                      (N[e] || S.uniqueSort(r), D.test(e) && r.reverse()),
                    this.pushStack(r)
                  );
                };
              }
            );
          var $ = /[^\x20\t\r\n\f]+/g;
          function z(e) {
            return e;
          }
          function H(e) {
            throw e;
          }
          function B(e, t, n, i) {
            var r;
            try {
              e && v((r = e.promise))
                ? r.call(e).done(t).fail(n)
                : e && v((r = e.then))
                ? r.call(e, t, n)
                : t.apply(void 0, [e].slice(i));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          (S.Callbacks = function (e) {
            e =
              "string" == typeof e
                ? (function (e) {
                    var t = {};
                    return (
                      S.each(e.match($) || [], function (e, n) {
                        t[n] = !0;
                      }),
                      t
                    );
                  })(e)
                : S.extend({}, e);
            var t,
              n,
              i,
              r,
              o = [],
              a = [],
              s = -1,
              l = function () {
                for (r = r || e.once, i = t = !0; a.length; s = -1)
                  for (n = a.shift(); ++s < o.length; )
                    !1 === o[s].apply(n[0], n[1]) &&
                      e.stopOnFalse &&
                      ((s = o.length), (n = !1));
                e.memory || (n = !1), (t = !1), r && (o = n ? [] : "");
              },
              c = {
                add: function () {
                  return (
                    o &&
                      (n && !t && ((s = o.length - 1), a.push(n)),
                      (function t(n) {
                        S.each(n, function (n, i) {
                          v(i)
                            ? (e.unique && c.has(i)) || o.push(i)
                            : i && i.length && "string" !== C(i) && t(i);
                        });
                      })(arguments),
                      n && !t && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    S.each(arguments, function (e, t) {
                      for (var n; (n = S.inArray(t, o, n)) > -1; )
                        o.splice(n, 1), n <= s && s--;
                    }),
                    this
                  );
                },
                has: function (e) {
                  return e ? S.inArray(e, o) > -1 : o.length > 0;
                },
                empty: function () {
                  return o && (o = []), this;
                },
                disable: function () {
                  return (r = a = []), (o = n = ""), this;
                },
                disabled: function () {
                  return !o;
                },
                lock: function () {
                  return (r = a = []), n || t || (o = n = ""), this;
                },
                locked: function () {
                  return !!r;
                },
                fireWith: function (e, n) {
                  return (
                    r ||
                      ((n = [e, (n = n || []).slice ? n.slice() : n]),
                      a.push(n),
                      t || l()),
                    this
                  );
                },
                fire: function () {
                  return c.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!i;
                },
              };
            return c;
          }),
            S.extend({
              Deferred: function (e) {
                var t = [
                    [
                      "notify",
                      "progress",
                      S.Callbacks("memory"),
                      S.Callbacks("memory"),
                      2,
                    ],
                    [
                      "resolve",
                      "done",
                      S.Callbacks("once memory"),
                      S.Callbacks("once memory"),
                      0,
                      "resolved",
                    ],
                    [
                      "reject",
                      "fail",
                      S.Callbacks("once memory"),
                      S.Callbacks("once memory"),
                      1,
                      "rejected",
                    ],
                  ],
                  n = "pending",
                  r = {
                    state: function () {
                      return n;
                    },
                    always: function () {
                      return o.done(arguments).fail(arguments), this;
                    },
                    catch: function (e) {
                      return r.then(null, e);
                    },
                    pipe: function () {
                      var e = arguments;
                      return S.Deferred(function (n) {
                        S.each(t, function (t, i) {
                          var r = v(e[i[4]]) && e[i[4]];
                          o[i[1]](function () {
                            var e = r && r.apply(this, arguments);
                            e && v(e.promise)
                              ? e
                                  .promise()
                                  .progress(n.notify)
                                  .done(n.resolve)
                                  .fail(n.reject)
                              : n[i[0] + "With"](this, r ? [e] : arguments);
                          });
                        }),
                          (e = null);
                      }).promise();
                    },
                    then: function (e, n, r) {
                      var o = 0;
                      function a(e, t, n, r) {
                        return function () {
                          var s = this,
                            l = arguments,
                            c = function () {
                              var i, c;
                              if (!(e < o)) {
                                if ((i = n.apply(s, l)) === t.promise())
                                  throw new TypeError(
                                    "Thenable self-resolution"
                                  );
                                (c =
                                  i &&
                                  ("object" == typeof i ||
                                    "function" == typeof i) &&
                                  i.then),
                                  v(c)
                                    ? r
                                      ? c.call(i, a(o, t, z, r), a(o, t, H, r))
                                      : (o++,
                                        c.call(
                                          i,
                                          a(o, t, z, r),
                                          a(o, t, H, r),
                                          a(o, t, z, t.notifyWith)
                                        ))
                                    : (n !== z && ((s = void 0), (l = [i])),
                                      (r || t.resolveWith)(s, l));
                              }
                            },
                            u = r
                              ? c
                              : function () {
                                  try {
                                    c();
                                  } catch (i) {
                                    S.Deferred.exceptionHook &&
                                      S.Deferred.exceptionHook(i, u.stackTrace),
                                      e + 1 >= o &&
                                        (n !== H && ((s = void 0), (l = [i])),
                                        t.rejectWith(s, l));
                                  }
                                };
                          e
                            ? u()
                            : (S.Deferred.getStackHook &&
                                (u.stackTrace = S.Deferred.getStackHook()),
                              i.setTimeout(u));
                        };
                      }
                      return S.Deferred(function (i) {
                        t[0][3].add(a(0, i, v(r) ? r : z, i.notifyWith)),
                          t[1][3].add(a(0, i, v(e) ? e : z)),
                          t[2][3].add(a(0, i, v(n) ? n : H));
                      }).promise();
                    },
                    promise: function (e) {
                      return null != e ? S.extend(e, r) : r;
                    },
                  },
                  o = {};
                return (
                  S.each(t, function (e, i) {
                    var a = i[2],
                      s = i[5];
                    (r[i[1]] = a.add),
                      s &&
                        a.add(
                          function () {
                            n = s;
                          },
                          t[3 - e][2].disable,
                          t[3 - e][3].disable,
                          t[0][2].lock,
                          t[0][3].lock
                        ),
                      a.add(i[3].fire),
                      (o[i[0]] = function () {
                        return (
                          o[i[0] + "With"](
                            this === o ? void 0 : this,
                            arguments
                          ),
                          this
                        );
                      }),
                      (o[i[0] + "With"] = a.fireWith);
                  }),
                  r.promise(o),
                  e && e.call(o, o),
                  o
                );
              },
              when: function (e) {
                var t = arguments.length,
                  n = t,
                  i = Array(n),
                  r = s.call(arguments),
                  o = S.Deferred(),
                  a = function (e) {
                    return function (n) {
                      (i[e] = this),
                        (r[e] = arguments.length > 1 ? s.call(arguments) : n),
                        --t || o.resolveWith(i, r);
                    };
                  };
                if (
                  t <= 1 &&
                  (B(e, o.done(a(n)).resolve, o.reject, !t),
                  "pending" === o.state() || v(r[n] && r[n].then))
                )
                  return o.then();
                for (; n--; ) B(r[n], a(n), o.reject);
                return o.promise();
              },
            });
          var F = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (S.Deferred.exceptionHook = function (e, t) {
            i.console &&
              i.console.warn &&
              e &&
              F.test(e.name) &&
              i.console.warn(
                "jQuery.Deferred exception: " + e.message,
                e.stack,
                t
              );
          }),
            (S.readyException = function (e) {
              i.setTimeout(function () {
                throw e;
              });
            });
          var R = S.Deferred();
          function W() {
            b.removeEventListener("DOMContentLoaded", W),
              i.removeEventListener("load", W),
              S.ready();
          }
          (S.fn.ready = function (e) {
            return (
              R.then(e).catch(function (e) {
                S.readyException(e);
              }),
              this
            );
          }),
            S.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (e) {
                (!0 === e ? --S.readyWait : S.isReady) ||
                  ((S.isReady = !0),
                  (!0 !== e && --S.readyWait > 0) || R.resolveWith(b, [S]));
              },
            }),
            (S.ready.then = R.then),
            "complete" === b.readyState ||
            ("loading" !== b.readyState && !b.documentElement.doScroll)
              ? i.setTimeout(S.ready)
              : (b.addEventListener("DOMContentLoaded", W),
                i.addEventListener("load", W));
          var G = function (e, t, n, i, r, o, a) {
              var s = 0,
                l = e.length,
                c = null == n;
              if ("object" === C(n))
                for (s in ((r = !0), n)) G(e, t, s, n[s], !0, o, a);
              else if (
                void 0 !== i &&
                ((r = !0),
                v(i) || (a = !0),
                c &&
                  (a
                    ? (t.call(e, i), (t = null))
                    : ((c = t),
                      (t = function (e, t, n) {
                        return c.call(S(e), n);
                      }))),
                t)
              )
                for (; s < l; s++)
                  t(e[s], n, a ? i : i.call(e[s], s, t(e[s], n)));
              return r ? e : c ? t.call(e) : l ? t(e[0], n) : o;
            },
            V = /^-ms-/,
            X = /-([a-z])/g;
          function Y(e, t) {
            return t.toUpperCase();
          }
          function U(e) {
            return e.replace(V, "ms-").replace(X, Y);
          }
          var K = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function J() {
            this.expando = S.expando + J.uid++;
          }
          (J.uid = 1),
            (J.prototype = {
              cache: function (e) {
                var t = e[this.expando];
                return (
                  t ||
                    ((t = {}),
                    K(e) &&
                      (e.nodeType
                        ? (e[this.expando] = t)
                        : Object.defineProperty(e, this.expando, {
                            value: t,
                            configurable: !0,
                          }))),
                  t
                );
              },
              set: function (e, t, n) {
                var i,
                  r = this.cache(e);
                if ("string" == typeof t) r[U(t)] = n;
                else for (i in t) r[U(i)] = t[i];
                return r;
              },
              get: function (e, t) {
                return void 0 === t
                  ? this.cache(e)
                  : e[this.expando] && e[this.expando][U(t)];
              },
              access: function (e, t, n) {
                return void 0 === t ||
                  (t && "string" == typeof t && void 0 === n)
                  ? this.get(e, t)
                  : (this.set(e, t, n), void 0 !== n ? n : t);
              },
              remove: function (e, t) {
                var n,
                  i = e[this.expando];
                if (void 0 !== i) {
                  if (void 0 !== t) {
                    n = (t = Array.isArray(t)
                      ? t.map(U)
                      : (t = U(t)) in i
                      ? [t]
                      : t.match($) || []).length;
                    for (; n--; ) delete i[t[n]];
                  }
                  (void 0 === t || S.isEmptyObject(i)) &&
                    (e.nodeType
                      ? (e[this.expando] = void 0)
                      : delete e[this.expando]);
                }
              },
              hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !S.isEmptyObject(t);
              },
            });
          var Q = new J(),
            Z = new J(),
            ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            te = /[A-Z]/g;
          function ne(e, t, n) {
            var i;
            if (void 0 === n && 1 === e.nodeType)
              if (
                ((i = "data-" + t.replace(te, "-$&").toLowerCase()),
                "string" == typeof (n = e.getAttribute(i)))
              ) {
                try {
                  n = (function (e) {
                    return (
                      "true" === e ||
                      ("false" !== e &&
                        ("null" === e
                          ? null
                          : e === +e + ""
                          ? +e
                          : ee.test(e)
                          ? JSON.parse(e)
                          : e))
                    );
                  })(n);
                } catch (e) {}
                Z.set(e, t, n);
              } else n = void 0;
            return n;
          }
          S.extend({
            hasData: function (e) {
              return Z.hasData(e) || Q.hasData(e);
            },
            data: function (e, t, n) {
              return Z.access(e, t, n);
            },
            removeData: function (e, t) {
              Z.remove(e, t);
            },
            _data: function (e, t, n) {
              return Q.access(e, t, n);
            },
            _removeData: function (e, t) {
              Q.remove(e, t);
            },
          }),
            S.fn.extend({
              data: function (e, t) {
                var n,
                  i,
                  r,
                  o = this[0],
                  a = o && o.attributes;
                if (void 0 === e) {
                  if (
                    this.length &&
                    ((r = Z.get(o)),
                    1 === o.nodeType && !Q.get(o, "hasDataAttrs"))
                  ) {
                    for (n = a.length; n--; )
                      a[n] &&
                        0 === (i = a[n].name).indexOf("data-") &&
                        ((i = U(i.slice(5))), ne(o, i, r[i]));
                    Q.set(o, "hasDataAttrs", !0);
                  }
                  return r;
                }
                return "object" == typeof e
                  ? this.each(function () {
                      Z.set(this, e);
                    })
                  : G(
                      this,
                      function (t) {
                        var n;
                        if (o && void 0 === t)
                          return void 0 !== (n = Z.get(o, e)) ||
                            void 0 !== (n = ne(o, e))
                            ? n
                            : void 0;
                        this.each(function () {
                          Z.set(this, e, t);
                        });
                      },
                      null,
                      t,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (e) {
                return this.each(function () {
                  Z.remove(this, e);
                });
              },
            }),
            S.extend({
              queue: function (e, t, n) {
                var i;
                if (e)
                  return (
                    (t = (t || "fx") + "queue"),
                    (i = Q.get(e, t)),
                    n &&
                      (!i || Array.isArray(n)
                        ? (i = Q.access(e, t, S.makeArray(n)))
                        : i.push(n)),
                    i || []
                  );
              },
              dequeue: function (e, t) {
                t = t || "fx";
                var n = S.queue(e, t),
                  i = n.length,
                  r = n.shift(),
                  o = S._queueHooks(e, t);
                "inprogress" === r && ((r = n.shift()), i--),
                  r &&
                    ("fx" === t && n.unshift("inprogress"),
                    delete o.stop,
                    r.call(
                      e,
                      function () {
                        S.dequeue(e, t);
                      },
                      o
                    )),
                  !i && o && o.empty.fire();
              },
              _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                  Q.get(e, n) ||
                  Q.access(e, n, {
                    empty: S.Callbacks("once memory").add(function () {
                      Q.remove(e, [t + "queue", n]);
                    }),
                  })
                );
              },
            }),
            S.fn.extend({
              queue: function (e, t) {
                var n = 2;
                return (
                  "string" != typeof e && ((t = e), (e = "fx"), n--),
                  arguments.length < n
                    ? S.queue(this[0], e)
                    : void 0 === t
                    ? this
                    : this.each(function () {
                        var n = S.queue(this, e, t);
                        S._queueHooks(this, e),
                          "fx" === e &&
                            "inprogress" !== n[0] &&
                            S.dequeue(this, e);
                      })
                );
              },
              dequeue: function (e) {
                return this.each(function () {
                  S.dequeue(this, e);
                });
              },
              clearQueue: function (e) {
                return this.queue(e || "fx", []);
              },
              promise: function (e, t) {
                var n,
                  i = 1,
                  r = S.Deferred(),
                  o = this,
                  a = this.length,
                  s = function () {
                    --i || r.resolveWith(o, [o]);
                  };
                for (
                  "string" != typeof e && ((t = e), (e = void 0)),
                    e = e || "fx";
                  a--;

                )
                  (n = Q.get(o[a], e + "queueHooks")) &&
                    n.empty &&
                    (i++, n.empty.add(s));
                return s(), r.promise(t);
              },
            });
          var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            re = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
            oe = ["Top", "Right", "Bottom", "Left"],
            ae = b.documentElement,
            se = function (e) {
              return S.contains(e.ownerDocument, e);
            },
            le = { composed: !0 };
          ae.getRootNode &&
            (se = function (e) {
              return (
                S.contains(e.ownerDocument, e) ||
                e.getRootNode(le) === e.ownerDocument
              );
            });
          var ce = function (e, t) {
            return (
              "none" === (e = t || e).style.display ||
              ("" === e.style.display &&
                se(e) &&
                "none" === S.css(e, "display"))
            );
          };
          function ue(e, t, n, i) {
            var r,
              o,
              a = 20,
              s = i
                ? function () {
                    return i.cur();
                  }
                : function () {
                    return S.css(e, t, "");
                  },
              l = s(),
              c = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
              u =
                e.nodeType &&
                (S.cssNumber[t] || ("px" !== c && +l)) &&
                re.exec(S.css(e, t));
            if (u && u[3] !== c) {
              for (l /= 2, c = c || u[3], u = +l || 1; a--; )
                S.style(e, t, u + c),
                  (1 - o) * (1 - (o = s() / l || 0.5)) <= 0 && (a = 0),
                  (u /= o);
              (u *= 2), S.style(e, t, u + c), (n = n || []);
            }
            return (
              n &&
                ((u = +u || +l || 0),
                (r = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
                i && ((i.unit = c), (i.start = u), (i.end = r))),
              r
            );
          }
          var de = {};
          function pe(e) {
            var t,
              n = e.ownerDocument,
              i = e.nodeName,
              r = de[i];
            return (
              r ||
              ((t = n.body.appendChild(n.createElement(i))),
              (r = S.css(t, "display")),
              t.parentNode.removeChild(t),
              "none" === r && (r = "block"),
              (de[i] = r),
              r)
            );
          }
          function fe(e, t) {
            for (var n, i, r = [], o = 0, a = e.length; o < a; o++)
              (i = e[o]).style &&
                ((n = i.style.display),
                t
                  ? ("none" === n &&
                      ((r[o] = Q.get(i, "display") || null),
                      r[o] || (i.style.display = "")),
                    "" === i.style.display && ce(i) && (r[o] = pe(i)))
                  : "none" !== n && ((r[o] = "none"), Q.set(i, "display", n)));
            for (o = 0; o < a; o++) null != r[o] && (e[o].style.display = r[o]);
            return e;
          }
          S.fn.extend({
            show: function () {
              return fe(this, !0);
            },
            hide: function () {
              return fe(this);
            },
            toggle: function (e) {
              return "boolean" == typeof e
                ? e
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ce(this) ? S(this).show() : S(this).hide();
                  });
            },
          });
          var he,
            me,
            ge = /^(?:checkbox|radio)$/i,
            ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            ye = /^$|^module$|\/(?:java|ecma)script/i;
          (he = b.createDocumentFragment().appendChild(b.createElement("div"))),
            (me = b.createElement("input")).setAttribute("type", "radio"),
            me.setAttribute("checked", "checked"),
            me.setAttribute("name", "t"),
            he.appendChild(me),
            (g.checkClone = he.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (he.innerHTML = "<textarea>x</textarea>"),
            (g.noCloneChecked = !!he.cloneNode(!0).lastChild.defaultValue),
            (he.innerHTML = "<option></option>"),
            (g.option = !!he.lastChild);
          var be = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
          };
          function we(e, t) {
            var n;
            return (
              (n =
                void 0 !== e.getElementsByTagName
                  ? e.getElementsByTagName(t || "*")
                  : void 0 !== e.querySelectorAll
                  ? e.querySelectorAll(t || "*")
                  : []),
              void 0 === t || (t && M(e, t)) ? S.merge([e], n) : n
            );
          }
          function xe(e, t) {
            for (var n = 0, i = e.length; n < i; n++)
              Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
          }
          (be.tbody = be.tfoot = be.colgroup = be.caption = be.thead),
            (be.th = be.td),
            g.option ||
              (be.optgroup = be.option =
                [1, "<select multiple='multiple'>", "</select>"]);
          var Ce = /<|&#?\w+;/;
          function Te(e, t, n, i, r) {
            for (
              var o,
                a,
                s,
                l,
                c,
                u,
                d = t.createDocumentFragment(),
                p = [],
                f = 0,
                h = e.length;
              f < h;
              f++
            )
              if ((o = e[f]) || 0 === o)
                if ("object" === C(o)) S.merge(p, o.nodeType ? [o] : o);
                else if (Ce.test(o)) {
                  for (
                    a = a || d.appendChild(t.createElement("div")),
                      s = (ve.exec(o) || ["", ""])[1].toLowerCase(),
                      l = be[s] || be._default,
                      a.innerHTML = l[1] + S.htmlPrefilter(o) + l[2],
                      u = l[0];
                    u--;

                  )
                    a = a.lastChild;
                  S.merge(p, a.childNodes),
                    ((a = d.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
            for (d.textContent = "", f = 0; (o = p[f++]); )
              if (i && S.inArray(o, i) > -1) r && r.push(o);
              else if (
                ((c = se(o)),
                (a = we(d.appendChild(o), "script")),
                c && xe(a),
                n)
              )
                for (u = 0; (o = a[u++]); ) ye.test(o.type || "") && n.push(o);
            return d;
          }
          var Se = /^([^.]*)(?:\.(.+)|)/;
          function Ee() {
            return !0;
          }
          function ke() {
            return !1;
          }
          function Le(e, t) {
            return (
              (e ===
                (function () {
                  try {
                    return b.activeElement;
                  } catch (e) {}
                })()) ==
              ("focus" === t)
            );
          }
          function Pe(e, t, n, i, r, o) {
            var a, s;
            if ("object" == typeof t) {
              for (s in ("string" != typeof n && ((i = i || n), (n = void 0)),
              t))
                Pe(e, s, n, i, t[s], o);
              return e;
            }
            if (
              (null == i && null == r
                ? ((r = n), (i = n = void 0))
                : null == r &&
                  ("string" == typeof n
                    ? ((r = i), (i = void 0))
                    : ((r = i), (i = n), (n = void 0))),
              !1 === r)
            )
              r = ke;
            else if (!r) return e;
            return (
              1 === o &&
                ((a = r),
                (r = function (e) {
                  return S().off(e), a.apply(this, arguments);
                }),
                (r.guid = a.guid || (a.guid = S.guid++))),
              e.each(function () {
                S.event.add(this, t, r, i, n);
              })
            );
          }
          function Oe(e, t, n) {
            n
              ? (Q.set(e, t, !1),
                S.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                    var i,
                      r,
                      o = Q.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                      if (o.length)
                        (S.event.special[t] || {}).delegateType &&
                          e.stopPropagation();
                      else if (
                        ((o = s.call(arguments)),
                        Q.set(this, t, o),
                        (i = n(this, t)),
                        this[t](),
                        o !== (r = Q.get(this, t)) || i
                          ? Q.set(this, t, !1)
                          : (r = {}),
                        o !== r)
                      )
                        return (
                          e.stopImmediatePropagation(),
                          e.preventDefault(),
                          r && r.value
                        );
                    } else
                      o.length &&
                        (Q.set(this, t, {
                          value: S.event.trigger(
                            S.extend(o[0], S.Event.prototype),
                            o.slice(1),
                            this
                          ),
                        }),
                        e.stopImmediatePropagation());
                  },
                }))
              : void 0 === Q.get(e, t) && S.event.add(e, t, Ee);
          }
          (S.event = {
            global: {},
            add: function (e, t, n, i, r) {
              var o,
                a,
                s,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g = Q.get(e);
              if (K(e))
                for (
                  n.handler && ((n = (o = n).handler), (r = o.selector)),
                    r && S.find.matchesSelector(ae, r),
                    n.guid || (n.guid = S.guid++),
                    (l = g.events) || (l = g.events = Object.create(null)),
                    (a = g.handle) ||
                      (a = g.handle =
                        function (t) {
                          return void 0 !== S && S.event.triggered !== t.type
                            ? S.event.dispatch.apply(e, arguments)
                            : void 0;
                        }),
                    c = (t = (t || "").match($) || [""]).length;
                  c--;

                )
                  (f = m = (s = Se.exec(t[c]) || [])[1]),
                    (h = (s[2] || "").split(".").sort()),
                    f &&
                      ((d = S.event.special[f] || {}),
                      (f = (r ? d.delegateType : d.bindType) || f),
                      (d = S.event.special[f] || {}),
                      (u = S.extend(
                        {
                          type: f,
                          origType: m,
                          data: i,
                          handler: n,
                          guid: n.guid,
                          selector: r,
                          needsContext: r && S.expr.match.needsContext.test(r),
                          namespace: h.join("."),
                        },
                        o
                      )),
                      (p = l[f]) ||
                        (((p = l[f] = []).delegateCount = 0),
                        (d.setup && !1 !== d.setup.call(e, i, h, a)) ||
                          (e.addEventListener && e.addEventListener(f, a))),
                      d.add &&
                        (d.add.call(e, u),
                        u.handler.guid || (u.handler.guid = n.guid)),
                      r ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                      (S.event.global[f] = !0));
            },
            remove: function (e, t, n, i, r) {
              var o,
                a,
                s,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g = Q.hasData(e) && Q.get(e);
              if (g && (l = g.events)) {
                for (c = (t = (t || "").match($) || [""]).length; c--; )
                  if (
                    ((f = m = (s = Se.exec(t[c]) || [])[1]),
                    (h = (s[2] || "").split(".").sort()),
                    f)
                  ) {
                    for (
                      d = S.event.special[f] || {},
                        p =
                          l[(f = (i ? d.delegateType : d.bindType) || f)] || [],
                        s =
                          s[2] &&
                          new RegExp(
                            "(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"
                          ),
                        a = o = p.length;
                      o--;

                    )
                      (u = p[o]),
                        (!r && m !== u.origType) ||
                          (n && n.guid !== u.guid) ||
                          (s && !s.test(u.namespace)) ||
                          (i &&
                            i !== u.selector &&
                            ("**" !== i || !u.selector)) ||
                          (p.splice(o, 1),
                          u.selector && p.delegateCount--,
                          d.remove && d.remove.call(e, u));
                    a &&
                      !p.length &&
                      ((d.teardown && !1 !== d.teardown.call(e, h, g.handle)) ||
                        S.removeEvent(e, f, g.handle),
                      delete l[f]);
                  } else for (f in l) S.event.remove(e, f + t[c], n, i, !0);
                S.isEmptyObject(l) && Q.remove(e, "handle events");
              }
            },
            dispatch: function (e) {
              var t,
                n,
                i,
                r,
                o,
                a,
                s = new Array(arguments.length),
                l = S.event.fix(e),
                c =
                  (Q.get(this, "events") || Object.create(null))[l.type] || [],
                u = S.event.special[l.type] || {};
              for (s[0] = l, t = 1; t < arguments.length; t++)
                s[t] = arguments[t];
              if (
                ((l.delegateTarget = this),
                !u.preDispatch || !1 !== u.preDispatch.call(this, l))
              ) {
                for (
                  a = S.event.handlers.call(this, l, c), t = 0;
                  (r = a[t++]) && !l.isPropagationStopped();

                )
                  for (
                    l.currentTarget = r.elem, n = 0;
                    (o = r.handlers[n++]) && !l.isImmediatePropagationStopped();

                  )
                    (l.rnamespace &&
                      !1 !== o.namespace &&
                      !l.rnamespace.test(o.namespace)) ||
                      ((l.handleObj = o),
                      (l.data = o.data),
                      void 0 !==
                        (i = (
                          (S.event.special[o.origType] || {}).handle ||
                          o.handler
                        ).apply(r.elem, s)) &&
                        !1 === (l.result = i) &&
                        (l.preventDefault(), l.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (e, t) {
              var n,
                i,
                r,
                o,
                a,
                s = [],
                l = t.delegateCount,
                c = e.target;
              if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                for (; c !== this; c = c.parentNode || this)
                  if (
                    1 === c.nodeType &&
                    ("click" !== e.type || !0 !== c.disabled)
                  ) {
                    for (o = [], a = {}, n = 0; n < l; n++)
                      void 0 === a[(r = (i = t[n]).selector + " ")] &&
                        (a[r] = i.needsContext
                          ? S(r, this).index(c) > -1
                          : S.find(r, this, null, [c]).length),
                        a[r] && o.push(i);
                    o.length && s.push({ elem: c, handlers: o });
                  }
              return (
                (c = this),
                l < t.length && s.push({ elem: c, handlers: t.slice(l) }),
                s
              );
            },
            addProp: function (e, t) {
              Object.defineProperty(S.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: v(t)
                  ? function () {
                      if (this.originalEvent) return t(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[e];
                    },
                set: function (t) {
                  Object.defineProperty(this, e, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t,
                  });
                },
              });
            },
            fix: function (e) {
              return e[S.expando] ? e : new S.Event(e);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (e) {
                  var t = this || e;
                  return (
                    ge.test(t.type) &&
                      t.click &&
                      M(t, "input") &&
                      Oe(t, "click", Ee),
                    !1
                  );
                },
                trigger: function (e) {
                  var t = this || e;
                  return (
                    ge.test(t.type) &&
                      t.click &&
                      M(t, "input") &&
                      Oe(t, "click"),
                    !0
                  );
                },
                _default: function (e) {
                  var t = e.target;
                  return (
                    (ge.test(t.type) &&
                      t.click &&
                      M(t, "input") &&
                      Q.get(t, "click")) ||
                    M(t, "a")
                  );
                },
              },
              beforeunload: {
                postDispatch: function (e) {
                  void 0 !== e.result &&
                    e.originalEvent &&
                    (e.originalEvent.returnValue = e.result);
                },
              },
            },
          }),
            (S.removeEvent = function (e, t, n) {
              e.removeEventListener && e.removeEventListener(t, n);
            }),
            (S.Event = function (e, t) {
              if (!(this instanceof S.Event)) return new S.Event(e, t);
              e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented =
                    e.defaultPrevented ||
                    (void 0 === e.defaultPrevented && !1 === e.returnValue)
                      ? Ee
                      : ke),
                  (this.target =
                    e.target && 3 === e.target.nodeType
                      ? e.target.parentNode
                      : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && S.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[S.expando] = !0);
            }),
            (S.Event.prototype = {
              constructor: S.Event,
              isDefaultPrevented: ke,
              isPropagationStopped: ke,
              isImmediatePropagationStopped: ke,
              isSimulated: !1,
              preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Ee),
                  e && !this.isSimulated && e.preventDefault();
              },
              stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Ee),
                  e && !this.isSimulated && e.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Ee),
                  e && !this.isSimulated && e.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            S.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              S.event.addProp
            ),
            S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
              S.event.special[e] = {
                setup: function () {
                  return Oe(this, e, Le), !1;
                },
                trigger: function () {
                  return Oe(this, e), !0;
                },
                _default: function () {
                  return !0;
                },
                delegateType: t,
              };
            }),
            S.each(
              {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout",
              },
              function (e, t) {
                S.event.special[e] = {
                  delegateType: t,
                  bindType: t,
                  handle: function (e) {
                    var n,
                      i = this,
                      r = e.relatedTarget,
                      o = e.handleObj;
                    return (
                      (r && (r === i || S.contains(i, r))) ||
                        ((e.type = o.origType),
                        (n = o.handler.apply(this, arguments)),
                        (e.type = t)),
                      n
                    );
                  },
                };
              }
            ),
            S.fn.extend({
              on: function (e, t, n, i) {
                return Pe(this, e, t, n, i);
              },
              one: function (e, t, n, i) {
                return Pe(this, e, t, n, i, 1);
              },
              off: function (e, t, n) {
                var i, r;
                if (e && e.preventDefault && e.handleObj)
                  return (
                    (i = e.handleObj),
                    S(e.delegateTarget).off(
                      i.namespace ? i.origType + "." + i.namespace : i.origType,
                      i.selector,
                      i.handler
                    ),
                    this
                  );
                if ("object" == typeof e) {
                  for (r in e) this.off(r, t, e[r]);
                  return this;
                }
                return (
                  (!1 !== t && "function" != typeof t) ||
                    ((n = t), (t = void 0)),
                  !1 === n && (n = ke),
                  this.each(function () {
                    S.event.remove(this, e, n, t);
                  })
                );
              },
            });
          var Me = /<script|<style|<link/i,
            Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Ie = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function je(e, t) {
            return (
              (M(e, "table") &&
                M(11 !== t.nodeType ? t : t.firstChild, "tr") &&
                S(e).children("tbody")[0]) ||
              e
            );
          }
          function _e(e) {
            return (
              (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e
            );
          }
          function De(e) {
            return (
              "true/" === (e.type || "").slice(0, 5)
                ? (e.type = e.type.slice(5))
                : e.removeAttribute("type"),
              e
            );
          }
          function Ne(e, t) {
            var n, i, r, o, a, s;
            if (1 === t.nodeType) {
              if (Q.hasData(e) && (s = Q.get(e).events))
                for (r in (Q.remove(t, "handle events"), s))
                  for (n = 0, i = s[r].length; n < i; n++)
                    S.event.add(t, r, s[r][n]);
              Z.hasData(e) &&
                ((o = Z.access(e)), (a = S.extend({}, o)), Z.set(t, a));
            }
          }
          function qe(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && ge.test(e.type)
              ? (t.checked = e.checked)
              : ("input" !== n && "textarea" !== n) ||
                (t.defaultValue = e.defaultValue);
          }
          function $e(e, t, n, i) {
            t = l(t);
            var r,
              o,
              a,
              s,
              c,
              u,
              d = 0,
              p = e.length,
              f = p - 1,
              h = t[0],
              m = v(h);
            if (
              m ||
              (p > 1 && "string" == typeof h && !g.checkClone && Ae.test(h))
            )
              return e.each(function (r) {
                var o = e.eq(r);
                m && (t[0] = h.call(this, r, o.html())), $e(o, t, n, i);
              });
            if (
              p &&
              ((o = (r = Te(t, e[0].ownerDocument, !1, e, i)).firstChild),
              1 === r.childNodes.length && (r = o),
              o || i)
            ) {
              for (s = (a = S.map(we(r, "script"), _e)).length; d < p; d++)
                (c = r),
                  d !== f &&
                    ((c = S.clone(c, !0, !0)),
                    s && S.merge(a, we(c, "script"))),
                  n.call(e[d], c, d);
              if (s)
                for (
                  u = a[a.length - 1].ownerDocument, S.map(a, De), d = 0;
                  d < s;
                  d++
                )
                  (c = a[d]),
                    ye.test(c.type || "") &&
                      !Q.access(c, "globalEval") &&
                      S.contains(u, c) &&
                      (c.src && "module" !== (c.type || "").toLowerCase()
                        ? S._evalUrl &&
                          !c.noModule &&
                          S._evalUrl(
                            c.src,
                            { nonce: c.nonce || c.getAttribute("nonce") },
                            u
                          )
                        : x(c.textContent.replace(Ie, ""), c, u));
            }
            return e;
          }
          function ze(e, t, n) {
            for (
              var i, r = t ? S.filter(t, e) : e, o = 0;
              null != (i = r[o]);
              o++
            )
              n || 1 !== i.nodeType || S.cleanData(we(i)),
                i.parentNode &&
                  (n && se(i) && xe(we(i, "script")),
                  i.parentNode.removeChild(i));
            return e;
          }
          S.extend({
            htmlPrefilter: function (e) {
              return e;
            },
            clone: function (e, t, n) {
              var i,
                r,
                o,
                a,
                s = e.cloneNode(!0),
                l = se(e);
              if (
                !(
                  g.noCloneChecked ||
                  (1 !== e.nodeType && 11 !== e.nodeType) ||
                  S.isXMLDoc(e)
                )
              )
                for (a = we(s), i = 0, r = (o = we(e)).length; i < r; i++)
                  qe(o[i], a[i]);
              if (t)
                if (n)
                  for (
                    o = o || we(e), a = a || we(s), i = 0, r = o.length;
                    i < r;
                    i++
                  )
                    Ne(o[i], a[i]);
                else Ne(e, s);
              return (
                (a = we(s, "script")).length > 0 &&
                  xe(a, !l && we(e, "script")),
                s
              );
            },
            cleanData: function (e) {
              for (
                var t, n, i, r = S.event.special, o = 0;
                void 0 !== (n = e[o]);
                o++
              )
                if (K(n)) {
                  if ((t = n[Q.expando])) {
                    if (t.events)
                      for (i in t.events)
                        r[i]
                          ? S.event.remove(n, i)
                          : S.removeEvent(n, i, t.handle);
                    n[Q.expando] = void 0;
                  }
                  n[Z.expando] && (n[Z.expando] = void 0);
                }
            },
          }),
            S.fn.extend({
              detach: function (e) {
                return ze(this, e, !0);
              },
              remove: function (e) {
                return ze(this, e);
              },
              text: function (e) {
                return G(
                  this,
                  function (e) {
                    return void 0 === e
                      ? S.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType &&
                            11 !== this.nodeType &&
                            9 !== this.nodeType) ||
                            (this.textContent = e);
                        });
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              append: function () {
                return $e(this, arguments, function (e) {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    je(this, e).appendChild(e);
                });
              },
              prepend: function () {
                return $e(this, arguments, function (e) {
                  if (
                    1 === this.nodeType ||
                    11 === this.nodeType ||
                    9 === this.nodeType
                  ) {
                    var t = je(this, e);
                    t.insertBefore(e, t.firstChild);
                  }
                });
              },
              before: function () {
                return $e(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this);
                });
              },
              after: function () {
                return $e(this, arguments, function (e) {
                  this.parentNode &&
                    this.parentNode.insertBefore(e, this.nextSibling);
                });
              },
              empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++)
                  1 === e.nodeType &&
                    (S.cleanData(we(e, !1)), (e.textContent = ""));
                return this;
              },
              clone: function (e, t) {
                return (
                  (e = null != e && e),
                  (t = null == t ? e : t),
                  this.map(function () {
                    return S.clone(this, e, t);
                  })
                );
              },
              html: function (e) {
                return G(
                  this,
                  function (e) {
                    var t = this[0] || {},
                      n = 0,
                      i = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if (
                      "string" == typeof e &&
                      !Me.test(e) &&
                      !be[(ve.exec(e) || ["", ""])[1].toLowerCase()]
                    ) {
                      e = S.htmlPrefilter(e);
                      try {
                        for (; n < i; n++)
                          1 === (t = this[n] || {}).nodeType &&
                            (S.cleanData(we(t, !1)), (t.innerHTML = e));
                        t = 0;
                      } catch (e) {}
                    }
                    t && this.empty().append(e);
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              replaceWith: function () {
                var e = [];
                return $e(
                  this,
                  arguments,
                  function (t) {
                    var n = this.parentNode;
                    S.inArray(this, e) < 0 &&
                      (S.cleanData(we(this)), n && n.replaceChild(t, this));
                  },
                  e
                );
              },
            }),
            S.each(
              {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
              },
              function (e, t) {
                S.fn[e] = function (e) {
                  for (
                    var n, i = [], r = S(e), o = r.length - 1, a = 0;
                    a <= o;
                    a++
                  )
                    (n = a === o ? this : this.clone(!0)),
                      S(r[a])[t](n),
                      c.apply(i, n.get());
                  return this.pushStack(i);
                };
              }
            );
          var He = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
            Be = function (e) {
              var t = e.ownerDocument.defaultView;
              return (t && t.opener) || (t = i), t.getComputedStyle(e);
            },
            Fe = function (e, t, n) {
              var i,
                r,
                o = {};
              for (r in t) (o[r] = e.style[r]), (e.style[r] = t[r]);
              for (r in ((i = n.call(e)), t)) e.style[r] = o[r];
              return i;
            },
            Re = new RegExp(oe.join("|"), "i");
          function We(e, t, n) {
            var i,
              r,
              o,
              a,
              s = e.style;
            return (
              (n = n || Be(e)) &&
                ("" !== (a = n.getPropertyValue(t) || n[t]) ||
                  se(e) ||
                  (a = S.style(e, t)),
                !g.pixelBoxStyles() &&
                  He.test(a) &&
                  Re.test(t) &&
                  ((i = s.width),
                  (r = s.minWidth),
                  (o = s.maxWidth),
                  (s.minWidth = s.maxWidth = s.width = a),
                  (a = n.width),
                  (s.width = i),
                  (s.minWidth = r),
                  (s.maxWidth = o))),
              void 0 !== a ? a + "" : a
            );
          }
          function Ge(e, t) {
            return {
              get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function e() {
              if (u) {
                (c.style.cssText =
                  "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                  (u.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                  ae.appendChild(c).appendChild(u);
                var e = i.getComputedStyle(u);
                (n = "1%" !== e.top),
                  (l = 12 === t(e.marginLeft)),
                  (u.style.right = "60%"),
                  (a = 36 === t(e.right)),
                  (r = 36 === t(e.width)),
                  (u.style.position = "absolute"),
                  (o = 12 === t(u.offsetWidth / 3)),
                  ae.removeChild(c),
                  (u = null);
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              r,
              o,
              a,
              s,
              l,
              c = b.createElement("div"),
              u = b.createElement("div");
            u.style &&
              ((u.style.backgroundClip = "content-box"),
              (u.cloneNode(!0).style.backgroundClip = ""),
              (g.clearCloneStyle = "content-box" === u.style.backgroundClip),
              S.extend(g, {
                boxSizingReliable: function () {
                  return e(), r;
                },
                pixelBoxStyles: function () {
                  return e(), a;
                },
                pixelPosition: function () {
                  return e(), n;
                },
                reliableMarginLeft: function () {
                  return e(), l;
                },
                scrollboxSize: function () {
                  return e(), o;
                },
                reliableTrDimensions: function () {
                  var e, t, n, r;
                  return (
                    null == s &&
                      ((e = b.createElement("table")),
                      (t = b.createElement("tr")),
                      (n = b.createElement("div")),
                      (e.style.cssText =
                        "position:absolute;left:-11111px;border-collapse:separate"),
                      (t.style.cssText = "border:1px solid"),
                      (t.style.height = "1px"),
                      (n.style.height = "9px"),
                      (n.style.display = "block"),
                      ae.appendChild(e).appendChild(t).appendChild(n),
                      (r = i.getComputedStyle(t)),
                      (s =
                        parseInt(r.height, 10) +
                          parseInt(r.borderTopWidth, 10) +
                          parseInt(r.borderBottomWidth, 10) ===
                        t.offsetHeight),
                      ae.removeChild(e)),
                    s
                  );
                },
              }));
          })();
          var Ve = ["Webkit", "Moz", "ms"],
            Xe = b.createElement("div").style,
            Ye = {};
          function Ue(e) {
            return (
              S.cssProps[e] ||
              Ye[e] ||
              (e in Xe
                ? e
                : (Ye[e] =
                    (function (e) {
                      for (
                        var t = e[0].toUpperCase() + e.slice(1), n = Ve.length;
                        n--;

                      )
                        if ((e = Ve[n] + t) in Xe) return e;
                    })(e) || e))
            );
          }
          var Ke = /^(none|table(?!-c[ea]).+)/,
            Je = /^--/,
            Qe = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            Ze = { letterSpacing: "0", fontWeight: "400" };
          function et(e, t, n) {
            var i = re.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
          }
          function tt(e, t, n, i, r, o) {
            var a = "width" === t ? 1 : 0,
              s = 0,
              l = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; a < 4; a += 2)
              "margin" === n && (l += S.css(e, n + oe[a], !0, r)),
                i
                  ? ("content" === n &&
                      (l -= S.css(e, "padding" + oe[a], !0, r)),
                    "margin" !== n &&
                      (l -= S.css(e, "border" + oe[a] + "Width", !0, r)))
                  : ((l += S.css(e, "padding" + oe[a], !0, r)),
                    "padding" !== n
                      ? (l += S.css(e, "border" + oe[a] + "Width", !0, r))
                      : (s += S.css(e, "border" + oe[a] + "Width", !0, r)));
            return (
              !i &&
                o >= 0 &&
                (l +=
                  Math.max(
                    0,
                    Math.ceil(
                      e["offset" + t[0].toUpperCase() + t.slice(1)] -
                        o -
                        l -
                        s -
                        0.5
                    )
                  ) || 0),
              l
            );
          }
          function nt(e, t, n) {
            var i = Be(e),
              r =
                (!g.boxSizingReliable() || n) &&
                "border-box" === S.css(e, "boxSizing", !1, i),
              o = r,
              a = We(e, t, i),
              s = "offset" + t[0].toUpperCase() + t.slice(1);
            if (He.test(a)) {
              if (!n) return a;
              a = "auto";
            }
            return (
              ((!g.boxSizingReliable() && r) ||
                (!g.reliableTrDimensions() && M(e, "tr")) ||
                "auto" === a ||
                (!parseFloat(a) && "inline" === S.css(e, "display", !1, i))) &&
                e.getClientRects().length &&
                ((r = "border-box" === S.css(e, "boxSizing", !1, i)),
                (o = s in e) && (a = e[s])),
              (a = parseFloat(a) || 0) +
                tt(e, t, n || (r ? "border" : "content"), o, i, a) +
                "px"
            );
          }
          function it(e, t, n, i, r) {
            return new it.prototype.init(e, t, n, i, r);
          }
          S.extend({
            cssHooks: {
              opacity: {
                get: function (e, t) {
                  if (t) {
                    var n = We(e, "opacity");
                    return "" === n ? "1" : n;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (e, t, n, i) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r,
                  o,
                  a,
                  s = U(t),
                  l = Je.test(t),
                  c = e.style;
                if (
                  (l || (t = Ue(s)),
                  (a = S.cssHooks[t] || S.cssHooks[s]),
                  void 0 === n)
                )
                  return a && "get" in a && void 0 !== (r = a.get(e, !1, i))
                    ? r
                    : c[t];
                "string" == (o = typeof n) &&
                  (r = re.exec(n)) &&
                  r[1] &&
                  ((n = ue(e, t, r)), (o = "number")),
                  null != n &&
                    n == n &&
                    ("number" !== o ||
                      l ||
                      (n += (r && r[3]) || (S.cssNumber[s] ? "" : "px")),
                    g.clearCloneStyle ||
                      "" !== n ||
                      0 !== t.indexOf("background") ||
                      (c[t] = "inherit"),
                    (a && "set" in a && void 0 === (n = a.set(e, n, i))) ||
                      (l ? c.setProperty(t, n) : (c[t] = n)));
              }
            },
            css: function (e, t, n, i) {
              var r,
                o,
                a,
                s = U(t);
              return (
                Je.test(t) || (t = Ue(s)),
                (a = S.cssHooks[t] || S.cssHooks[s]) &&
                  "get" in a &&
                  (r = a.get(e, !0, n)),
                void 0 === r && (r = We(e, t, i)),
                "normal" === r && t in Ze && (r = Ze[t]),
                "" === n || n
                  ? ((o = parseFloat(r)), !0 === n || isFinite(o) ? o || 0 : r)
                  : r
              );
            },
          }),
            S.each(["height", "width"], function (e, t) {
              S.cssHooks[t] = {
                get: function (e, n, i) {
                  if (n)
                    return !Ke.test(S.css(e, "display")) ||
                      (e.getClientRects().length &&
                        e.getBoundingClientRect().width)
                      ? nt(e, t, i)
                      : Fe(e, Qe, function () {
                          return nt(e, t, i);
                        });
                },
                set: function (e, n, i) {
                  var r,
                    o = Be(e),
                    a = !g.scrollboxSize() && "absolute" === o.position,
                    s =
                      (a || i) && "border-box" === S.css(e, "boxSizing", !1, o),
                    l = i ? tt(e, t, i, s, o) : 0;
                  return (
                    s &&
                      a &&
                      (l -= Math.ceil(
                        e["offset" + t[0].toUpperCase() + t.slice(1)] -
                          parseFloat(o[t]) -
                          tt(e, t, "border", !1, o) -
                          0.5
                      )),
                    l &&
                      (r = re.exec(n)) &&
                      "px" !== (r[3] || "px") &&
                      ((e.style[t] = n), (n = S.css(e, t))),
                    et(0, n, l)
                  );
                },
              };
            }),
            (S.cssHooks.marginLeft = Ge(g.reliableMarginLeft, function (e, t) {
              if (t)
                return (
                  (parseFloat(We(e, "marginLeft")) ||
                    e.getBoundingClientRect().left -
                      Fe(e, { marginLeft: 0 }, function () {
                        return e.getBoundingClientRect().left;
                      })) + "px"
                );
            })),
            S.each(
              { margin: "", padding: "", border: "Width" },
              function (e, t) {
                (S.cssHooks[e + t] = {
                  expand: function (n) {
                    for (
                      var i = 0,
                        r = {},
                        o = "string" == typeof n ? n.split(" ") : [n];
                      i < 4;
                      i++
                    )
                      r[e + oe[i] + t] = o[i] || o[i - 2] || o[0];
                    return r;
                  },
                }),
                  "margin" !== e && (S.cssHooks[e + t].set = et);
              }
            ),
            S.fn.extend({
              css: function (e, t) {
                return G(
                  this,
                  function (e, t, n) {
                    var i,
                      r,
                      o = {},
                      a = 0;
                    if (Array.isArray(t)) {
                      for (i = Be(e), r = t.length; a < r; a++)
                        o[t[a]] = S.css(e, t[a], !1, i);
                      return o;
                    }
                    return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                  },
                  e,
                  t,
                  arguments.length > 1
                );
              },
            }),
            (S.Tween = it),
            (it.prototype = {
              constructor: it,
              init: function (e, t, n, i, r, o) {
                (this.elem = e),
                  (this.prop = n),
                  (this.easing = r || S.easing._default),
                  (this.options = t),
                  (this.start = this.now = this.cur()),
                  (this.end = i),
                  (this.unit = o || (S.cssNumber[n] ? "" : "px"));
              },
              cur: function () {
                var e = it.propHooks[this.prop];
                return e && e.get
                  ? e.get(this)
                  : it.propHooks._default.get(this);
              },
              run: function (e) {
                var t,
                  n = it.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = t =
                        S.easing[this.easing](
                          e,
                          this.options.duration * e,
                          0,
                          1,
                          this.options.duration
                        ))
                    : (this.pos = t = e),
                  (this.now = (this.end - this.start) * t + this.start),
                  this.options.step &&
                    this.options.step.call(this.elem, this.now, this),
                  n && n.set ? n.set(this) : it.propHooks._default.set(this),
                  this
                );
              },
            }),
            (it.prototype.init.prototype = it.prototype),
            (it.propHooks = {
              _default: {
                get: function (e) {
                  var t;
                  return 1 !== e.elem.nodeType ||
                    (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                    ? e.elem[e.prop]
                    : (t = S.css(e.elem, e.prop, "")) && "auto" !== t
                    ? t
                    : 0;
                },
                set: function (e) {
                  S.fx.step[e.prop]
                    ? S.fx.step[e.prop](e)
                    : 1 !== e.elem.nodeType ||
                      (!S.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)])
                    ? (e.elem[e.prop] = e.now)
                    : S.style(e.elem, e.prop, e.now + e.unit);
                },
              },
            }),
            (it.propHooks.scrollTop = it.propHooks.scrollLeft =
              {
                set: function (e) {
                  e.elem.nodeType &&
                    e.elem.parentNode &&
                    (e.elem[e.prop] = e.now);
                },
              }),
            (S.easing = {
              linear: function (e) {
                return e;
              },
              swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
              },
              _default: "swing",
            }),
            (S.fx = it.prototype.init),
            (S.fx.step = {});
          var rt,
            ot,
            at = /^(?:toggle|show|hide)$/,
            st = /queueHooks$/;
          function lt() {
            ot &&
              (!1 === b.hidden && i.requestAnimationFrame
                ? i.requestAnimationFrame(lt)
                : i.setTimeout(lt, S.fx.interval),
              S.fx.tick());
          }
          function ct() {
            return (
              i.setTimeout(function () {
                rt = void 0;
              }),
              (rt = Date.now())
            );
          }
          function ut(e, t) {
            var n,
              i = 0,
              r = { height: e };
            for (t = t ? 1 : 0; i < 4; i += 2 - t)
              r["margin" + (n = oe[i])] = r["padding" + n] = e;
            return t && (r.opacity = r.width = e), r;
          }
          function dt(e, t, n) {
            for (
              var i,
                r = (pt.tweeners[t] || []).concat(pt.tweeners["*"]),
                o = 0,
                a = r.length;
              o < a;
              o++
            )
              if ((i = r[o].call(n, t, e))) return i;
          }
          function pt(e, t, n) {
            var i,
              r,
              o = 0,
              a = pt.prefilters.length,
              s = S.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (r) return !1;
                for (
                  var t = rt || ct(),
                    n = Math.max(0, c.startTime + c.duration - t),
                    i = 1 - (n / c.duration || 0),
                    o = 0,
                    a = c.tweens.length;
                  o < a;
                  o++
                )
                  c.tweens[o].run(i);
                return (
                  s.notifyWith(e, [c, i, n]),
                  i < 1 && a
                    ? n
                    : (a || s.notifyWith(e, [c, 1, 0]),
                      s.resolveWith(e, [c]),
                      !1)
                );
              },
              c = s.promise({
                elem: e,
                props: S.extend({}, t),
                opts: S.extend(
                  !0,
                  { specialEasing: {}, easing: S.easing._default },
                  n
                ),
                originalProperties: t,
                originalOptions: n,
                startTime: rt || ct(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                  var i = S.Tween(
                    e,
                    c.opts,
                    t,
                    n,
                    c.opts.specialEasing[t] || c.opts.easing
                  );
                  return c.tweens.push(i), i;
                },
                stop: function (t) {
                  var n = 0,
                    i = t ? c.tweens.length : 0;
                  if (r) return this;
                  for (r = !0; n < i; n++) c.tweens[n].run(1);
                  return (
                    t
                      ? (s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c, t]))
                      : s.rejectWith(e, [c, t]),
                    this
                  );
                },
              }),
              u = c.props;
            for (
              (function (e, t) {
                var n, i, r, o, a;
                for (n in e)
                  if (
                    ((r = t[(i = U(n))]),
                    (o = e[n]),
                    Array.isArray(o) && ((r = o[1]), (o = e[n] = o[0])),
                    n !== i && ((e[i] = o), delete e[n]),
                    (a = S.cssHooks[i]) && ("expand" in a))
                  )
                    for (n in ((o = a.expand(o)), delete e[i], o))
                      (n in e) || ((e[n] = o[n]), (t[n] = r));
                  else t[i] = r;
              })(u, c.opts.specialEasing);
              o < a;
              o++
            )
              if ((i = pt.prefilters[o].call(c, e, u, c.opts)))
                return (
                  v(i.stop) &&
                    (S._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
                  i
                );
            return (
              S.map(u, dt, c),
              v(c.opts.start) && c.opts.start.call(e, c),
              c
                .progress(c.opts.progress)
                .done(c.opts.done, c.opts.complete)
                .fail(c.opts.fail)
                .always(c.opts.always),
              S.fx.timer(
                S.extend(l, { elem: e, anim: c, queue: c.opts.queue })
              ),
              c
            );
          }
          (S.Animation = S.extend(pt, {
            tweeners: {
              "*": [
                function (e, t) {
                  var n = this.createTween(e, t);
                  return ue(n.elem, e, re.exec(t), n), n;
                },
              ],
            },
            tweener: function (e, t) {
              v(e) ? ((t = e), (e = ["*"])) : (e = e.match($));
              for (var n, i = 0, r = e.length; i < r; i++)
                (n = e[i]),
                  (pt.tweeners[n] = pt.tweeners[n] || []),
                  pt.tweeners[n].unshift(t);
            },
            prefilters: [
              function (e, t, n) {
                var i,
                  r,
                  o,
                  a,
                  s,
                  l,
                  c,
                  u,
                  d = "width" in t || "height" in t,
                  p = this,
                  f = {},
                  h = e.style,
                  m = e.nodeType && ce(e),
                  g = Q.get(e, "fxshow");
                for (i in (n.queue ||
                  (null == (a = S._queueHooks(e, "fx")).unqueued &&
                    ((a.unqueued = 0),
                    (s = a.empty.fire),
                    (a.empty.fire = function () {
                      a.unqueued || s();
                    })),
                  a.unqueued++,
                  p.always(function () {
                    p.always(function () {
                      a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
                    });
                  })),
                t))
                  if (((r = t[i]), at.test(r))) {
                    if (
                      (delete t[i],
                      (o = o || "toggle" === r),
                      r === (m ? "hide" : "show"))
                    ) {
                      if ("show" !== r || !g || void 0 === g[i]) continue;
                      m = !0;
                    }
                    f[i] = (g && g[i]) || S.style(e, i);
                  }
                if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(f))
                  for (i in (d &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (c = g && g.display) && (c = Q.get(e, "display")),
                    "none" === (u = S.css(e, "display")) &&
                      (c
                        ? (u = c)
                        : (fe([e], !0),
                          (c = e.style.display || c),
                          (u = S.css(e, "display")),
                          fe([e]))),
                    ("inline" === u || ("inline-block" === u && null != c)) &&
                      "none" === S.css(e, "float") &&
                      (l ||
                        (p.done(function () {
                          h.display = c;
                        }),
                        null == c &&
                          ((u = h.display), (c = "none" === u ? "" : u))),
                      (h.display = "inline-block"))),
                  n.overflow &&
                    ((h.overflow = "hidden"),
                    p.always(function () {
                      (h.overflow = n.overflow[0]),
                        (h.overflowX = n.overflow[1]),
                        (h.overflowY = n.overflow[2]);
                    })),
                  (l = !1),
                  f))
                    l ||
                      (g
                        ? "hidden" in g && (m = g.hidden)
                        : (g = Q.access(e, "fxshow", { display: c })),
                      o && (g.hidden = !m),
                      m && fe([e], !0),
                      p.done(function () {
                        for (i in (m || fe([e]), Q.remove(e, "fxshow"), f))
                          S.style(e, i, f[i]);
                      })),
                      (l = dt(m ? g[i] : 0, i, p)),
                      i in g ||
                        ((g[i] = l.start),
                        m && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (e, t) {
              t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
            },
          })),
            (S.speed = function (e, t, n) {
              var i =
                e && "object" == typeof e
                  ? S.extend({}, e)
                  : {
                      complete: n || (!n && t) || (v(e) && e),
                      duration: e,
                      easing: (n && t) || (t && !v(t) && t),
                    };
              return (
                S.fx.off
                  ? (i.duration = 0)
                  : "number" != typeof i.duration &&
                    (i.duration in S.fx.speeds
                      ? (i.duration = S.fx.speeds[i.duration])
                      : (i.duration = S.fx.speeds._default)),
                (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                (i.old = i.complete),
                (i.complete = function () {
                  v(i.old) && i.old.call(this),
                    i.queue && S.dequeue(this, i.queue);
                }),
                i
              );
            }),
            S.fn.extend({
              fadeTo: function (e, t, n, i) {
                return this.filter(ce)
                  .css("opacity", 0)
                  .show()
                  .end()
                  .animate({ opacity: t }, e, n, i);
              },
              animate: function (e, t, n, i) {
                var r = S.isEmptyObject(e),
                  o = S.speed(t, n, i),
                  a = function () {
                    var t = pt(this, S.extend({}, e), o);
                    (r || Q.get(this, "finish")) && t.stop(!0);
                  };
                return (
                  (a.finish = a),
                  r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
                );
              },
              stop: function (e, t, n) {
                var i = function (e) {
                  var t = e.stop;
                  delete e.stop, t(n);
                };
                return (
                  "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                  t && this.queue(e || "fx", []),
                  this.each(function () {
                    var t = !0,
                      r = null != e && e + "queueHooks",
                      o = S.timers,
                      a = Q.get(this);
                    if (r) a[r] && a[r].stop && i(a[r]);
                    else
                      for (r in a) a[r] && a[r].stop && st.test(r) && i(a[r]);
                    for (r = o.length; r--; )
                      o[r].elem !== this ||
                        (null != e && o[r].queue !== e) ||
                        (o[r].anim.stop(n), (t = !1), o.splice(r, 1));
                    (!t && n) || S.dequeue(this, e);
                  })
                );
              },
              finish: function (e) {
                return (
                  !1 !== e && (e = e || "fx"),
                  this.each(function () {
                    var t,
                      n = Q.get(this),
                      i = n[e + "queue"],
                      r = n[e + "queueHooks"],
                      o = S.timers,
                      a = i ? i.length : 0;
                    for (
                      n.finish = !0,
                        S.queue(this, e, []),
                        r && r.stop && r.stop.call(this, !0),
                        t = o.length;
                      t--;

                    )
                      o[t].elem === this &&
                        o[t].queue === e &&
                        (o[t].anim.stop(!0), o.splice(t, 1));
                    for (t = 0; t < a; t++)
                      i[t] && i[t].finish && i[t].finish.call(this);
                    delete n.finish;
                  })
                );
              },
            }),
            S.each(["toggle", "show", "hide"], function (e, t) {
              var n = S.fn[t];
              S.fn[t] = function (e, i, r) {
                return null == e || "boolean" == typeof e
                  ? n.apply(this, arguments)
                  : this.animate(ut(t, !0), e, i, r);
              };
            }),
            S.each(
              {
                slideDown: ut("show"),
                slideUp: ut("hide"),
                slideToggle: ut("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
              },
              function (e, t) {
                S.fn[e] = function (e, n, i) {
                  return this.animate(t, e, n, i);
                };
              }
            ),
            (S.timers = []),
            (S.fx.tick = function () {
              var e,
                t = 0,
                n = S.timers;
              for (rt = Date.now(); t < n.length; t++)
                (e = n[t])() || n[t] !== e || n.splice(t--, 1);
              n.length || S.fx.stop(), (rt = void 0);
            }),
            (S.fx.timer = function (e) {
              S.timers.push(e), S.fx.start();
            }),
            (S.fx.interval = 13),
            (S.fx.start = function () {
              ot || ((ot = !0), lt());
            }),
            (S.fx.stop = function () {
              ot = null;
            }),
            (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (S.fn.delay = function (e, t) {
              return (
                (e = (S.fx && S.fx.speeds[e]) || e),
                (t = t || "fx"),
                this.queue(t, function (t, n) {
                  var r = i.setTimeout(t, e);
                  n.stop = function () {
                    i.clearTimeout(r);
                  };
                })
              );
            }),
            (function () {
              var e = b.createElement("input"),
                t = b
                  .createElement("select")
                  .appendChild(b.createElement("option"));
              (e.type = "checkbox"),
                (g.checkOn = "" !== e.value),
                (g.optSelected = t.selected),
                ((e = b.createElement("input")).value = "t"),
                (e.type = "radio"),
                (g.radioValue = "t" === e.value);
            })();
          var ft,
            ht = S.expr.attrHandle;
          S.fn.extend({
            attr: function (e, t) {
              return G(this, S.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
              return this.each(function () {
                S.removeAttr(this, e);
              });
            },
          }),
            S.extend({
              attr: function (e, t, n) {
                var i,
                  r,
                  o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === e.getAttribute
                    ? S.prop(e, t, n)
                    : ((1 === o && S.isXMLDoc(e)) ||
                        (r =
                          S.attrHooks[t.toLowerCase()] ||
                          (S.expr.match.bool.test(t) ? ft : void 0)),
                      void 0 !== n
                        ? null === n
                          ? void S.removeAttr(e, t)
                          : r && "set" in r && void 0 !== (i = r.set(e, n, t))
                          ? i
                          : (e.setAttribute(t, n + ""), n)
                        : r && "get" in r && null !== (i = r.get(e, t))
                        ? i
                        : null == (i = S.find.attr(e, t))
                        ? void 0
                        : i);
              },
              attrHooks: {
                type: {
                  set: function (e, t) {
                    if (!g.radioValue && "radio" === t && M(e, "input")) {
                      var n = e.value;
                      return e.setAttribute("type", t), n && (e.value = n), t;
                    }
                  },
                },
              },
              removeAttr: function (e, t) {
                var n,
                  i = 0,
                  r = t && t.match($);
                if (r && 1 === e.nodeType)
                  for (; (n = r[i++]); ) e.removeAttribute(n);
              },
            }),
            (ft = {
              set: function (e, t, n) {
                return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
              },
            }),
            S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
              var n = ht[t] || S.find.attr;
              ht[t] = function (e, t, i) {
                var r,
                  o,
                  a = t.toLowerCase();
                return (
                  i ||
                    ((o = ht[a]),
                    (ht[a] = r),
                    (r = null != n(e, t, i) ? a : null),
                    (ht[a] = o)),
                  r
                );
              };
            });
          var mt = /^(?:input|select|textarea|button)$/i,
            gt = /^(?:a|area)$/i;
          function vt(e) {
            return (e.match($) || []).join(" ");
          }
          function yt(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
          }
          function bt(e) {
            return Array.isArray(e)
              ? e
              : ("string" == typeof e && e.match($)) || [];
          }
          S.fn.extend({
            prop: function (e, t) {
              return G(this, S.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
              return this.each(function () {
                delete this[S.propFix[e] || e];
              });
            },
          }),
            S.extend({
              prop: function (e, t, n) {
                var i,
                  r,
                  o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return (
                    (1 === o && S.isXMLDoc(e)) ||
                      ((t = S.propFix[t] || t), (r = S.propHooks[t])),
                    void 0 !== n
                      ? r && "set" in r && void 0 !== (i = r.set(e, n, t))
                        ? i
                        : (e[t] = n)
                      : r && "get" in r && null !== (i = r.get(e, t))
                      ? i
                      : e[t]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (e) {
                    var t = S.find.attr(e, "tabindex");
                    return t
                      ? parseInt(t, 10)
                      : mt.test(e.nodeName) || (gt.test(e.nodeName) && e.href)
                      ? 0
                      : -1;
                  },
                },
              },
              propFix: { for: "htmlFor", class: "className" },
            }),
            g.optSelected ||
              (S.propHooks.selected = {
                get: function (e) {
                  var t = e.parentNode;
                  return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                  var t = e.parentNode;
                  t &&
                    (t.selectedIndex,
                    t.parentNode && t.parentNode.selectedIndex);
                },
              }),
            S.each(
              [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
              ],
              function () {
                S.propFix[this.toLowerCase()] = this;
              }
            ),
            S.fn.extend({
              addClass: function (e) {
                var t,
                  n,
                  i,
                  r,
                  o,
                  a,
                  s,
                  l = 0;
                if (v(e))
                  return this.each(function (t) {
                    S(this).addClass(e.call(this, t, yt(this)));
                  });
                if ((t = bt(e)).length)
                  for (; (n = this[l++]); )
                    if (
                      ((r = yt(n)), (i = 1 === n.nodeType && " " + vt(r) + " "))
                    ) {
                      for (a = 0; (o = t[a++]); )
                        i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                      r !== (s = vt(i)) && n.setAttribute("class", s);
                    }
                return this;
              },
              removeClass: function (e) {
                var t,
                  n,
                  i,
                  r,
                  o,
                  a,
                  s,
                  l = 0;
                if (v(e))
                  return this.each(function (t) {
                    S(this).removeClass(e.call(this, t, yt(this)));
                  });
                if (!arguments.length) return this.attr("class", "");
                if ((t = bt(e)).length)
                  for (; (n = this[l++]); )
                    if (
                      ((r = yt(n)), (i = 1 === n.nodeType && " " + vt(r) + " "))
                    ) {
                      for (a = 0; (o = t[a++]); )
                        for (; i.indexOf(" " + o + " ") > -1; )
                          i = i.replace(" " + o + " ", " ");
                      r !== (s = vt(i)) && n.setAttribute("class", s);
                    }
                return this;
              },
              toggleClass: function (e, t) {
                var n = typeof e,
                  i = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && i
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : v(e)
                  ? this.each(function (n) {
                      S(this).toggleClass(e.call(this, n, yt(this), t), t);
                    })
                  : this.each(function () {
                      var t, r, o, a;
                      if (i)
                        for (r = 0, o = S(this), a = bt(e); (t = a[r++]); )
                          o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                      else
                        (void 0 !== e && "boolean" !== n) ||
                          ((t = yt(this)) && Q.set(this, "__className__", t),
                          this.setAttribute &&
                            this.setAttribute(
                              "class",
                              t || !1 === e
                                ? ""
                                : Q.get(this, "__className__") || ""
                            ));
                    });
              },
              hasClass: function (e) {
                var t,
                  n,
                  i = 0;
                for (t = " " + e + " "; (n = this[i++]); )
                  if (
                    1 === n.nodeType &&
                    (" " + vt(yt(n)) + " ").indexOf(t) > -1
                  )
                    return !0;
                return !1;
              },
            });
          var wt = /\r/g;
          S.fn.extend({
            val: function (e) {
              var t,
                n,
                i,
                r = this[0];
              return arguments.length
                ? ((i = v(e)),
                  this.each(function (n) {
                    var r;
                    1 === this.nodeType &&
                      (null == (r = i ? e.call(this, n, S(this).val()) : e)
                        ? (r = "")
                        : "number" == typeof r
                        ? (r += "")
                        : Array.isArray(r) &&
                          (r = S.map(r, function (e) {
                            return null == e ? "" : e + "";
                          })),
                      ((t =
                        S.valHooks[this.type] ||
                        S.valHooks[this.nodeName.toLowerCase()]) &&
                        "set" in t &&
                        void 0 !== t.set(this, r, "value")) ||
                        (this.value = r));
                  }))
                : r
                ? (t =
                    S.valHooks[r.type] ||
                    S.valHooks[r.nodeName.toLowerCase()]) &&
                  "get" in t &&
                  void 0 !== (n = t.get(r, "value"))
                  ? n
                  : "string" == typeof (n = r.value)
                  ? n.replace(wt, "")
                  : null == n
                  ? ""
                  : n
                : void 0;
            },
          }),
            S.extend({
              valHooks: {
                option: {
                  get: function (e) {
                    var t = S.find.attr(e, "value");
                    return null != t ? t : vt(S.text(e));
                  },
                },
                select: {
                  get: function (e) {
                    var t,
                      n,
                      i,
                      r = e.options,
                      o = e.selectedIndex,
                      a = "select-one" === e.type,
                      s = a ? null : [],
                      l = a ? o + 1 : r.length;
                    for (i = o < 0 ? l : a ? o : 0; i < l; i++)
                      if (
                        ((n = r[i]).selected || i === o) &&
                        !n.disabled &&
                        (!n.parentNode.disabled || !M(n.parentNode, "optgroup"))
                      ) {
                        if (((t = S(n).val()), a)) return t;
                        s.push(t);
                      }
                    return s;
                  },
                  set: function (e, t) {
                    for (
                      var n, i, r = e.options, o = S.makeArray(t), a = r.length;
                      a--;

                    )
                      ((i = r[a]).selected =
                        S.inArray(S.valHooks.option.get(i), o) > -1) &&
                        (n = !0);
                    return n || (e.selectedIndex = -1), o;
                  },
                },
              },
            }),
            S.each(["radio", "checkbox"], function () {
              (S.valHooks[this] = {
                set: function (e, t) {
                  if (Array.isArray(t))
                    return (e.checked = S.inArray(S(e).val(), t) > -1);
                },
              }),
                g.checkOn ||
                  (S.valHooks[this].get = function (e) {
                    return null === e.getAttribute("value") ? "on" : e.value;
                  });
            }),
            (g.focusin = "onfocusin" in i);
          var xt = /^(?:focusinfocus|focusoutblur)$/,
            Ct = function (e) {
              e.stopPropagation();
            };
          S.extend(S.event, {
            trigger: function (e, t, n, r) {
              var o,
                a,
                s,
                l,
                c,
                u,
                d,
                p,
                h = [n || b],
                m = f.call(e, "type") ? e.type : e,
                g = f.call(e, "namespace") ? e.namespace.split(".") : [];
              if (
                ((a = p = s = n = n || b),
                3 !== n.nodeType &&
                  8 !== n.nodeType &&
                  !xt.test(m + S.event.triggered) &&
                  (m.indexOf(".") > -1 &&
                    ((g = m.split(".")), (m = g.shift()), g.sort()),
                  (c = m.indexOf(":") < 0 && "on" + m),
                  ((e = e[S.expando]
                    ? e
                    : new S.Event(m, "object" == typeof e && e)).isTrigger = r
                    ? 2
                    : 3),
                  (e.namespace = g.join(".")),
                  (e.rnamespace = e.namespace
                    ? new RegExp(
                        "(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"
                      )
                    : null),
                  (e.result = void 0),
                  e.target || (e.target = n),
                  (t = null == t ? [e] : S.makeArray(t, [e])),
                  (d = S.event.special[m] || {}),
                  r || !d.trigger || !1 !== d.trigger.apply(n, t)))
              ) {
                if (!r && !d.noBubble && !y(n)) {
                  for (
                    l = d.delegateType || m,
                      xt.test(l + m) || (a = a.parentNode);
                    a;
                    a = a.parentNode
                  )
                    h.push(a), (s = a);
                  s === (n.ownerDocument || b) &&
                    h.push(s.defaultView || s.parentWindow || i);
                }
                for (o = 0; (a = h[o++]) && !e.isPropagationStopped(); )
                  (p = a),
                    (e.type = o > 1 ? l : d.bindType || m),
                    (u =
                      (Q.get(a, "events") || Object.create(null))[e.type] &&
                      Q.get(a, "handle")) && u.apply(a, t),
                    (u = c && a[c]) &&
                      u.apply &&
                      K(a) &&
                      ((e.result = u.apply(a, t)),
                      !1 === e.result && e.preventDefault());
                return (
                  (e.type = m),
                  r ||
                    e.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(h.pop(), t)) ||
                    !K(n) ||
                    (c &&
                      v(n[m]) &&
                      !y(n) &&
                      ((s = n[c]) && (n[c] = null),
                      (S.event.triggered = m),
                      e.isPropagationStopped() && p.addEventListener(m, Ct),
                      n[m](),
                      e.isPropagationStopped() && p.removeEventListener(m, Ct),
                      (S.event.triggered = void 0),
                      s && (n[c] = s))),
                  e.result
                );
              }
            },
            simulate: function (e, t, n) {
              var i = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
              S.event.trigger(i, null, t);
            },
          }),
            S.fn.extend({
              trigger: function (e, t) {
                return this.each(function () {
                  S.event.trigger(e, t, this);
                });
              },
              triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return S.event.trigger(e, t, n, !0);
              },
            }),
            g.focusin ||
              S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                  S.event.simulate(t, e.target, S.event.fix(e));
                };
                S.event.special[t] = {
                  setup: function () {
                    var i = this.ownerDocument || this.document || this,
                      r = Q.access(i, t);
                    r || i.addEventListener(e, n, !0),
                      Q.access(i, t, (r || 0) + 1);
                  },
                  teardown: function () {
                    var i = this.ownerDocument || this.document || this,
                      r = Q.access(i, t) - 1;
                    r
                      ? Q.access(i, t, r)
                      : (i.removeEventListener(e, n, !0), Q.remove(i, t));
                  },
                };
              });
          var Tt = i.location,
            St = { guid: Date.now() },
            Et = /\?/;
          S.parseXML = function (e) {
            var t, n;
            if (!e || "string" != typeof e) return null;
            try {
              t = new i.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {}
            return (
              (n = t && t.getElementsByTagName("parsererror")[0]),
              (t && !n) ||
                S.error(
                  "Invalid XML: " +
                    (n
                      ? S.map(n.childNodes, function (e) {
                          return e.textContent;
                        }).join("\n")
                      : e)
                ),
              t
            );
          };
          var kt = /\[\]$/,
            Lt = /\r?\n/g,
            Pt = /^(?:submit|button|image|reset|file)$/i,
            Ot = /^(?:input|select|textarea|keygen)/i;
          function Mt(e, t, n, i) {
            var r;
            if (Array.isArray(t))
              S.each(t, function (t, r) {
                n || kt.test(e)
                  ? i(e, r)
                  : Mt(
                      e +
                        "[" +
                        ("object" == typeof r && null != r ? t : "") +
                        "]",
                      r,
                      n,
                      i
                    );
              });
            else if (n || "object" !== C(t)) i(e, t);
            else for (r in t) Mt(e + "[" + r + "]", t[r], n, i);
          }
          (S.param = function (e, t) {
            var n,
              i = [],
              r = function (e, t) {
                var n = v(t) ? t() : t;
                i[i.length] =
                  encodeURIComponent(e) +
                  "=" +
                  encodeURIComponent(null == n ? "" : n);
              };
            if (null == e) return "";
            if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
              S.each(e, function () {
                r(this.name, this.value);
              });
            else for (n in e) Mt(n, e[n], t, r);
            return i.join("&");
          }),
            S.fn.extend({
              serialize: function () {
                return S.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var e = S.prop(this, "elements");
                  return e ? S.makeArray(e) : this;
                })
                  .filter(function () {
                    var e = this.type;
                    return (
                      this.name &&
                      !S(this).is(":disabled") &&
                      Ot.test(this.nodeName) &&
                      !Pt.test(e) &&
                      (this.checked || !ge.test(e))
                    );
                  })
                  .map(function (e, t) {
                    var n = S(this).val();
                    return null == n
                      ? null
                      : Array.isArray(n)
                      ? S.map(n, function (e) {
                          return { name: t.name, value: e.replace(Lt, "\r\n") };
                        })
                      : { name: t.name, value: n.replace(Lt, "\r\n") };
                  })
                  .get();
              },
            });
          var At = /%20/g,
            It = /#.*$/,
            jt = /([?&])_=[^&]*/,
            _t = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Dt = /^(?:GET|HEAD)$/,
            Nt = /^\/\//,
            qt = {},
            $t = {},
            zt = "*/".concat("*"),
            Ht = b.createElement("a");
          function Bt(e) {
            return function (t, n) {
              "string" != typeof t && ((n = t), (t = "*"));
              var i,
                r = 0,
                o = t.toLowerCase().match($) || [];
              if (v(n))
                for (; (i = o[r++]); )
                  "+" === i[0]
                    ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
                    : (e[i] = e[i] || []).push(n);
            };
          }
          function Ft(e, t, n, i) {
            var r = {},
              o = e === $t;
            function a(s) {
              var l;
              return (
                (r[s] = !0),
                S.each(e[s] || [], function (e, s) {
                  var c = s(t, n, i);
                  return "string" != typeof c || o || r[c]
                    ? o
                      ? !(l = c)
                      : void 0
                    : (t.dataTypes.unshift(c), a(c), !1);
                }),
                l
              );
            }
            return a(t.dataTypes[0]) || (!r["*"] && a("*"));
          }
          function Rt(e, t) {
            var n,
              i,
              r = S.ajaxSettings.flatOptions || {};
            for (n in t)
              void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
            return i && S.extend(!0, e, i), e;
          }
          (Ht.href = Tt.href),
            S.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: Tt.href,
                type: "GET",
                isLocal:
                  /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                    Tt.protocol
                  ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                  "*": zt,
                  text: "text/plain",
                  html: "text/html",
                  xml: "application/xml, text/xml",
                  json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                  xml: "responseXML",
                  text: "responseText",
                  json: "responseJSON",
                },
                converters: {
                  "* text": String,
                  "text html": !0,
                  "text json": JSON.parse,
                  "text xml": S.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (e, t) {
                return t ? Rt(Rt(e, S.ajaxSettings), t) : Rt(S.ajaxSettings, e);
              },
              ajaxPrefilter: Bt(qt),
              ajaxTransport: Bt($t),
              ajax: function (e, t) {
                "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                var n,
                  r,
                  o,
                  a,
                  s,
                  l,
                  c,
                  u,
                  d,
                  p,
                  f = S.ajaxSetup({}, t),
                  h = f.context || f,
                  m = f.context && (h.nodeType || h.jquery) ? S(h) : S.event,
                  g = S.Deferred(),
                  v = S.Callbacks("once memory"),
                  y = f.statusCode || {},
                  w = {},
                  x = {},
                  C = "canceled",
                  T = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                      var t;
                      if (c) {
                        if (!a)
                          for (a = {}; (t = _t.exec(o)); )
                            a[t[1].toLowerCase() + " "] = (
                              a[t[1].toLowerCase() + " "] || []
                            ).concat(t[2]);
                        t = a[e.toLowerCase() + " "];
                      }
                      return null == t ? null : t.join(", ");
                    },
                    getAllResponseHeaders: function () {
                      return c ? o : null;
                    },
                    setRequestHeader: function (e, t) {
                      return (
                        null == c &&
                          ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e),
                          (w[e] = t)),
                        this
                      );
                    },
                    overrideMimeType: function (e) {
                      return null == c && (f.mimeType = e), this;
                    },
                    statusCode: function (e) {
                      var t;
                      if (e)
                        if (c) T.always(e[T.status]);
                        else for (t in e) y[t] = [y[t], e[t]];
                      return this;
                    },
                    abort: function (e) {
                      var t = e || C;
                      return n && n.abort(t), E(0, t), this;
                    },
                  };
                if (
                  (g.promise(T),
                  (f.url = ((e || f.url || Tt.href) + "").replace(
                    Nt,
                    Tt.protocol + "//"
                  )),
                  (f.type = t.method || t.type || f.method || f.type),
                  (f.dataTypes = (f.dataType || "*").toLowerCase().match($) || [
                    "",
                  ]),
                  null == f.crossDomain)
                ) {
                  l = b.createElement("a");
                  try {
                    (l.href = f.url),
                      (l.href = l.href),
                      (f.crossDomain =
                        Ht.protocol + "//" + Ht.host !=
                        l.protocol + "//" + l.host);
                  } catch (e) {
                    f.crossDomain = !0;
                  }
                }
                if (
                  (f.data &&
                    f.processData &&
                    "string" != typeof f.data &&
                    (f.data = S.param(f.data, f.traditional)),
                  Ft(qt, f, t, T),
                  c)
                )
                  return T;
                for (d in ((u = S.event && f.global) &&
                  0 == S.active++ &&
                  S.event.trigger("ajaxStart"),
                (f.type = f.type.toUpperCase()),
                (f.hasContent = !Dt.test(f.type)),
                (r = f.url.replace(It, "")),
                f.hasContent
                  ? f.data &&
                    f.processData &&
                    0 ===
                      (f.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) &&
                    (f.data = f.data.replace(At, "+"))
                  : ((p = f.url.slice(r.length)),
                    f.data &&
                      (f.processData || "string" == typeof f.data) &&
                      ((r += (Et.test(r) ? "&" : "?") + f.data), delete f.data),
                    !1 === f.cache &&
                      ((r = r.replace(jt, "$1")),
                      (p = (Et.test(r) ? "&" : "?") + "_=" + St.guid++ + p)),
                    (f.url = r + p)),
                f.ifModified &&
                  (S.lastModified[r] &&
                    T.setRequestHeader("If-Modified-Since", S.lastModified[r]),
                  S.etag[r] && T.setRequestHeader("If-None-Match", S.etag[r])),
                ((f.data && f.hasContent && !1 !== f.contentType) ||
                  t.contentType) &&
                  T.setRequestHeader("Content-Type", f.contentType),
                T.setRequestHeader(
                  "Accept",
                  f.dataTypes[0] && f.accepts[f.dataTypes[0]]
                    ? f.accepts[f.dataTypes[0]] +
                        ("*" !== f.dataTypes[0] ? ", " + zt + "; q=0.01" : "")
                    : f.accepts["*"]
                ),
                f.headers))
                  T.setRequestHeader(d, f.headers[d]);
                if (f.beforeSend && (!1 === f.beforeSend.call(h, T, f) || c))
                  return T.abort();
                if (
                  ((C = "abort"),
                  v.add(f.complete),
                  T.done(f.success),
                  T.fail(f.error),
                  (n = Ft($t, f, t, T)))
                ) {
                  if (
                    ((T.readyState = 1), u && m.trigger("ajaxSend", [T, f]), c)
                  )
                    return T;
                  f.async &&
                    f.timeout > 0 &&
                    (s = i.setTimeout(function () {
                      T.abort("timeout");
                    }, f.timeout));
                  try {
                    (c = !1), n.send(w, E);
                  } catch (e) {
                    if (c) throw e;
                    E(-1, e);
                  }
                } else E(-1, "No Transport");
                function E(e, t, a, l) {
                  var d,
                    p,
                    b,
                    w,
                    x,
                    C = t;
                  c ||
                    ((c = !0),
                    s && i.clearTimeout(s),
                    (n = void 0),
                    (o = l || ""),
                    (T.readyState = e > 0 ? 4 : 0),
                    (d = (e >= 200 && e < 300) || 304 === e),
                    a &&
                      (w = (function (e, t, n) {
                        for (
                          var i, r, o, a, s = e.contents, l = e.dataTypes;
                          "*" === l[0];

                        )
                          l.shift(),
                            void 0 === i &&
                              (i =
                                e.mimeType ||
                                t.getResponseHeader("Content-Type"));
                        if (i)
                          for (r in s)
                            if (s[r] && s[r].test(i)) {
                              l.unshift(r);
                              break;
                            }
                        if (l[0] in n) o = l[0];
                        else {
                          for (r in n) {
                            if (!l[0] || e.converters[r + " " + l[0]]) {
                              o = r;
                              break;
                            }
                            a || (a = r);
                          }
                          o = o || a;
                        }
                        if (o) return o !== l[0] && l.unshift(o), n[o];
                      })(f, T, a)),
                    !d &&
                      S.inArray("script", f.dataTypes) > -1 &&
                      S.inArray("json", f.dataTypes) < 0 &&
                      (f.converters["text script"] = function () {}),
                    (w = (function (e, t, n, i) {
                      var r,
                        o,
                        a,
                        s,
                        l,
                        c = {},
                        u = e.dataTypes.slice();
                      if (u[1])
                        for (a in e.converters)
                          c[a.toLowerCase()] = e.converters[a];
                      for (o = u.shift(); o; )
                        if (
                          (e.responseFields[o] && (n[e.responseFields[o]] = t),
                          !l &&
                            i &&
                            e.dataFilter &&
                            (t = e.dataFilter(t, e.dataType)),
                          (l = o),
                          (o = u.shift()))
                        )
                          if ("*" === o) o = l;
                          else if ("*" !== l && l !== o) {
                            if (!(a = c[l + " " + o] || c["* " + o]))
                              for (r in c)
                                if (
                                  (s = r.split(" "))[1] === o &&
                                  (a = c[l + " " + s[0]] || c["* " + s[0]])
                                ) {
                                  !0 === a
                                    ? (a = c[r])
                                    : !0 !== c[r] &&
                                      ((o = s[0]), u.unshift(s[1]));
                                  break;
                                }
                            if (!0 !== a)
                              if (a && e.throws) t = a(t);
                              else
                                try {
                                  t = a(t);
                                } catch (e) {
                                  return {
                                    state: "parsererror",
                                    error: a
                                      ? e
                                      : "No conversion from " + l + " to " + o,
                                  };
                                }
                          }
                      return { state: "success", data: t };
                    })(f, w, T, d)),
                    d
                      ? (f.ifModified &&
                          ((x = T.getResponseHeader("Last-Modified")) &&
                            (S.lastModified[r] = x),
                          (x = T.getResponseHeader("etag")) && (S.etag[r] = x)),
                        204 === e || "HEAD" === f.type
                          ? (C = "nocontent")
                          : 304 === e
                          ? (C = "notmodified")
                          : ((C = w.state), (p = w.data), (d = !(b = w.error))))
                      : ((b = C),
                        (!e && C) || ((C = "error"), e < 0 && (e = 0))),
                    (T.status = e),
                    (T.statusText = (t || C) + ""),
                    d
                      ? g.resolveWith(h, [p, C, T])
                      : g.rejectWith(h, [T, C, b]),
                    T.statusCode(y),
                    (y = void 0),
                    u &&
                      m.trigger(d ? "ajaxSuccess" : "ajaxError", [
                        T,
                        f,
                        d ? p : b,
                      ]),
                    v.fireWith(h, [T, C]),
                    u &&
                      (m.trigger("ajaxComplete", [T, f]),
                      --S.active || S.event.trigger("ajaxStop")));
                }
                return T;
              },
              getJSON: function (e, t, n) {
                return S.get(e, t, n, "json");
              },
              getScript: function (e, t) {
                return S.get(e, void 0, t, "script");
              },
            }),
            S.each(["get", "post"], function (e, t) {
              S[t] = function (e, n, i, r) {
                return (
                  v(n) && ((r = r || i), (i = n), (n = void 0)),
                  S.ajax(
                    S.extend(
                      { url: e, type: t, dataType: r, data: n, success: i },
                      S.isPlainObject(e) && e
                    )
                  )
                );
              };
            }),
            S.ajaxPrefilter(function (e) {
              var t;
              for (t in e.headers)
                "content-type" === t.toLowerCase() &&
                  (e.contentType = e.headers[t] || "");
            }),
            (S._evalUrl = function (e, t, n) {
              return S.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                  S.globalEval(e, t, n);
                },
              });
            }),
            S.fn.extend({
              wrapAll: function (e) {
                var t;
                return (
                  this[0] &&
                    (v(e) && (e = e.call(this[0])),
                    (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && t.insertBefore(this[0]),
                    t
                      .map(function () {
                        for (var e = this; e.firstElementChild; )
                          e = e.firstElementChild;
                        return e;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (e) {
                return v(e)
                  ? this.each(function (t) {
                      S(this).wrapInner(e.call(this, t));
                    })
                  : this.each(function () {
                      var t = S(this),
                        n = t.contents();
                      n.length ? n.wrapAll(e) : t.append(e);
                    });
              },
              wrap: function (e) {
                var t = v(e);
                return this.each(function (n) {
                  S(this).wrapAll(t ? e.call(this, n) : e);
                });
              },
              unwrap: function (e) {
                return (
                  this.parent(e)
                    .not("body")
                    .each(function () {
                      S(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (S.expr.pseudos.hidden = function (e) {
              return !S.expr.pseudos.visible(e);
            }),
            (S.expr.pseudos.visible = function (e) {
              return !!(
                e.offsetWidth ||
                e.offsetHeight ||
                e.getClientRects().length
              );
            }),
            (S.ajaxSettings.xhr = function () {
              try {
                return new i.XMLHttpRequest();
              } catch (e) {}
            });
          var Wt = { 0: 200, 1223: 204 },
            Gt = S.ajaxSettings.xhr();
          (g.cors = !!Gt && "withCredentials" in Gt),
            (g.ajax = Gt = !!Gt),
            S.ajaxTransport(function (e) {
              var t, n;
              if (g.cors || (Gt && !e.crossDomain))
                return {
                  send: function (r, o) {
                    var a,
                      s = e.xhr();
                    if (
                      (s.open(e.type, e.url, e.async, e.username, e.password),
                      e.xhrFields)
                    )
                      for (a in e.xhrFields) s[a] = e.xhrFields[a];
                    for (a in (e.mimeType &&
                      s.overrideMimeType &&
                      s.overrideMimeType(e.mimeType),
                    e.crossDomain ||
                      r["X-Requested-With"] ||
                      (r["X-Requested-With"] = "XMLHttpRequest"),
                    r))
                      s.setRequestHeader(a, r[a]);
                    (t = function (e) {
                      return function () {
                        t &&
                          ((t =
                            n =
                            s.onload =
                            s.onerror =
                            s.onabort =
                            s.ontimeout =
                            s.onreadystatechange =
                              null),
                          "abort" === e
                            ? s.abort()
                            : "error" === e
                            ? "number" != typeof s.status
                              ? o(0, "error")
                              : o(s.status, s.statusText)
                            : o(
                                Wt[s.status] || s.status,
                                s.statusText,
                                "text" !== (s.responseType || "text") ||
                                  "string" != typeof s.responseText
                                  ? { binary: s.response }
                                  : { text: s.responseText },
                                s.getAllResponseHeaders()
                              ));
                      };
                    }),
                      (s.onload = t()),
                      (n = s.onerror = s.ontimeout = t("error")),
                      void 0 !== s.onabort
                        ? (s.onabort = n)
                        : (s.onreadystatechange = function () {
                            4 === s.readyState &&
                              i.setTimeout(function () {
                                t && n();
                              });
                          }),
                      (t = t("abort"));
                    try {
                      s.send((e.hasContent && e.data) || null);
                    } catch (e) {
                      if (t) throw e;
                    }
                  },
                  abort: function () {
                    t && t();
                  },
                };
            }),
            S.ajaxPrefilter(function (e) {
              e.crossDomain && (e.contents.script = !1);
            }),
            S.ajaxSetup({
              accepts: {
                script:
                  "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                "text script": function (e) {
                  return S.globalEval(e), e;
                },
              },
            }),
            S.ajaxPrefilter("script", function (e) {
              void 0 === e.cache && (e.cache = !1),
                e.crossDomain && (e.type = "GET");
            }),
            S.ajaxTransport("script", function (e) {
              var t, n;
              if (e.crossDomain || e.scriptAttrs)
                return {
                  send: function (i, r) {
                    (t = S("<script>")
                      .attr(e.scriptAttrs || {})
                      .prop({ charset: e.scriptCharset, src: e.url })
                      .on(
                        "load error",
                        (n = function (e) {
                          t.remove(),
                            (n = null),
                            e && r("error" === e.type ? 404 : 200, e.type);
                        })
                      )),
                      b.head.appendChild(t[0]);
                  },
                  abort: function () {
                    n && n();
                  },
                };
            });
          var Vt,
            Xt = [],
            Yt = /(=)\?(?=&|$)|\?\?/;
          S.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var e = Xt.pop() || S.expando + "_" + St.guid++;
              return (this[e] = !0), e;
            },
          }),
            S.ajaxPrefilter("json jsonp", function (e, t, n) {
              var r,
                o,
                a,
                s =
                  !1 !== e.jsonp &&
                  (Yt.test(e.url)
                    ? "url"
                    : "string" == typeof e.data &&
                      0 ===
                        (e.contentType || "").indexOf(
                          "application/x-www-form-urlencoded"
                        ) &&
                      Yt.test(e.data) &&
                      "data");
              if (s || "jsonp" === e.dataTypes[0])
                return (
                  (r = e.jsonpCallback =
                    v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                  s
                    ? (e[s] = e[s].replace(Yt, "$1" + r))
                    : !1 !== e.jsonp &&
                      (e.url +=
                        (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
                  (e.converters["script json"] = function () {
                    return a || S.error(r + " was not called"), a[0];
                  }),
                  (e.dataTypes[0] = "json"),
                  (o = i[r]),
                  (i[r] = function () {
                    a = arguments;
                  }),
                  n.always(function () {
                    void 0 === o ? S(i).removeProp(r) : (i[r] = o),
                      e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
                      a && v(o) && o(a[0]),
                      (a = o = void 0);
                  }),
                  "script"
                );
            }),
            (g.createHTMLDocument =
              (((Vt = b.implementation.createHTMLDocument("").body).innerHTML =
                "<form></form><form></form>"),
              2 === Vt.childNodes.length)),
            (S.parseHTML = function (e, t, n) {
              return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t ||
                    (g.createHTMLDocument
                      ? (((i = (t =
                          b.implementation.createHTMLDocument(
                            ""
                          )).createElement("base")).href = b.location.href),
                        t.head.appendChild(i))
                      : (t = b)),
                  (o = !n && []),
                  (r = A.exec(e))
                    ? [t.createElement(r[1])]
                    : ((r = Te([e], t, o)),
                      o && o.length && S(o).remove(),
                      S.merge([], r.childNodes)));
              var i, r, o;
            }),
            (S.fn.load = function (e, t, n) {
              var i,
                r,
                o,
                a = this,
                s = e.indexOf(" ");
              return (
                s > -1 && ((i = vt(e.slice(s))), (e = e.slice(0, s))),
                v(t)
                  ? ((n = t), (t = void 0))
                  : t && "object" == typeof t && (r = "POST"),
                a.length > 0 &&
                  S.ajax({
                    url: e,
                    type: r || "GET",
                    dataType: "html",
                    data: t,
                  })
                    .done(function (e) {
                      (o = arguments),
                        a.html(
                          i ? S("<div>").append(S.parseHTML(e)).find(i) : e
                        );
                    })
                    .always(
                      n &&
                        function (e, t) {
                          a.each(function () {
                            n.apply(this, o || [e.responseText, t, e]);
                          });
                        }
                    ),
                this
              );
            }),
            (S.expr.pseudos.animated = function (e) {
              return S.grep(S.timers, function (t) {
                return e === t.elem;
              }).length;
            }),
            (S.offset = {
              setOffset: function (e, t, n) {
                var i,
                  r,
                  o,
                  a,
                  s,
                  l,
                  c = S.css(e, "position"),
                  u = S(e),
                  d = {};
                "static" === c && (e.style.position = "relative"),
                  (s = u.offset()),
                  (o = S.css(e, "top")),
                  (l = S.css(e, "left")),
                  ("absolute" === c || "fixed" === c) &&
                  (o + l).indexOf("auto") > -1
                    ? ((a = (i = u.position()).top), (r = i.left))
                    : ((a = parseFloat(o) || 0), (r = parseFloat(l) || 0)),
                  v(t) && (t = t.call(e, n, S.extend({}, s))),
                  null != t.top && (d.top = t.top - s.top + a),
                  null != t.left && (d.left = t.left - s.left + r),
                  "using" in t ? t.using.call(e, d) : u.css(d);
              },
            }),
            S.fn.extend({
              offset: function (e) {
                if (arguments.length)
                  return void 0 === e
                    ? this
                    : this.each(function (t) {
                        S.offset.setOffset(this, e, t);
                      });
                var t,
                  n,
                  i = this[0];
                return i
                  ? i.getClientRects().length
                    ? ((t = i.getBoundingClientRect()),
                      (n = i.ownerDocument.defaultView),
                      {
                        top: t.top + n.pageYOffset,
                        left: t.left + n.pageXOffset,
                      })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var e,
                    t,
                    n,
                    i = this[0],
                    r = { top: 0, left: 0 };
                  if ("fixed" === S.css(i, "position"))
                    t = i.getBoundingClientRect();
                  else {
                    for (
                      t = this.offset(),
                        n = i.ownerDocument,
                        e = i.offsetParent || n.documentElement;
                      e &&
                      (e === n.body || e === n.documentElement) &&
                      "static" === S.css(e, "position");

                    )
                      e = e.parentNode;
                    e &&
                      e !== i &&
                      1 === e.nodeType &&
                      (((r = S(e).offset()).top += S.css(
                        e,
                        "borderTopWidth",
                        !0
                      )),
                      (r.left += S.css(e, "borderLeftWidth", !0)));
                  }
                  return {
                    top: t.top - r.top - S.css(i, "marginTop", !0),
                    left: t.left - r.left - S.css(i, "marginLeft", !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var e = this.offsetParent;
                    e && "static" === S.css(e, "position");

                  )
                    e = e.offsetParent;
                  return e || ae;
                });
              },
            }),
            S.each(
              { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
              function (e, t) {
                var n = "pageYOffset" === t;
                S.fn[e] = function (i) {
                  return G(
                    this,
                    function (e, i, r) {
                      var o;
                      if (
                        (y(e)
                          ? (o = e)
                          : 9 === e.nodeType && (o = e.defaultView),
                        void 0 === r)
                      )
                        return o ? o[t] : e[i];
                      o
                        ? o.scrollTo(
                            n ? o.pageXOffset : r,
                            n ? r : o.pageYOffset
                          )
                        : (e[i] = r);
                    },
                    e,
                    i,
                    arguments.length
                  );
                };
              }
            ),
            S.each(["top", "left"], function (e, t) {
              S.cssHooks[t] = Ge(g.pixelPosition, function (e, n) {
                if (n)
                  return (
                    (n = We(e, t)), He.test(n) ? S(e).position()[t] + "px" : n
                  );
              });
            }),
            S.each({ Height: "height", Width: "width" }, function (e, t) {
              S.each(
                { padding: "inner" + e, content: t, "": "outer" + e },
                function (n, i) {
                  S.fn[i] = function (r, o) {
                    var a = arguments.length && (n || "boolean" != typeof r),
                      s = n || (!0 === r || !0 === o ? "margin" : "border");
                    return G(
                      this,
                      function (t, n, r) {
                        var o;
                        return y(t)
                          ? 0 === i.indexOf("outer")
                            ? t["inner" + e]
                            : t.document.documentElement["client" + e]
                          : 9 === t.nodeType
                          ? ((o = t.documentElement),
                            Math.max(
                              t.body["scroll" + e],
                              o["scroll" + e],
                              t.body["offset" + e],
                              o["offset" + e],
                              o["client" + e]
                            ))
                          : void 0 === r
                          ? S.css(t, n, s)
                          : S.style(t, n, r, s);
                      },
                      t,
                      a ? r : void 0,
                      a
                    );
                  };
                }
              );
            }),
            S.each(
              [
                "ajaxStart",
                "ajaxStop",
                "ajaxComplete",
                "ajaxError",
                "ajaxSuccess",
                "ajaxSend",
              ],
              function (e, t) {
                S.fn[t] = function (e) {
                  return this.on(t, e);
                };
              }
            ),
            S.fn.extend({
              bind: function (e, t, n) {
                return this.on(e, null, t, n);
              },
              unbind: function (e, t) {
                return this.off(e, null, t);
              },
              delegate: function (e, t, n, i) {
                return this.on(t, e, n, i);
              },
              undelegate: function (e, t, n) {
                return 1 === arguments.length
                  ? this.off(e, "**")
                  : this.off(t, e || "**", n);
              },
              hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
              },
            }),
            S.each(
              "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
              ),
              function (e, t) {
                S.fn[t] = function (e, n) {
                  return arguments.length > 0
                    ? this.on(t, null, e, n)
                    : this.trigger(t);
                };
              }
            );
          var Ut = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (S.proxy = function (e, t) {
            var n, i, r;
            if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
              return (
                (i = s.call(arguments, 2)),
                (r = function () {
                  return e.apply(t || this, i.concat(s.call(arguments)));
                }),
                (r.guid = e.guid = e.guid || S.guid++),
                r
              );
          }),
            (S.holdReady = function (e) {
              e ? S.readyWait++ : S.ready(!0);
            }),
            (S.isArray = Array.isArray),
            (S.parseJSON = JSON.parse),
            (S.nodeName = M),
            (S.isFunction = v),
            (S.isWindow = y),
            (S.camelCase = U),
            (S.type = C),
            (S.now = Date.now),
            (S.isNumeric = function (e) {
              var t = S.type(e);
              return (
                ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
              );
            }),
            (S.trim = function (e) {
              return null == e ? "" : (e + "").replace(Ut, "");
            }),
            void 0 ===
              (n = function () {
                return S;
              }.apply(t, [])) || (e.exports = n);
          var Kt = i.jQuery,
            Jt = i.$;
          return (
            (S.noConflict = function (e) {
              return (
                i.$ === S && (i.$ = Jt),
                e && i.jQuery === S && (i.jQuery = Kt),
                S
              );
            }),
            void 0 === r && (i.jQuery = i.$ = S),
            S
          );
        });
      },
      729: (e, t, n) => {
        var i, r, o;
        (r = [n(755)]),
          (i = function (e) {
            var t,
              n,
              i,
              r,
              o,
              a,
              s = "Close",
              l = "BeforeClose",
              c = "MarkupParse",
              u = "Open",
              d = "Change",
              p = "mfp",
              f = ".mfp",
              h = "mfp-ready",
              m = "mfp-removing",
              g = "mfp-prevent-close",
              v = function () {},
              y = !!window.jQuery,
              b = e(window),
              w = function (e, n) {
                t.ev.on(p + e + f, n);
              },
              x = function (t, n, i, r) {
                var o = document.createElement("div");
                return (
                  (o.className = "mfp-" + t),
                  i && (o.innerHTML = i),
                  r ? n && n.appendChild(o) : ((o = e(o)), n && o.appendTo(n)),
                  o
                );
              },
              C = function (n, i) {
                t.ev.triggerHandler(p + n, i),
                  t.st.callbacks &&
                    ((n = n.charAt(0).toLowerCase() + n.slice(1)),
                    t.st.callbacks[n] &&
                      t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]));
              },
              T = function (n) {
                return (
                  (n === a && t.currTemplate.closeBtn) ||
                    ((t.currTemplate.closeBtn = e(
                      t.st.closeMarkup.replace("%title%", t.st.tClose)
                    )),
                    (a = n)),
                  t.currTemplate.closeBtn
                );
              },
              S = function () {
                e.magnificPopup.instance ||
                  ((t = new v()).init(), (e.magnificPopup.instance = t));
              };
            (v.prototype = {
              constructor: v,
              init: function () {
                var n = navigator.appVersion;
                (t.isLowIE = t.isIE8 =
                  document.all && !document.addEventListener),
                  (t.isAndroid = /android/gi.test(n)),
                  (t.isIOS = /iphone|ipad|ipod/gi.test(n)),
                  (t.supportsTransition = (function () {
                    var e = document.createElement("p").style,
                      t = ["ms", "O", "Moz", "Webkit"];
                    if (void 0 !== e.transition) return !0;
                    for (; t.length; )
                      if (t.pop() + "Transition" in e) return !0;
                    return !1;
                  })()),
                  (t.probablyMobile =
                    t.isAndroid ||
                    t.isIOS ||
                    /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                      navigator.userAgent
                    )),
                  (i = e(document)),
                  (t.popupsCache = {});
              },
              open: function (n) {
                var r;
                if (!1 === n.isObj) {
                  (t.items = n.items.toArray()), (t.index = 0);
                  var a,
                    s = n.items;
                  for (r = 0; r < s.length; r++)
                    if (((a = s[r]).parsed && (a = a.el[0]), a === n.el[0])) {
                      t.index = r;
                      break;
                    }
                } else
                  (t.items = e.isArray(n.items) ? n.items : [n.items]),
                    (t.index = n.index || 0);
                if (!t.isOpen) {
                  (t.types = []),
                    (o = ""),
                    n.mainEl && n.mainEl.length
                      ? (t.ev = n.mainEl.eq(0))
                      : (t.ev = i),
                    n.key
                      ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}),
                        (t.currTemplate = t.popupsCache[n.key]))
                      : (t.currTemplate = {}),
                    (t.st = e.extend(!0, {}, e.magnificPopup.defaults, n)),
                    (t.fixedContentPos =
                      "auto" === t.st.fixedContentPos
                        ? !t.probablyMobile
                        : t.st.fixedContentPos),
                    t.st.modal &&
                      ((t.st.closeOnContentClick = !1),
                      (t.st.closeOnBgClick = !1),
                      (t.st.showCloseBtn = !1),
                      (t.st.enableEscapeKey = !1)),
                    t.bgOverlay ||
                      ((t.bgOverlay = x("bg").on("click.mfp", function () {
                        t.close();
                      })),
                      (t.wrap = x("wrap")
                        .attr("tabindex", -1)
                        .on("click.mfp", function (e) {
                          t._checkIfClose(e.target) && t.close();
                        })),
                      (t.container = x("container", t.wrap))),
                    (t.contentContainer = x("content")),
                    t.st.preloader &&
                      (t.preloader = x(
                        "preloader",
                        t.container,
                        t.st.tLoading
                      ));
                  var l = e.magnificPopup.modules;
                  for (r = 0; r < l.length; r++) {
                    var d = l[r];
                    (d = d.charAt(0).toUpperCase() + d.slice(1)),
                      t["init" + d].call(t);
                  }
                  C("BeforeOpen"),
                    t.st.showCloseBtn &&
                      (t.st.closeBtnInside
                        ? (w(c, function (e, t, n, i) {
                            n.close_replaceWith = T(i.type);
                          }),
                          (o += " mfp-close-btn-in"))
                        : t.wrap.append(T())),
                    t.st.alignTop && (o += " mfp-align-top"),
                    t.fixedContentPos
                      ? t.wrap.css({
                          overflow: t.st.overflowY,
                          overflowX: "hidden",
                          overflowY: t.st.overflowY,
                        })
                      : t.wrap.css({
                          top: b.scrollTop(),
                          position: "absolute",
                        }),
                    (!1 === t.st.fixedBgPos ||
                      ("auto" === t.st.fixedBgPos && !t.fixedContentPos)) &&
                      t.bgOverlay.css({
                        height: i.height(),
                        position: "absolute",
                      }),
                    t.st.enableEscapeKey &&
                      i.on("keyup.mfp", function (e) {
                        27 === e.keyCode && t.close();
                      }),
                    b.on("resize.mfp", function () {
                      t.updateSize();
                    }),
                    t.st.closeOnContentClick || (o += " mfp-auto-cursor"),
                    o && t.wrap.addClass(o);
                  var p = (t.wH = b.height()),
                    f = {};
                  if (t.fixedContentPos && t._hasScrollBar(p)) {
                    var m = t._getScrollbarSize();
                    m && (f.marginRight = m);
                  }
                  t.fixedContentPos &&
                    (t.isIE7
                      ? e("body, html").css("overflow", "hidden")
                      : (f.overflow = "hidden"));
                  var g = t.st.mainClass;
                  return (
                    t.isIE7 && (g += " mfp-ie7"),
                    g && t._addClassToMFP(g),
                    t.updateItemHTML(),
                    C("BuildControls"),
                    e("html").css(f),
                    t.bgOverlay
                      .add(t.wrap)
                      .prependTo(t.st.prependTo || e(document.body)),
                    (t._lastFocusedEl = document.activeElement),
                    setTimeout(function () {
                      t.content
                        ? (t._addClassToMFP(h), t._setFocus())
                        : t.bgOverlay.addClass(h),
                        i.on("focusin.mfp", t._onFocusIn);
                    }, 16),
                    (t.isOpen = !0),
                    t.updateSize(p),
                    C(u),
                    n
                  );
                }
                t.updateItemHTML();
              },
              close: function () {
                t.isOpen &&
                  (C(l),
                  (t.isOpen = !1),
                  t.st.removalDelay && !t.isLowIE && t.supportsTransition
                    ? (t._addClassToMFP(m),
                      setTimeout(function () {
                        t._close();
                      }, t.st.removalDelay))
                    : t._close());
              },
              _close: function () {
                C(s);
                var n = "mfp-removing mfp-ready ";
                if (
                  (t.bgOverlay.detach(),
                  t.wrap.detach(),
                  t.container.empty(),
                  t.st.mainClass && (n += t.st.mainClass + " "),
                  t._removeClassFromMFP(n),
                  t.fixedContentPos)
                ) {
                  var r = { marginRight: "" };
                  t.isIE7
                    ? e("body, html").css("overflow", "")
                    : (r.overflow = ""),
                    e("html").css(r);
                }
                i.off("keyup.mfp focusin.mfp"),
                  t.ev.off(f),
                  t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                  t.bgOverlay.attr("class", "mfp-bg"),
                  t.container.attr("class", "mfp-container"),
                  !t.st.showCloseBtn ||
                    (t.st.closeBtnInside &&
                      !0 !== t.currTemplate[t.currItem.type]) ||
                    (t.currTemplate.closeBtn &&
                      t.currTemplate.closeBtn.detach()),
                  t.st.autoFocusLast &&
                    t._lastFocusedEl &&
                    e(t._lastFocusedEl).focus(),
                  (t.currItem = null),
                  (t.content = null),
                  (t.currTemplate = null),
                  (t.prevHeight = 0),
                  C("AfterClose");
              },
              updateSize: function (e) {
                if (t.isIOS) {
                  var n =
                      document.documentElement.clientWidth / window.innerWidth,
                    i = window.innerHeight * n;
                  t.wrap.css("height", i), (t.wH = i);
                } else t.wH = e || b.height();
                t.fixedContentPos || t.wrap.css("height", t.wH), C("Resize");
              },
              updateItemHTML: function () {
                var n = t.items[t.index];
                t.contentContainer.detach(),
                  t.content && t.content.detach(),
                  n.parsed || (n = t.parseEl(t.index));
                var i = n.type;
                if (
                  (C("BeforeChange", [t.currItem ? t.currItem.type : "", i]),
                  (t.currItem = n),
                  !t.currTemplate[i])
                ) {
                  var o = !!t.st[i] && t.st[i].markup;
                  C("FirstMarkupParse", o), (t.currTemplate[i] = !o || e(o));
                }
                r &&
                  r !== n.type &&
                  t.container.removeClass("mfp-" + r + "-holder");
                var a = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](
                  n,
                  t.currTemplate[i]
                );
                t.appendContent(a, i),
                  (n.preloaded = !0),
                  C(d, n),
                  (r = n.type),
                  t.container.prepend(t.contentContainer),
                  C("AfterChange");
              },
              appendContent: function (e, n) {
                (t.content = e),
                  e
                    ? t.st.showCloseBtn &&
                      t.st.closeBtnInside &&
                      !0 === t.currTemplate[n]
                      ? t.content.find(".mfp-close").length ||
                        t.content.append(T())
                      : (t.content = e)
                    : (t.content = ""),
                  C("BeforeAppend"),
                  t.container.addClass("mfp-" + n + "-holder"),
                  t.contentContainer.append(t.content);
              },
              parseEl: function (n) {
                var i,
                  r = t.items[n];
                if (
                  (r.tagName
                    ? (r = { el: e(r) })
                    : ((i = r.type), (r = { data: r, src: r.src })),
                  r.el)
                ) {
                  for (var o = t.types, a = 0; a < o.length; a++)
                    if (r.el.hasClass("mfp-" + o[a])) {
                      i = o[a];
                      break;
                    }
                  (r.src = r.el.attr("data-mfp-src")),
                    r.src || (r.src = r.el.attr("href"));
                }
                return (
                  (r.type = i || t.st.type || "inline"),
                  (r.index = n),
                  (r.parsed = !0),
                  (t.items[n] = r),
                  C("ElementParse", r),
                  t.items[n]
                );
              },
              addGroup: function (e, n) {
                var i = function (i) {
                  (i.mfpEl = this), t._openClick(i, e, n);
                };
                n || (n = {});
                var r = "click.magnificPopup";
                (n.mainEl = e),
                  n.items
                    ? ((n.isObj = !0), e.off(r).on(r, i))
                    : ((n.isObj = !1),
                      n.delegate
                        ? e.off(r).on(r, n.delegate, i)
                        : ((n.items = e), e.off(r).on(r, i)));
              },
              _openClick: function (n, i, r) {
                if (
                  (void 0 !== r.midClick
                    ? r.midClick
                    : e.magnificPopup.defaults.midClick) ||
                  !(
                    2 === n.which ||
                    n.ctrlKey ||
                    n.metaKey ||
                    n.altKey ||
                    n.shiftKey
                  )
                ) {
                  var o =
                    void 0 !== r.disableOn
                      ? r.disableOn
                      : e.magnificPopup.defaults.disableOn;
                  if (o)
                    if (e.isFunction(o)) {
                      if (!o.call(t)) return !0;
                    } else if (b.width() < o) return !0;
                  n.type &&
                    (n.preventDefault(), t.isOpen && n.stopPropagation()),
                    (r.el = e(n.mfpEl)),
                    r.delegate && (r.items = i.find(r.delegate)),
                    t.open(r);
                }
              },
              updateStatus: function (e, i) {
                if (t.preloader) {
                  n !== e && t.container.removeClass("mfp-s-" + n),
                    i || "loading" !== e || (i = t.st.tLoading);
                  var r = { status: e, text: i };
                  C("UpdateStatus", r),
                    (e = r.status),
                    (i = r.text),
                    t.preloader.html(i),
                    t.preloader.find("a").on("click", function (e) {
                      e.stopImmediatePropagation();
                    }),
                    t.container.addClass("mfp-s-" + e),
                    (n = e);
                }
              },
              _checkIfClose: function (n) {
                if (!e(n).hasClass(g)) {
                  var i = t.st.closeOnContentClick,
                    r = t.st.closeOnBgClick;
                  if (i && r) return !0;
                  if (
                    !t.content ||
                    e(n).hasClass("mfp-close") ||
                    (t.preloader && n === t.preloader[0])
                  )
                    return !0;
                  if (n === t.content[0] || e.contains(t.content[0], n)) {
                    if (i) return !0;
                  } else if (r && e.contains(document, n)) return !0;
                  return !1;
                }
              },
              _addClassToMFP: function (e) {
                t.bgOverlay.addClass(e), t.wrap.addClass(e);
              },
              _removeClassFromMFP: function (e) {
                this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
              },
              _hasScrollBar: function (e) {
                return (
                  (t.isIE7 ? i.height() : document.body.scrollHeight) >
                  (e || b.height())
                );
              },
              _setFocus: function () {
                (t.st.focus
                  ? t.content.find(t.st.focus).eq(0)
                  : t.wrap
                ).focus();
              },
              _onFocusIn: function (n) {
                if (n.target !== t.wrap[0] && !e.contains(t.wrap[0], n.target))
                  return t._setFocus(), !1;
              },
              _parseMarkup: function (t, n, i) {
                var r;
                i.data && (n = e.extend(i.data, n)),
                  C(c, [t, n, i]),
                  e.each(n, function (n, i) {
                    if (void 0 === i || !1 === i) return !0;
                    if ((r = n.split("_")).length > 1) {
                      var o = t.find(".mfp-" + r[0]);
                      if (o.length > 0) {
                        var a = r[1];
                        "replaceWith" === a
                          ? o[0] !== i[0] && o.replaceWith(i)
                          : "img" === a
                          ? o.is("img")
                            ? o.attr("src", i)
                            : o.replaceWith(
                                e("<img>")
                                  .attr("src", i)
                                  .attr("class", o.attr("class"))
                              )
                          : o.attr(r[1], i);
                      }
                    } else t.find(".mfp-" + n).html(i);
                  });
              },
              _getScrollbarSize: function () {
                if (void 0 === t.scrollbarSize) {
                  var e = document.createElement("div");
                  (e.style.cssText =
                    "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
                    document.body.appendChild(e),
                    (t.scrollbarSize = e.offsetWidth - e.clientWidth),
                    document.body.removeChild(e);
                }
                return t.scrollbarSize;
              },
            }),
              (e.magnificPopup = {
                instance: null,
                proto: v.prototype,
                modules: [],
                open: function (t, n) {
                  return (
                    S(),
                    ((t = t ? e.extend(!0, {}, t) : {}).isObj = !0),
                    (t.index = n || 0),
                    this.instance.open(t)
                  );
                },
                close: function () {
                  return (
                    e.magnificPopup.instance && e.magnificPopup.instance.close()
                  );
                },
                registerModule: function (t, n) {
                  n.options && (e.magnificPopup.defaults[t] = n.options),
                    e.extend(this.proto, n.proto),
                    this.modules.push(t);
                },
                defaults: {
                  disableOn: 0,
                  key: null,
                  midClick: !1,
                  mainClass: "",
                  preloader: !0,
                  focus: "",
                  closeOnContentClick: !1,
                  closeOnBgClick: !0,
                  closeBtnInside: !0,
                  showCloseBtn: !0,
                  enableEscapeKey: !0,
                  modal: !1,
                  alignTop: !1,
                  removalDelay: 0,
                  prependTo: null,
                  fixedContentPos: "auto",
                  fixedBgPos: "auto",
                  overflowY: "auto",
                  closeMarkup:
                    '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                  tClose: "Close (Esc)",
                  tLoading: "Loading...",
                  autoFocusLast: !0,
                },
              }),
              (e.fn.magnificPopup = function (n) {
                S();
                var i = e(this);
                if ("string" == typeof n)
                  if ("open" === n) {
                    var r,
                      o = y ? i.data("magnificPopup") : i[0].magnificPopup,
                      a = parseInt(arguments[1], 10) || 0;
                    o.items
                      ? (r = o.items[a])
                      : ((r = i),
                        o.delegate && (r = r.find(o.delegate)),
                        (r = r.eq(a))),
                      t._openClick({ mfpEl: r }, i, o);
                  } else
                    t.isOpen &&
                      t[n].apply(t, Array.prototype.slice.call(arguments, 1));
                else
                  (n = e.extend(!0, {}, n)),
                    y ? i.data("magnificPopup", n) : (i[0].magnificPopup = n),
                    t.addGroup(i, n);
                return i;
              });
            var E,
              k,
              L,
              P = "inline",
              O = function () {
                L && (k.after(L.addClass(E)).detach(), (L = null));
              };
            e.magnificPopup.registerModule(P, {
              options: {
                hiddenClass: "hide",
                markup: "",
                tNotFound: "Content not found",
              },
              proto: {
                initInline: function () {
                  t.types.push(P),
                    w("Close.inline", function () {
                      O();
                    });
                },
                getInline: function (n, i) {
                  if ((O(), n.src)) {
                    var r = t.st.inline,
                      o = e(n.src);
                    if (o.length) {
                      var a = o[0].parentNode;
                      a &&
                        a.tagName &&
                        (k ||
                          ((E = r.hiddenClass), (k = x(E)), (E = "mfp-" + E)),
                        (L = o.after(k).detach().removeClass(E))),
                        t.updateStatus("ready");
                    } else
                      t.updateStatus("error", r.tNotFound), (o = e("<div>"));
                    return (n.inlineElement = o), o;
                  }
                  return t.updateStatus("ready"), t._parseMarkup(i, {}, n), i;
                },
              },
            });
            var M,
              A = "ajax",
              I = function () {
                M && e(document.body).removeClass(M);
              },
              j = function () {
                I(), t.req && t.req.abort();
              };
            e.magnificPopup.registerModule(A, {
              options: {
                settings: null,
                cursor: "mfp-ajax-cur",
                tError: '<a href="%url%">The content</a> could not be loaded.',
              },
              proto: {
                initAjax: function () {
                  t.types.push(A),
                    (M = t.st.ajax.cursor),
                    w("Close.ajax", j),
                    w("BeforeChange.ajax", j);
                },
                getAjax: function (n) {
                  M && e(document.body).addClass(M), t.updateStatus("loading");
                  var i = e.extend(
                    {
                      url: n.src,
                      success: function (i, r, o) {
                        var a = { data: i, xhr: o };
                        C("ParseAjax", a),
                          t.appendContent(e(a.data), A),
                          (n.finished = !0),
                          I(),
                          t._setFocus(),
                          setTimeout(function () {
                            t.wrap.addClass(h);
                          }, 16),
                          t.updateStatus("ready"),
                          C("AjaxContentAdded");
                      },
                      error: function () {
                        I(),
                          (n.finished = n.loadError = !0),
                          t.updateStatus(
                            "error",
                            t.st.ajax.tError.replace("%url%", n.src)
                          );
                      },
                    },
                    t.st.ajax.settings
                  );
                  return (t.req = e.ajax(i)), "";
                },
              },
            });
            var _,
              D = function (n) {
                if (n.data && void 0 !== n.data.title) return n.data.title;
                var i = t.st.image.titleSrc;
                if (i) {
                  if (e.isFunction(i)) return i.call(t, n);
                  if (n.el) return n.el.attr(i) || "";
                }
                return "";
              };
            e.magnificPopup.registerModule("image", {
              options: {
                markup:
                  '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                cursor: "mfp-zoom-out-cur",
                titleSrc: "title",
                verticalFit: !0,
                tError: '<a href="%url%">The image</a> could not be loaded.',
              },
              proto: {
                initImage: function () {
                  var n = t.st.image,
                    i = ".image";
                  t.types.push("image"),
                    w("Open.image", function () {
                      "image" === t.currItem.type &&
                        n.cursor &&
                        e(document.body).addClass(n.cursor);
                    }),
                    w("Close.image", function () {
                      n.cursor && e(document.body).removeClass(n.cursor),
                        b.off("resize.mfp");
                    }),
                    w("Resize" + i, t.resizeImage),
                    t.isLowIE && w("AfterChange", t.resizeImage);
                },
                resizeImage: function () {
                  var e = t.currItem;
                  if (e && e.img && t.st.image.verticalFit) {
                    var n = 0;
                    t.isLowIE &&
                      (n =
                        parseInt(e.img.css("padding-top"), 10) +
                        parseInt(e.img.css("padding-bottom"), 10)),
                      e.img.css("max-height", t.wH - n);
                  }
                },
                _onImageHasSize: function (e) {
                  e.img &&
                    ((e.hasSize = !0),
                    _ && clearInterval(_),
                    (e.isCheckingImgSize = !1),
                    C("ImageHasSize", e),
                    e.imgHidden &&
                      (t.content && t.content.removeClass("mfp-loading"),
                      (e.imgHidden = !1)));
                },
                findImageSize: function (e) {
                  var n = 0,
                    i = e.img[0],
                    r = function (o) {
                      _ && clearInterval(_),
                        (_ = setInterval(function () {
                          i.naturalWidth > 0
                            ? t._onImageHasSize(e)
                            : (n > 200 && clearInterval(_),
                              3 == ++n
                                ? r(10)
                                : 40 === n
                                ? r(50)
                                : 100 === n && r(500));
                        }, o));
                    };
                  r(1);
                },
                getImage: function (n, i) {
                  var r = 0,
                    o = function () {
                      n &&
                        (n.img[0].complete
                          ? (n.img.off(".mfploader"),
                            n === t.currItem &&
                              (t._onImageHasSize(n), t.updateStatus("ready")),
                            (n.hasSize = !0),
                            (n.loaded = !0),
                            C("ImageLoadComplete"))
                          : ++r < 200
                          ? setTimeout(o, 100)
                          : a());
                    },
                    a = function () {
                      n &&
                        (n.img.off(".mfploader"),
                        n === t.currItem &&
                          (t._onImageHasSize(n),
                          t.updateStatus(
                            "error",
                            s.tError.replace("%url%", n.src)
                          )),
                        (n.hasSize = !0),
                        (n.loaded = !0),
                        (n.loadError = !0));
                    },
                    s = t.st.image,
                    l = i.find(".mfp-img");
                  if (l.length) {
                    var c = document.createElement("img");
                    (c.className = "mfp-img"),
                      n.el &&
                        n.el.find("img").length &&
                        (c.alt = n.el.find("img").attr("alt")),
                      (n.img = e(c)
                        .on("load.mfploader", o)
                        .on("error.mfploader", a)),
                      (c.src = n.src),
                      l.is("img") && (n.img = n.img.clone()),
                      (c = n.img[0]).naturalWidth > 0
                        ? (n.hasSize = !0)
                        : c.width || (n.hasSize = !1);
                  }
                  return (
                    t._parseMarkup(
                      i,
                      { title: D(n), img_replaceWith: n.img },
                      n
                    ),
                    t.resizeImage(),
                    n.hasSize
                      ? (_ && clearInterval(_),
                        n.loadError
                          ? (i.addClass("mfp-loading"),
                            t.updateStatus(
                              "error",
                              s.tError.replace("%url%", n.src)
                            ))
                          : (i.removeClass("mfp-loading"),
                            t.updateStatus("ready")),
                        i)
                      : (t.updateStatus("loading"),
                        (n.loading = !0),
                        n.hasSize ||
                          ((n.imgHidden = !0),
                          i.addClass("mfp-loading"),
                          t.findImageSize(n)),
                        i)
                  );
                },
              },
            });
            var N;
            e.magnificPopup.registerModule("zoom", {
              options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function (e) {
                  return e.is("img") ? e : e.find("img");
                },
              },
              proto: {
                initZoom: function () {
                  var e,
                    n = t.st.zoom,
                    i = ".zoom";
                  if (n.enabled && t.supportsTransition) {
                    var r,
                      o,
                      a = n.duration,
                      s = function (e) {
                        var t = e
                            .clone()
                            .removeAttr("style")
                            .removeAttr("class")
                            .addClass("mfp-animated-image"),
                          i = "all " + n.duration / 1e3 + "s " + n.easing,
                          r = {
                            position: "fixed",
                            zIndex: 9999,
                            left: 0,
                            top: 0,
                            "-webkit-backface-visibility": "hidden",
                          },
                          o = "transition";
                        return (
                          (r["-webkit-" + o] =
                            r["-moz-" + o] =
                            r["-o-" + o] =
                            r[o] =
                              i),
                          t.css(r),
                          t
                        );
                      },
                      l = function () {
                        t.content.css("visibility", "visible");
                      };
                    w("BuildControls" + i, function () {
                      if (t._allowZoom()) {
                        if (
                          (clearTimeout(r),
                          t.content.css("visibility", "hidden"),
                          !(e = t._getItemToZoom()))
                        )
                          return void l();
                        (o = s(e)).css(t._getOffset()),
                          t.wrap.append(o),
                          (r = setTimeout(function () {
                            o.css(t._getOffset(!0)),
                              (r = setTimeout(function () {
                                l(),
                                  setTimeout(function () {
                                    o.remove(),
                                      (e = o = null),
                                      C("ZoomAnimationEnded");
                                  }, 16);
                              }, a));
                          }, 16));
                      }
                    }),
                      w("BeforeClose.zoom", function () {
                        if (t._allowZoom()) {
                          if ((clearTimeout(r), (t.st.removalDelay = a), !e)) {
                            if (!(e = t._getItemToZoom())) return;
                            o = s(e);
                          }
                          o.css(t._getOffset(!0)),
                            t.wrap.append(o),
                            t.content.css("visibility", "hidden"),
                            setTimeout(function () {
                              o.css(t._getOffset());
                            }, 16);
                        }
                      }),
                      w("Close.zoom", function () {
                        t._allowZoom() && (l(), o && o.remove(), (e = null));
                      });
                  }
                },
                _allowZoom: function () {
                  return "image" === t.currItem.type;
                },
                _getItemToZoom: function () {
                  return !!t.currItem.hasSize && t.currItem.img;
                },
                _getOffset: function (n) {
                  var i,
                    r = (i = n
                      ? t.currItem.img
                      : t.st.zoom.opener(t.currItem.el || t.currItem)).offset(),
                    o = parseInt(i.css("padding-top"), 10),
                    a = parseInt(i.css("padding-bottom"), 10);
                  r.top -= e(window).scrollTop() - o;
                  var s = {
                    width: i.width(),
                    height: (y ? i.innerHeight() : i[0].offsetHeight) - a - o,
                  };
                  return (
                    void 0 === N &&
                      (N =
                        void 0 !==
                        document.createElement("p").style.MozTransform),
                    N
                      ? (s["-moz-transform"] = s.transform =
                          "translate(" + r.left + "px," + r.top + "px)")
                      : ((s.left = r.left), (s.top = r.top)),
                    s
                  );
                },
              },
            });
            var q = "iframe",
              $ = function (e) {
                if (t.currTemplate.iframe) {
                  var n = t.currTemplate.iframe.find("iframe");
                  n.length &&
                    (e || (n[0].src = "//about:blank"),
                    t.isIE8 && n.css("display", e ? "block" : "none"));
                }
              };
            e.magnificPopup.registerModule(q, {
              options: {
                markup:
                  '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                  youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1",
                  },
                  vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1",
                  },
                  gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
                },
              },
              proto: {
                initIframe: function () {
                  t.types.push(q),
                    w("BeforeChange", function (e, t, n) {
                      t !== n && (t === q ? $() : n === q && $(!0));
                    }),
                    w("Close.iframe", function () {
                      $();
                    });
                },
                getIframe: function (n, i) {
                  var r = n.src,
                    o = t.st.iframe;
                  e.each(o.patterns, function () {
                    if (r.indexOf(this.index) > -1)
                      return (
                        this.id &&
                          (r =
                            "string" == typeof this.id
                              ? r.substr(
                                  r.lastIndexOf(this.id) + this.id.length,
                                  r.length
                                )
                              : this.id.call(this, r)),
                        (r = this.src.replace("%id%", r)),
                        !1
                      );
                  });
                  var a = {};
                  return (
                    o.srcAction && (a[o.srcAction] = r),
                    t._parseMarkup(i, a, n),
                    t.updateStatus("ready"),
                    i
                  );
                },
              },
            });
            var z = function (e) {
                var n = t.items.length;
                return e > n - 1 ? e - n : e < 0 ? n + e : e;
              },
              H = function (e, t, n) {
                return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n);
              };
            e.magnificPopup.registerModule("gallery", {
              options: {
                enabled: !1,
                arrowMarkup:
                  '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%",
              },
              proto: {
                initGallery: function () {
                  var n = t.st.gallery,
                    r = ".mfp-gallery";
                  if (((t.direction = !0), !n || !n.enabled)) return !1;
                  (o += " mfp-gallery"),
                    w(u + r, function () {
                      n.navigateByImgClick &&
                        t.wrap.on("click" + r, ".mfp-img", function () {
                          if (t.items.length > 1) return t.next(), !1;
                        }),
                        i.on("keydown" + r, function (e) {
                          37 === e.keyCode
                            ? t.prev()
                            : 39 === e.keyCode && t.next();
                        });
                    }),
                    w("UpdateStatus" + r, function (e, n) {
                      n.text &&
                        (n.text = H(n.text, t.currItem.index, t.items.length));
                    }),
                    w(c + r, function (e, i, r, o) {
                      var a = t.items.length;
                      r.counter = a > 1 ? H(n.tCounter, o.index, a) : "";
                    }),
                    w("BuildControls" + r, function () {
                      if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
                        var i = n.arrowMarkup,
                          r = (t.arrowLeft = e(
                            i
                              .replace(/%title%/gi, n.tPrev)
                              .replace(/%dir%/gi, "left")
                          ).addClass(g)),
                          o = (t.arrowRight = e(
                            i
                              .replace(/%title%/gi, n.tNext)
                              .replace(/%dir%/gi, "right")
                          ).addClass(g));
                        r.click(function () {
                          t.prev();
                        }),
                          o.click(function () {
                            t.next();
                          }),
                          t.container.append(r.add(o));
                      }
                    }),
                    w(d + r, function () {
                      t._preloadTimeout && clearTimeout(t._preloadTimeout),
                        (t._preloadTimeout = setTimeout(function () {
                          t.preloadNearbyImages(), (t._preloadTimeout = null);
                        }, 16));
                    }),
                    w(s + r, function () {
                      i.off(r),
                        t.wrap.off("click" + r),
                        (t.arrowRight = t.arrowLeft = null);
                    });
                },
                next: function () {
                  (t.direction = !0),
                    (t.index = z(t.index + 1)),
                    t.updateItemHTML();
                },
                prev: function () {
                  (t.direction = !1),
                    (t.index = z(t.index - 1)),
                    t.updateItemHTML();
                },
                goTo: function (e) {
                  (t.direction = e >= t.index),
                    (t.index = e),
                    t.updateItemHTML();
                },
                preloadNearbyImages: function () {
                  var e,
                    n = t.st.gallery.preload,
                    i = Math.min(n[0], t.items.length),
                    r = Math.min(n[1], t.items.length);
                  for (e = 1; e <= (t.direction ? r : i); e++)
                    t._preloadItem(t.index + e);
                  for (e = 1; e <= (t.direction ? i : r); e++)
                    t._preloadItem(t.index - e);
                },
                _preloadItem: function (n) {
                  if (((n = z(n)), !t.items[n].preloaded)) {
                    var i = t.items[n];
                    i.parsed || (i = t.parseEl(n)),
                      C("LazyLoad", i),
                      "image" === i.type &&
                        (i.img = e('<img class="mfp-img" />')
                          .on("load.mfploader", function () {
                            i.hasSize = !0;
                          })
                          .on("error.mfploader", function () {
                            (i.hasSize = !0),
                              (i.loadError = !0),
                              C("LazyLoadError", i);
                          })
                          .attr("src", i.src)),
                      (i.preloaded = !0);
                  }
                },
              },
            });
            var B = "retina";
            e.magnificPopup.registerModule(B, {
              options: {
                replaceSrc: function (e) {
                  return e.src.replace(/\.\w+$/, function (e) {
                    return "@2x" + e;
                  });
                },
                ratio: 1,
              },
              proto: {
                initRetina: function () {
                  if (window.devicePixelRatio > 1) {
                    var e = t.st.retina,
                      n = e.ratio;
                    (n = isNaN(n) ? n() : n) > 1 &&
                      (w("ImageHasSize.retina", function (e, t) {
                        t.img.css({
                          "max-width": t.img[0].naturalWidth / n,
                          width: "100%",
                        });
                      }),
                      w("ElementParse.retina", function (t, i) {
                        i.src = e.replaceSrc(i, n);
                      }));
                  }
                },
              },
            }),
              S();
          }),
          void 0 === (o = i.apply(t, r)) || (e.exports = o);
      },
      732: function (e) {
        e.exports = (function () {
          "use strict";
          function e() {
            return (
              (e =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var i in n)
                      Object.prototype.hasOwnProperty.call(n, i) &&
                        (e[i] = n[i]);
                  }
                  return e;
                }),
              e.apply(this, arguments)
            );
          }
          var t = "undefined" != typeof window,
            n =
              (t && !("onscroll" in window)) ||
              ("undefined" != typeof navigator &&
                /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
            i = t && "IntersectionObserver" in window,
            r = t && "classList" in document.createElement("p"),
            o = t && window.devicePixelRatio > 1,
            a = {
              elements_selector: ".lazy",
              container: n || t ? document : null,
              threshold: 300,
              thresholds: null,
              data_src: "src",
              data_srcset: "srcset",
              data_sizes: "sizes",
              data_bg: "bg",
              data_bg_hidpi: "bg-hidpi",
              data_bg_multi: "bg-multi",
              data_bg_multi_hidpi: "bg-multi-hidpi",
              data_poster: "poster",
              class_applied: "applied",
              class_loading: "loading",
              class_loaded: "loaded",
              class_error: "error",
              class_entered: "entered",
              class_exited: "exited",
              unobserve_completed: !0,
              unobserve_entered: !1,
              cancel_on_exit: !0,
              callback_enter: null,
              callback_exit: null,
              callback_applied: null,
              callback_loading: null,
              callback_loaded: null,
              callback_error: null,
              callback_finish: null,
              callback_cancel: null,
              use_native: !1,
            },
            s = function (t) {
              return e({}, a, t);
            },
            l = function (e, t) {
              var n,
                i = "LazyLoad::Initialized",
                r = new e(t);
              try {
                n = new CustomEvent(i, { detail: { instance: r } });
              } catch (e) {
                (n = document.createEvent("CustomEvent")).initCustomEvent(
                  i,
                  !1,
                  !1,
                  { instance: r }
                );
              }
              window.dispatchEvent(n);
            },
            c = "src",
            u = "srcset",
            d = "sizes",
            p = "poster",
            f = "llOriginalAttrs",
            h = "data",
            m = "loading",
            g = "loaded",
            v = "applied",
            y = "error",
            b = "native",
            w = function (e, t) {
              return e.getAttribute("data-" + t);
            },
            x = function (e) {
              return w(e, "ll-status");
            },
            C = function (e, t) {
              return (function (e, t, n) {
                var i = "data-ll-status";
                null !== n ? e.setAttribute(i, n) : e.removeAttribute(i);
              })(e, 0, t);
            },
            T = function (e) {
              return C(e, null);
            },
            S = function (e) {
              return null === x(e);
            },
            E = function (e) {
              return x(e) === b;
            },
            k = [m, g, v, y],
            L = function (e, t, n, i) {
              e &&
                (void 0 === i ? (void 0 === n ? e(t) : e(t, n)) : e(t, n, i));
            },
            P = function (e, t) {
              r
                ? e.classList.add(t)
                : (e.className += (e.className ? " " : "") + t);
            },
            O = function (e, t) {
              r
                ? e.classList.remove(t)
                : (e.className = e.className
                    .replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ")
                    .replace(/^\s+/, "")
                    .replace(/\s+$/, ""));
            },
            M = function (e) {
              return e.llTempImage;
            },
            A = function (e, t) {
              if (t) {
                var n = t._observer;
                n && n.unobserve(e);
              }
            },
            I = function (e, t) {
              e && (e.loadingCount += t);
            },
            j = function (e, t) {
              e && (e.toLoadCount = t);
            },
            _ = function (e) {
              for (var t, n = [], i = 0; (t = e.children[i]); i += 1)
                "SOURCE" === t.tagName && n.push(t);
              return n;
            },
            D = function (e, t) {
              var n = e.parentNode;
              n && "PICTURE" === n.tagName && _(n).forEach(t);
            },
            N = function (e, t) {
              _(e).forEach(t);
            },
            q = [c],
            $ = [c, p],
            z = [c, u, d],
            H = [h],
            B = function (e) {
              return !!e[f];
            },
            F = function (e) {
              return e[f];
            },
            R = function (e) {
              return delete e[f];
            },
            W = function (e, t) {
              if (!B(e)) {
                var n = {};
                t.forEach(function (t) {
                  n[t] = e.getAttribute(t);
                }),
                  (e[f] = n);
              }
            },
            G = function (e, t) {
              if (B(e)) {
                var n = F(e);
                t.forEach(function (t) {
                  !(function (e, t, n) {
                    n ? e.setAttribute(t, n) : e.removeAttribute(t);
                  })(e, t, n[t]);
                });
              }
            },
            V = function (e, t, n) {
              P(e, t.class_loading),
                C(e, m),
                n && (I(n, 1), L(t.callback_loading, e, n));
            },
            X = function (e, t, n) {
              n && e.setAttribute(t, n);
            },
            Y = function (e, t) {
              X(e, d, w(e, t.data_sizes)),
                X(e, u, w(e, t.data_srcset)),
                X(e, c, w(e, t.data_src));
            },
            U = {
              IMG: function (e, t) {
                D(e, function (e) {
                  W(e, z), Y(e, t);
                }),
                  W(e, z),
                  Y(e, t);
              },
              IFRAME: function (e, t) {
                W(e, q), X(e, c, w(e, t.data_src));
              },
              VIDEO: function (e, t) {
                N(e, function (e) {
                  W(e, q), X(e, c, w(e, t.data_src));
                }),
                  W(e, $),
                  X(e, p, w(e, t.data_poster)),
                  X(e, c, w(e, t.data_src)),
                  e.load();
              },
              OBJECT: function (e, t) {
                W(e, H), X(e, h, w(e, t.data_src));
              },
            },
            K = ["IMG", "IFRAME", "VIDEO", "OBJECT"],
            J = function (e, t) {
              !t ||
                (function (e) {
                  return e.loadingCount > 0;
                })(t) ||
                (function (e) {
                  return e.toLoadCount > 0;
                })(t) ||
                L(e.callback_finish, t);
            },
            Q = function (e, t, n) {
              e.addEventListener(t, n), (e.llEvLisnrs[t] = n);
            },
            Z = function (e, t, n) {
              e.removeEventListener(t, n);
            },
            ee = function (e) {
              return !!e.llEvLisnrs;
            },
            te = function (e) {
              if (ee(e)) {
                var t = e.llEvLisnrs;
                for (var n in t) {
                  var i = t[n];
                  Z(e, n, i);
                }
                delete e.llEvLisnrs;
              }
            },
            ne = function (e, t, n) {
              !(function (e) {
                delete e.llTempImage;
              })(e),
                I(n, -1),
                (function (e) {
                  e && (e.toLoadCount -= 1);
                })(n),
                O(e, t.class_loading),
                t.unobserve_completed && A(e, n);
            },
            ie = function (e, t, n) {
              var i = M(e) || e;
              ee(i) ||
                (function (e, t, n) {
                  ee(e) || (e.llEvLisnrs = {});
                  var i = "VIDEO" === e.tagName ? "loadeddata" : "load";
                  Q(e, i, t), Q(e, "error", n);
                })(
                  i,
                  function (r) {
                    !(function (e, t, n, i) {
                      var r = E(t);
                      ne(t, n, i),
                        P(t, n.class_loaded),
                        C(t, g),
                        L(n.callback_loaded, t, i),
                        r || J(n, i);
                    })(0, e, t, n),
                      te(i);
                  },
                  function (r) {
                    !(function (e, t, n, i) {
                      var r = E(t);
                      ne(t, n, i),
                        P(t, n.class_error),
                        C(t, y),
                        L(n.callback_error, t, i),
                        r || J(n, i);
                    })(0, e, t, n),
                      te(i);
                  }
                );
            },
            re = function (e, t, n) {
              !(function (e) {
                return K.indexOf(e.tagName) > -1;
              })(e)
                ? (function (e, t, n) {
                    !(function (e) {
                      e.llTempImage = document.createElement("IMG");
                    })(e),
                      ie(e, t, n),
                      (function (e) {
                        B(e) ||
                          (e[f] = { backgroundImage: e.style.backgroundImage });
                      })(e),
                      (function (e, t, n) {
                        var i = w(e, t.data_bg),
                          r = w(e, t.data_bg_hidpi),
                          a = o && r ? r : i;
                        a &&
                          ((e.style.backgroundImage = 'url("'.concat(a, '")')),
                          M(e).setAttribute(c, a),
                          V(e, t, n));
                      })(e, t, n),
                      (function (e, t, n) {
                        var i = w(e, t.data_bg_multi),
                          r = w(e, t.data_bg_multi_hidpi),
                          a = o && r ? r : i;
                        a &&
                          ((e.style.backgroundImage = a),
                          (function (e, t, n) {
                            P(e, t.class_applied),
                              C(e, v),
                              n &&
                                (t.unobserve_completed && A(e, t),
                                L(t.callback_applied, e, n));
                          })(e, t, n));
                      })(e, t, n);
                  })(e, t, n)
                : (function (e, t, n) {
                    ie(e, t, n),
                      (function (e, t, n) {
                        var i = U[e.tagName];
                        i && (i(e, t), V(e, t, n));
                      })(e, t, n);
                  })(e, t, n);
            },
            oe = function (e) {
              e.removeAttribute(c), e.removeAttribute(u), e.removeAttribute(d);
            },
            ae = function (e) {
              D(e, function (e) {
                G(e, z);
              }),
                G(e, z);
            },
            se = {
              IMG: ae,
              IFRAME: function (e) {
                G(e, q);
              },
              VIDEO: function (e) {
                N(e, function (e) {
                  G(e, q);
                }),
                  G(e, $),
                  e.load();
              },
              OBJECT: function (e) {
                G(e, H);
              },
            },
            le = ["IMG", "IFRAME", "VIDEO"],
            ce = function (e) {
              return e.use_native && "loading" in HTMLImageElement.prototype;
            },
            ue = function (e) {
              return Array.prototype.slice.call(e);
            },
            de = function (e) {
              return e.container.querySelectorAll(e.elements_selector);
            },
            pe = function (e) {
              return (function (e) {
                return x(e) === y;
              })(e);
            },
            fe = function (e, t) {
              return (function (e) {
                return ue(e).filter(S);
              })(e || de(t));
            },
            he = function (e, n) {
              var r = s(e);
              (this._settings = r),
                (this.loadingCount = 0),
                (function (e, t) {
                  i &&
                    !ce(e) &&
                    (t._observer = new IntersectionObserver(
                      function (n) {
                        !(function (e, t, n) {
                          e.forEach(function (e) {
                            return (function (e) {
                              return (
                                e.isIntersecting || e.intersectionRatio > 0
                              );
                            })(e)
                              ? (function (e, t, n, i) {
                                  var r = (function (e) {
                                    return k.indexOf(x(e)) >= 0;
                                  })(e);
                                  C(e, "entered"),
                                    P(e, n.class_entered),
                                    O(e, n.class_exited),
                                    (function (e, t, n) {
                                      t.unobserve_entered && A(e, n);
                                    })(e, n, i),
                                    L(n.callback_enter, e, t, i),
                                    r || re(e, n, i);
                                })(e.target, e, t, n)
                              : (function (e, t, n, i) {
                                  S(e) ||
                                    (P(e, n.class_exited),
                                    (function (e, t, n, i) {
                                      n.cancel_on_exit &&
                                        (function (e) {
                                          return x(e) === m;
                                        })(e) &&
                                        "IMG" === e.tagName &&
                                        (te(e),
                                        (function (e) {
                                          D(e, function (e) {
                                            oe(e);
                                          }),
                                            oe(e);
                                        })(e),
                                        ae(e),
                                        O(e, n.class_loading),
                                        I(i, -1),
                                        T(e),
                                        L(n.callback_cancel, e, t, i));
                                    })(e, t, n, i),
                                    L(n.callback_exit, e, t, i));
                                })(e.target, e, t, n);
                          });
                        })(n, e, t);
                      },
                      (function (e) {
                        return {
                          root: e.container === document ? null : e.container,
                          rootMargin: e.thresholds || e.threshold + "px",
                        };
                      })(e)
                    ));
                })(r, this),
                (function (e, n) {
                  t &&
                    window.addEventListener("online", function () {
                      !(function (e, t) {
                        var n;
                        ((n = de(e)), ue(n).filter(pe)).forEach(function (t) {
                          O(t, e.class_error), T(t);
                        }),
                          t.update();
                      })(e, n);
                    });
                })(r, this),
                this.update(n);
            };
          return (
            (he.prototype = {
              update: function (e) {
                var t,
                  r,
                  o = this._settings,
                  a = fe(e, o);
                j(this, a.length),
                  !n && i
                    ? ce(o)
                      ? (function (e, t, n) {
                          e.forEach(function (e) {
                            -1 !== le.indexOf(e.tagName) &&
                              (function (e, t, n) {
                                e.setAttribute("loading", "lazy"),
                                  ie(e, t, n),
                                  (function (e, t) {
                                    var n = U[e.tagName];
                                    n && n(e, t);
                                  })(e, t),
                                  C(e, b);
                              })(e, t, n);
                          }),
                            j(n, 0);
                        })(a, o, this)
                      : ((r = a),
                        (function (e) {
                          e.disconnect();
                        })((t = this._observer)),
                        (function (e, t) {
                          t.forEach(function (t) {
                            e.observe(t);
                          });
                        })(t, r))
                    : this.loadAll(a);
              },
              destroy: function () {
                this._observer && this._observer.disconnect(),
                  de(this._settings).forEach(function (e) {
                    R(e);
                  }),
                  delete this._observer,
                  delete this._settings,
                  delete this.loadingCount,
                  delete this.toLoadCount;
              },
              loadAll: function (e) {
                var t = this,
                  n = this._settings;
                fe(e, n).forEach(function (e) {
                  A(e, t), re(e, n, t);
                });
              },
              restoreAll: function () {
                var e = this._settings;
                de(e).forEach(function (t) {
                  !(function (e, t) {
                    (function (e) {
                      var t = se[e.tagName];
                      t
                        ? t(e)
                        : (function (e) {
                            if (B(e)) {
                              var t = F(e);
                              e.style.backgroundImage = t.backgroundImage;
                            }
                          })(e);
                    })(e),
                      (function (e, t) {
                        S(e) ||
                          E(e) ||
                          (O(e, t.class_entered),
                          O(e, t.class_exited),
                          O(e, t.class_applied),
                          O(e, t.class_loading),
                          O(e, t.class_loaded),
                          O(e, t.class_error));
                      })(e, t),
                      T(e),
                      R(e);
                  })(t, e);
                });
              },
            }),
            (he.load = function (e, t) {
              var n = s(t);
              re(e, n);
            }),
            (he.resetStatus = function (e) {
              T(e);
            }),
            t &&
              (function (e, t) {
                if (t)
                  if (t.length) for (var n, i = 0; (n = t[i]); i += 1) l(e, n);
                  else l(e, t);
              })(he, window.lazyLoadOptions),
            he
          );
        })();
      },
    },
    t = {};
  function n(i) {
    var r = t[i];
    if (void 0 !== r) return r.exports;
    var o = (t[i] = { exports: {} });
    return e[i].call(o.exports, o, o.exports, n), o.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, { a: t }), t;
  }),
    (n.d = (e, t) => {
      for (var i in t)
        n.o(t, i) &&
          !n.o(e, i) &&
          Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
    }),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (() => {
      "use strict";
      var e = n(732),
        t = n.n(e);
      function i(e) {
        const t = e || {};
        (this.settings = Object.assign(
          {
            method: "scroll",
            container: "#AjaxinateContainer",
            pagination: "#AjaxinatePagination",
            offset: 0,
            loadingText: "Loading",
            callback: null,
          },
          t
        )),
          (this.addScrollListeners = this.addScrollListeners.bind(this)),
          (this.addClickListener = this.addClickListener.bind(this)),
          (this.checkIfPaginationInView =
            this.checkIfPaginationInView.bind(this)),
          (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
          (this.removeClickListener = this.removeClickListener.bind(this)),
          (this.removeScrollListener = this.removeScrollListener.bind(this)),
          (this.removePaginationElement =
            this.removePaginationElement.bind(this)),
          (this.destroy = this.destroy.bind(this)),
          (this.containerElement = document.querySelector(
            this.settings.container
          )),
          (this.paginationElement = document.querySelector(
            this.settings.pagination
          )),
          this.initialize();
      }
      (i.prototype.initialize = function () {
        this.containerElement &&
          { click: this.addClickListener, scroll: this.addScrollListeners }[
            this.settings.method
          ]();
      }),
        (i.prototype.addScrollListeners = function () {
          this.paginationElement &&
            (document.addEventListener("scroll", this.checkIfPaginationInView),
            window.addEventListener("resize", this.checkIfPaginationInView),
            window.addEventListener(
              "orientationchange",
              this.checkIfPaginationInView
            ));
        }),
        (i.prototype.addClickListener = function () {
          this.paginationElement &&
            ((this.nextPageLinkElement =
              this.paginationElement.querySelector("a")),
            (this.clickActive = !0),
            void 0 !== this.nextPageLinkElement &&
              null !== this.nextPageLinkElement &&
              this.nextPageLinkElement.addEventListener(
                "click",
                this.preventMultipleClicks
              ));
        }),
        (i.prototype.preventMultipleClicks = function (e) {
          e.preventDefault(),
            this.clickActive &&
              ((this.nextPageLinkElement.innerText = this.settings.loadingText),
              (this.nextPageUrl = this.nextPageLinkElement.href),
              (this.clickActive = !1),
              this.loadMore());
        }),
        (i.prototype.checkIfPaginationInView = function () {
          const e =
              this.paginationElement.getBoundingClientRect().top -
              this.settings.offset,
            t =
              this.paginationElement.getBoundingClientRect().bottom +
              this.settings.offset;
          e <= window.innerHeight &&
            t >= 0 &&
            ((this.nextPageLinkElement =
              this.paginationElement.querySelector("a")),
            this.removeScrollListener(),
            this.nextPageLinkElement &&
              ((this.nextPageLinkElement.innerText = this.settings.loadingText),
              (this.nextPageUrl = this.nextPageLinkElement.href),
              this.loadMore()));
        }),
        (i.prototype.loadMore = function () {
          (this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
              if (!this.request.responseXML) return;
              if (
                4 === !this.request.readyState ||
                200 === !this.request.status
              )
                return;
              const e = this.request.responseXML.querySelectorAll(
                  this.settings.container
                )[0],
                t = this.request.responseXML.querySelectorAll(
                  this.settings.pagination
                )[0];
              this.containerElement.insertAdjacentHTML(
                "beforeend",
                e.innerHTML
              ),
                void 0 === t
                  ? this.removePaginationElement()
                  : ((this.paginationElement.innerHTML = t.innerHTML),
                    this.settings.callback &&
                      "function" == typeof this.settings.callback &&
                      this.settings.callback(this.request.responseXML),
                    this.initialize());
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl),
            (this.request.responseType = "document"),
            this.request.send();
        }),
        (i.prototype.removeClickListener = function () {
          this.nextPageLinkElement.removeEventListener(
            "click",
            this.preventMultipleClicks
          );
        }),
        (i.prototype.removePaginationElement = function () {
          (this.paginationElement.innerHTML = ""), this.destroy();
        }),
        (i.prototype.removeScrollListener = function () {
          document.removeEventListener("scroll", this.checkIfPaginationInView),
            window.removeEventListener("resize", this.checkIfPaginationInView),
            window.removeEventListener(
              "orientationchange",
              this.checkIfPaginationInView
            );
        }),
        (i.prototype.destroy = function () {
          return (
            {
              click: this.removeClickListener,
              scroll: this.removeScrollListener,
            }[this.settings.method](),
            this
          );
        });
      const r = i;
      var o = n(711),
        a = n.n(o);
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      var l = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.events();
        }
        var t, n;
        return (
          (t = e),
          (n = [{ key: "events", value: function () {} }]) && s(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function c(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      window.Sense = new l();
      var u = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.init();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "init",
              value: function () {
                var e = document.querySelector("[data-reset-toggle]"),
                  t = document.querySelector("[data-reset-form]"),
                  n = document.querySelector("[data-login-toggle]"),
                  i = document.querySelector("[data-login-form]");
                e &&
                  t &&
                  n &&
                  i &&
                  (e.addEventListener("click", function (e) {
                    e.preventDefault(),
                      (t.style.display = "block"),
                      (i.style.display = "none");
                  }),
                  n.addEventListener("click", function (e) {
                    e.preventDefault(),
                      (i.style.display = "block"),
                      (t.style.display = "none");
                  }));
              },
            },
          ]) && c(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function d(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function p(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      function f(e, t, n) {
        return (
          t && p(e.prototype, t),
          n && p(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          e
        );
      }
      document.querySelector("[data-account]") && new u();
      var h = f(function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e);
        var t = document.querySelector("#shopify-section-header");
        new IntersectionObserver(
          function (e) {
            var t,
              n,
              i = ((t = e),
              (n = 1),
              (function (e) {
                if (Array.isArray(e)) return e;
              })(t) ||
                (function (e, t) {
                  var n =
                    null == e
                      ? null
                      : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                        e["@@iterator"];
                  if (null != n) {
                    var i,
                      r,
                      o = [],
                      a = !0,
                      s = !1;
                    try {
                      for (
                        n = n.call(e);
                        !(a = (i = n.next()).done) &&
                        (o.push(i.value), !t || o.length !== t);
                        a = !0
                      );
                    } catch (e) {
                      (s = !0), (r = e);
                    } finally {
                      try {
                        a || null == n.return || n.return();
                      } finally {
                        if (s) throw r;
                      }
                    }
                    return o;
                  }
                })(t, n) ||
                (function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return d(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return (
                      "Object" === n &&
                        e.constructor &&
                        (n = e.constructor.name),
                      "Map" === n || "Set" === n
                        ? Array.from(e)
                        : "Arguments" === n ||
                          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                        ? d(e, t)
                        : void 0
                    );
                  }
                })(t, n) ||
                (function () {
                  throw new TypeError(
                    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                  );
                })())[0];
            return i.target.classList.toggle(
              "is-pinned",
              i.intersectionRatio < 1
            );
          },
          { threshold: [1] }
        ).observe(t);
      });
      function m(e) {
        return (
          null !== e &&
          "object" == typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function g(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n]
            ? (e[n] = t[n])
            : m(t[n]) &&
              m(e[n]) &&
              Object.keys(t[n]).length > 0 &&
              g(e[n], t[n]);
        });
      }
      document.querySelector("#shopify-section-header") && new h();
      const v = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName: () => [],
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function y() {
        const e = "undefined" != typeof document ? document : {};
        return g(e, v), e;
      }
      const b = {
        document: v,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        // history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) =>
          "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function w() {
        const e = "undefined" != typeof window ? window : {};
        return g(e, b), e;
      }
      class x extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get: () => t,
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function C(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...C(e)) : t.push(e);
          }),
          t
        );
      }
      function T(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function S(e, t) {
        const n = w(),
          i = y();
        let r = [];
        if (!t && e instanceof x) return e;
        if (!e) return new x(r);
        if ("string" == typeof e) {
          const n = e.trim();
          if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
            let e = "div";
            0 === n.indexOf("<li") && (e = "ul"),
              0 === n.indexOf("<tr") && (e = "tbody"),
              (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
              0 === n.indexOf("<tbody") && (e = "table"),
              0 === n.indexOf("<option") && (e = "select");
            const t = i.createElement(e);
            t.innerHTML = n;
            for (let e = 0; e < t.childNodes.length; e += 1)
              r.push(t.childNodes[e]);
          } else
            r = (function (e, t) {
              if ("string" != typeof e) return [e];
              const n = [],
                i = t.querySelectorAll(e);
              for (let e = 0; e < i.length; e += 1) n.push(i[e]);
              return n;
            })(e.trim(), t || i);
        } else if (e.nodeType || e === n || e === i) r.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof x) return e;
          r = e;
        }
        return new x(
          (function (e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1)
              -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(r)
        );
      }
      S.fn = x.prototype;
      const E = "resize scroll".split(" ");
      function k(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              E.indexOf(e) < 0 &&
                (e in this[t] ? this[t][e]() : S(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      k("click"),
        k("blur"),
        k("focus"),
        k("focusin"),
        k("focusout"),
        k("keyup"),
        k("keydown"),
        k("keypress"),
        k("submit"),
        k("change"),
        k("mousedown"),
        k("mousemove"),
        k("mouseup"),
        k("mouseenter"),
        k("mouseleave"),
        k("mouseout"),
        k("mouseover"),
        k("touchstart"),
        k("touchend"),
        k("touchmove"),
        k("resize"),
        k("scroll");
      const L = {
        addClass: function (...e) {
          const t = C(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = C(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = C(e.map((e) => e.split(" ")));
          return (
            T(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0)
              .length > 0
          );
        },
        toggleClass: function (...e) {
          const t = C(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (let n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else
              for (const t in e)
                (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration =
              "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, n, i, r] = e;
          function o(e) {
            const t = e.target;
            if (!t) return;
            const r = e.target.dom7EventData || [];
            if ((r.indexOf(e) < 0 && r.unshift(e), S(t).is(n))) i.apply(t, r);
            else {
              const e = S(t).parents();
              for (let t = 0; t < e.length; t += 1)
                S(e[t]).is(n) && i.apply(e[t], r);
            }
          }
          function a(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t);
          }
          "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
            r || (r = !1);
          const s = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (n)
              for (l = 0; l < s.length; l += 1) {
                const e = s[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({
                    listener: i,
                    proxyListener: o,
                  }),
                  t.addEventListener(e, o, r);
              }
            else
              for (l = 0; l < s.length; l += 1) {
                const e = s[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: i, proxyListener: a }),
                  t.addEventListener(e, a, r);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, n, i, r] = e;
          "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
            r || (r = !1);
          const o = t.split(" ");
          for (let e = 0; e < o.length; e += 1) {
            const t = o[e];
            for (let e = 0; e < this.length; e += 1) {
              const o = this[e];
              let a;
              if (
                (!n && o.dom7Listeners
                  ? (a = o.dom7Listeners[t])
                  : n && o.dom7LiveListeners && (a = o.dom7LiveListeners[t]),
                a && a.length)
              )
                for (let e = a.length - 1; e >= 0; e -= 1) {
                  const n = a[e];
                  (i && n.listener === i) ||
                  (i &&
                    n.listener &&
                    n.listener.dom7proxy &&
                    n.listener.dom7proxy === i)
                    ? (o.removeEventListener(t, n.proxyListener, r),
                      a.splice(e, 1))
                    : i ||
                      (o.removeEventListener(t, n.proxyListener, r),
                      a.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = w(),
            n = e[0].split(" "),
            i = e[1];
          for (let r = 0; r < n.length; r += 1) {
            const o = n[r];
            for (let n = 0; n < this.length; n += 1) {
              const r = this[n];
              if (t.CustomEvent) {
                const n = new t.CustomEvent(o, {
                  detail: i,
                  bubbles: !0,
                  cancelable: !0,
                });
                (r.dom7EventData = e.filter((e, t) => t > 0)),
                  r.dispatchEvent(n),
                  (r.dom7EventData = []),
                  delete r.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
              t.on("transitionend", function n(i) {
                i.target === this &&
                  (e.call(this, i), t.off("transitionend", n));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = w();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = w(),
              t = y(),
              n = this[0],
              i = n.getBoundingClientRect(),
              r = t.body,
              o = n.clientTop || r.clientTop || 0,
              a = n.clientLeft || r.clientLeft || 0,
              s = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: i.top + s - o, left: i.left + l - a };
          }
          return null;
        },
        css: function (e, t) {
          const n = w();
          let i;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (i = 0; i < this.length; i += 1)
                for (const t in e) this[i].style[t] = e[t];
              return this;
            }
            if (this[0])
              return n.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, n) => {
                e.apply(t, [t, n]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = w(),
            n = y(),
            i = this[0];
          let r, o;
          if (!i || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (i.matches) return i.matches(e);
            if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
            if (i.msMatchesSelector) return i.msMatchesSelector(e);
            for (r = S(e), o = 0; o < r.length; o += 1)
              if (r[o] === i) return !0;
            return !1;
          }
          if (e === n) return i === n;
          if (e === t) return i === t;
          if (e.nodeType || e instanceof x) {
            for (r = e.nodeType ? [e] : e, o = 0; o < r.length; o += 1)
              if (r[o] === i) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); )
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return S([]);
          if (e < 0) {
            const n = t + e;
            return S(n < 0 ? [] : [this[n]]);
          }
          return S([this[e]]);
        },
        append: function (...e) {
          let t;
          const n = y();
          for (let i = 0; i < e.length; i += 1) {
            t = e[i];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const i = n.createElement("div");
                for (i.innerHTML = t; i.firstChild; )
                  this[e].appendChild(i.firstChild);
              } else if (t instanceof x)
                for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = y();
          let n, i;
          for (n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              const r = t.createElement("div");
              for (r.innerHTML = e, i = r.childNodes.length - 1; i >= 0; i -= 1)
                this[n].insertBefore(r.childNodes[i], this[n].childNodes[0]);
            } else if (e instanceof x)
              for (i = 0; i < e.length; i += 1)
                this[n].insertBefore(e[i], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling &&
                S(this[0].nextElementSibling).is(e)
                ? S([this[0].nextElementSibling])
                : S([])
              : this[0].nextElementSibling
              ? S([this[0].nextElementSibling])
              : S([])
            : S([]);
        },
        nextAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return S([]);
          for (; n.nextElementSibling; ) {
            const i = n.nextElementSibling;
            e ? S(i).is(e) && t.push(i) : t.push(i), (n = i);
          }
          return S(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && S(t.previousElementSibling).is(e)
                ? S([t.previousElementSibling])
                : S([])
              : t.previousElementSibling
              ? S([t.previousElementSibling])
              : S([]);
          }
          return S([]);
        },
        prevAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return S([]);
          for (; n.previousElementSibling; ) {
            const i = n.previousElementSibling;
            e ? S(i).is(e) && t.push(i) : t.push(i), (n = i);
          }
          return S(t);
        },
        parent: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1)
            null !== this[n].parentNode &&
              (e
                ? S(this[n].parentNode).is(e) && t.push(this[n].parentNode)
                : t.push(this[n].parentNode));
          return S(t);
        },
        parents: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            let i = this[n].parentNode;
            for (; i; )
              e ? S(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
          }
          return S(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e
            ? S([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const i = this[n].querySelectorAll(e);
            for (let e = 0; e < i.length; e += 1) t.push(i[e]);
          }
          return S(t);
        },
        children: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const i = this[n].children;
            for (let n = 0; n < i.length; n += 1)
              (e && !S(i[n]).is(e)) || t.push(i[n]);
          }
          return S(t);
        },
        filter: function (e) {
          return S(T(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(L).forEach((e) => {
        Object.defineProperty(S.fn, e, { value: L[e], writable: !0 });
      });
      const P = S;
      function O(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function M() {
        return Date.now();
      }
      function A(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function I(e) {
        return "undefined" != typeof window && void 0 !== window.HTMLElement
          ? e instanceof HTMLElement
          : e && (1 === e.nodeType || 11 === e.nodeType);
      }
      function j() {
        const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
          t = ["__proto__", "constructor", "prototype"];
        for (let n = 1; n < arguments.length; n += 1) {
          const i = n < 0 || arguments.length <= n ? void 0 : arguments[n];
          if (null != i && !I(i)) {
            const n = Object.keys(Object(i)).filter((e) => t.indexOf(e) < 0);
            for (let t = 0, r = n.length; t < r; t += 1) {
              const r = n[t],
                o = Object.getOwnPropertyDescriptor(i, r);
              void 0 !== o &&
                o.enumerable &&
                (A(e[r]) && A(i[r])
                  ? i[r].__swiper__
                    ? (e[r] = i[r])
                    : j(e[r], i[r])
                  : !A(e[r]) && A(i[r])
                  ? ((e[r] = {}),
                    i[r].__swiper__ ? (e[r] = i[r]) : j(e[r], i[r]))
                  : (e[r] = i[r]));
            }
          }
        }
        return e;
      }
      function _(e, t, n) {
        e.style.setProperty(t, n);
      }
      function D(e) {
        let { swiper: t, targetPosition: n, side: i } = e;
        const r = w(),
          o = -t.translate;
        let a,
          s = null;
        const l = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"),
          r.cancelAnimationFrame(t.cssModeFrameID);
        const c = n > o ? "next" : "prev",
          u = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
          d = () => {
            (a = new Date().getTime()), null === s && (s = a);
            const e = Math.max(Math.min((a - s) / l, 1), 0),
              c = 0.5 - Math.cos(e * Math.PI) / 2;
            let p = o + c * (n - o);
            if ((u(p, n) && (p = n), t.wrapperEl.scrollTo({ [i]: p }), u(p, n)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""),
                    t.wrapperEl.scrollTo({ [i]: p });
                }),
                void r.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = r.requestAnimationFrame(d);
          };
        d();
      }
      let N, q, $;
      function z() {
        return (
          N ||
            (N = (function () {
              const e = w(),
                t = y();
              return {
                smoothScroll:
                  t.documentElement &&
                  "scrollBehavior" in t.documentElement.style,
                touch: !!(
                  "ontouchstart" in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
                passiveListener: (function () {
                  let t = !1;
                  try {
                    const n = Object.defineProperty({}, "passive", {
                      get() {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, n);
                  } catch (e) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          N
        );
      }
      const H = {
          on(e, t, n) {
            const i = this;
            if ("function" != typeof t) return i;
            const r = n ? "unshift" : "push";
            return (
              e.split(" ").forEach((e) => {
                i.eventsListeners[e] || (i.eventsListeners[e] = []),
                  i.eventsListeners[e][r](t);
              }),
              i
            );
          },
          once(e, t, n) {
            const i = this;
            if ("function" != typeof t) return i;
            function r() {
              i.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
              for (
                var n = arguments.length, o = new Array(n), a = 0;
                a < n;
                a++
              )
                o[a] = arguments[a];
              t.apply(i, o);
            }
            return (r.__emitterProxy = t), i.on(e, r, n);
          },
          onAny(e, t) {
            const n = this;
            if ("function" != typeof e) return n;
            const i = t ? "unshift" : "push";
            return (
              n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e),
              n
            );
          },
          offAny(e) {
            const t = this;
            if (!t.eventsAnyListeners) return t;
            const n = t.eventsAnyListeners.indexOf(e);
            return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
          },
          off(e, t) {
            const n = this;
            return n.eventsListeners
              ? (e.split(" ").forEach((e) => {
                  void 0 === t
                    ? (n.eventsListeners[e] = [])
                    : n.eventsListeners[e] &&
                      n.eventsListeners[e].forEach((i, r) => {
                        (i === t ||
                          (i.__emitterProxy && i.__emitterProxy === t)) &&
                          n.eventsListeners[e].splice(r, 1);
                      });
                }),
                n)
              : n;
          },
          emit() {
            const e = this;
            if (!e.eventsListeners) return e;
            let t, n, i;
            for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
              o[a] = arguments[a];
            return (
              "string" == typeof o[0] || Array.isArray(o[0])
                ? ((t = o[0]), (n = o.slice(1, o.length)), (i = e))
                : ((t = o[0].events), (n = o[0].data), (i = o[0].context || e)),
              n.unshift(i),
              (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                e.eventsAnyListeners &&
                  e.eventsAnyListeners.length &&
                  e.eventsAnyListeners.forEach((e) => {
                    e.apply(i, [t, ...n]);
                  }),
                  e.eventsListeners &&
                    e.eventsListeners[t] &&
                    e.eventsListeners[t].forEach((e) => {
                      e.apply(i, n);
                    });
              }),
              e
            );
          },
        },
        B = {
          updateSize: function () {
            const e = this;
            let t, n;
            const i = e.$el;
            (t =
              void 0 !== e.params.width && null !== e.params.width
                ? e.params.width
                : i[0].clientWidth),
              (n =
                void 0 !== e.params.height && null !== e.params.height
                  ? e.params.height
                  : i[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
                (0 === n && e.isVertical()) ||
                ((t =
                  t -
                  parseInt(i.css("padding-left") || 0, 10) -
                  parseInt(i.css("padding-right") || 0, 10)),
                (n =
                  n -
                  parseInt(i.css("padding-top") || 0, 10) -
                  parseInt(i.css("padding-bottom") || 0, 10)),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(n) && (n = 0),
                Object.assign(e, {
                  width: t,
                  height: n,
                  size: e.isHorizontal() ? t : n,
                }));
          },
          updateSlides: function () {
            const e = this;
            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[t];
            }
            function n(e, n) {
              return parseFloat(e.getPropertyValue(t(n)) || 0);
            }
            const i = e.params,
              { $wrapperEl: r, size: o, rtlTranslate: a, wrongRTL: s } = e,
              l = e.virtual && i.virtual.enabled,
              c = l ? e.virtual.slides.length : e.slides.length,
              u = r.children(`.${e.params.slideClass}`),
              d = l ? e.virtual.slides.length : u.length;
            let p = [];
            const f = [],
              h = [];
            let m = i.slidesOffsetBefore;
            "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
            let g = i.slidesOffsetAfter;
            "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              y = e.slidesGrid.length;
            let b = i.spaceBetween,
              w = -m,
              x = 0,
              C = 0;
            if (void 0 === o) return;
            "string" == typeof b &&
              b.indexOf("%") >= 0 &&
              (b = (parseFloat(b.replace("%", "")) / 100) * o),
              (e.virtualSize = -b),
              a
                ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
              i.centeredSlides &&
                i.cssMode &&
                (_(e.wrapperEl, "--swiper-centered-offset-before", ""),
                _(e.wrapperEl, "--swiper-centered-offset-after", ""));
            const T = i.grid && i.grid.rows > 1 && e.grid;
            let S;
            T && e.grid.initSlides(d);
            const E =
              "auto" === i.slidesPerView &&
              i.breakpoints &&
              Object.keys(i.breakpoints).filter(
                (e) => void 0 !== i.breakpoints[e].slidesPerView
              ).length > 0;
            for (let r = 0; r < d; r += 1) {
              S = 0;
              const a = u.eq(r);
              if (
                (T && e.grid.updateSlide(r, a, d, t),
                "none" !== a.css("display"))
              ) {
                if ("auto" === i.slidesPerView) {
                  E && (u[r].style[t("width")] = "");
                  const o = getComputedStyle(a[0]),
                    s = a[0].style.transform,
                    l = a[0].style.webkitTransform;
                  if (
                    (s && (a[0].style.transform = "none"),
                    l && (a[0].style.webkitTransform = "none"),
                    i.roundLengths)
                  )
                    S = e.isHorizontal() ? a.outerWidth(!0) : a.outerHeight(!0);
                  else {
                    const e = n(o, "width"),
                      t = n(o, "padding-left"),
                      i = n(o, "padding-right"),
                      r = n(o, "margin-left"),
                      s = n(o, "margin-right"),
                      l = o.getPropertyValue("box-sizing");
                    if (l && "border-box" === l) S = e + r + s;
                    else {
                      const { clientWidth: n, offsetWidth: o } = a[0];
                      S = e + t + i + r + s + (o - n);
                    }
                  }
                  s && (a[0].style.transform = s),
                    l && (a[0].style.webkitTransform = l),
                    i.roundLengths && (S = Math.floor(S));
                } else
                  (S = (o - (i.slidesPerView - 1) * b) / i.slidesPerView),
                    i.roundLengths && (S = Math.floor(S)),
                    u[r] && (u[r].style[t("width")] = `${S}px`);
                u[r] && (u[r].swiperSlideSize = S),
                  h.push(S),
                  i.centeredSlides
                    ? ((w = w + S / 2 + x / 2 + b),
                      0 === x && 0 !== r && (w = w - o / 2 - b),
                      0 === r && (w = w - o / 2 - b),
                      Math.abs(w) < 0.001 && (w = 0),
                      i.roundLengths && (w = Math.floor(w)),
                      C % i.slidesPerGroup == 0 && p.push(w),
                      f.push(w))
                    : (i.roundLengths && (w = Math.floor(w)),
                      (C - Math.min(e.params.slidesPerGroupSkip, C)) %
                        e.params.slidesPerGroup ==
                        0 && p.push(w),
                      f.push(w),
                      (w = w + S + b)),
                  (e.virtualSize += S + b),
                  (x = S),
                  (C += 1);
              }
            }
            if (
              ((e.virtualSize = Math.max(e.virtualSize, o) + g),
              a &&
                s &&
                ("slide" === i.effect || "coverflow" === i.effect) &&
                r.css({ width: `${e.virtualSize + i.spaceBetween}px` }),
              i.setWrapperSize &&
                r.css({ [t("width")]: `${e.virtualSize + i.spaceBetween}px` }),
              T && e.grid.updateWrapperSize(S, p, t),
              !i.centeredSlides)
            ) {
              const t = [];
              for (let n = 0; n < p.length; n += 1) {
                let r = p[n];
                i.roundLengths && (r = Math.floor(r)),
                  p[n] <= e.virtualSize - o && t.push(r);
              }
              (p = t),
                Math.floor(e.virtualSize - o) - Math.floor(p[p.length - 1]) >
                  1 && p.push(e.virtualSize - o);
            }
            if ((0 === p.length && (p = [0]), 0 !== i.spaceBetween)) {
              const n = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
              u.filter((e, t) => !i.cssMode || t !== u.length - 1).css({
                [n]: `${b}px`,
              });
            }
            if (i.centeredSlides && i.centeredSlidesBounds) {
              let e = 0;
              h.forEach((t) => {
                e += t + (i.spaceBetween ? i.spaceBetween : 0);
              }),
                (e -= i.spaceBetween);
              const t = e - o;
              p = p.map((e) => (e < 0 ? -m : e > t ? t + g : e));
            }
            if (i.centerInsufficientSlides) {
              let e = 0;
              if (
                (h.forEach((t) => {
                  e += t + (i.spaceBetween ? i.spaceBetween : 0);
                }),
                (e -= i.spaceBetween),
                e < o)
              ) {
                const t = (o - e) / 2;
                p.forEach((e, n) => {
                  p[n] = e - t;
                }),
                  f.forEach((e, n) => {
                    f[n] = e + t;
                  });
              }
            }
            if (
              (Object.assign(e, {
                slides: u,
                snapGrid: p,
                slidesGrid: f,
                slidesSizesGrid: h,
              }),
              i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
            ) {
              _(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"),
                _(
                  e.wrapperEl,
                  "--swiper-centered-offset-after",
                  e.size / 2 - h[h.length - 1] / 2 + "px"
                );
              const t = -e.snapGrid[0],
                n = -e.slidesGrid[0];
              (e.snapGrid = e.snapGrid.map((e) => e + t)),
                (e.slidesGrid = e.slidesGrid.map((e) => e + n));
            }
            if (
              (d !== c && e.emit("slidesLengthChange"),
              p.length !== v &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              f.length !== y && e.emit("slidesGridLengthChange"),
              i.watchSlidesProgress && e.updateSlidesOffset(),
              !(
                l ||
                i.cssMode ||
                ("slide" !== i.effect && "fade" !== i.effect)
              ))
            ) {
              const t = `${i.containerModifierClass}backface-hidden`,
                n = e.$el.hasClass(t);
              d <= i.maxBackfaceHiddenSlides
                ? n || e.$el.addClass(t)
                : n && e.$el.removeClass(t);
            }
          },
          updateAutoHeight: function (e) {
            const t = this,
              n = [],
              i = t.virtual && t.params.virtual.enabled;
            let r,
              o = 0;
            "number" == typeof e
              ? t.setTransition(e)
              : !0 === e && t.setTransition(t.params.speed);
            const a = (e) =>
              i
                ? t.slides.filter(
                    (t) =>
                      parseInt(
                        t.getAttribute("data-swiper-slide-index"),
                        10
                      ) === e
                  )[0]
                : t.slides.eq(e)[0];
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              if (t.params.centeredSlides)
                t.visibleSlides.each((e) => {
                  n.push(e);
                });
              else
                for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                  const e = t.activeIndex + r;
                  if (e > t.slides.length && !i) break;
                  n.push(a(e));
                }
            else n.push(a(t.activeIndex));
            for (r = 0; r < n.length; r += 1)
              if (void 0 !== n[r]) {
                const e = n[r].offsetHeight;
                o = e > o ? e : o;
              }
            (o || 0 === o) && t.$wrapperEl.css("height", `${o}px`);
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let n = 0; n < t.length; n += 1)
              t[n].swiperSlideOffset = e.isHorizontal()
                ? t[n].offsetLeft
                : t[n].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            const t = this,
              n = t.params,
              { slides: i, rtlTranslate: r, snapGrid: o } = t;
            if (0 === i.length) return;
            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
            let a = -e;
            r && (a = e),
              i.removeClass(n.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);
            for (let e = 0; e < i.length; e += 1) {
              const s = i[e];
              let l = s.swiperSlideOffset;
              n.cssMode && n.centeredSlides && (l -= i[0].swiperSlideOffset);
              const c =
                  (a + (n.centeredSlides ? t.minTranslate() : 0) - l) /
                  (s.swiperSlideSize + n.spaceBetween),
                u =
                  (a - o[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) /
                  (s.swiperSlideSize + n.spaceBetween),
                d = -(a - l),
                p = d + t.slidesSizesGrid[e];
              ((d >= 0 && d < t.size - 1) ||
                (p > 1 && p <= t.size) ||
                (d <= 0 && p >= t.size)) &&
                (t.visibleSlides.push(s),
                t.visibleSlidesIndexes.push(e),
                i.eq(e).addClass(n.slideVisibleClass)),
                (s.progress = r ? -c : c),
                (s.originalProgress = r ? -u : u);
            }
            t.visibleSlides = P(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            const n = t.params,
              i = t.maxTranslate() - t.minTranslate();
            let { progress: r, isBeginning: o, isEnd: a } = t;
            const s = o,
              l = a;
            0 === i
              ? ((r = 0), (o = !0), (a = !0))
              : ((r = (e - t.minTranslate()) / i), (o = r <= 0), (a = r >= 1)),
              Object.assign(t, { progress: r, isBeginning: o, isEnd: a }),
              (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
                t.updateSlidesProgress(e),
              o && !s && t.emit("reachBeginning toEdge"),
              a && !l && t.emit("reachEnd toEdge"),
              ((s && !o) || (l && !a)) && t.emit("fromEdge"),
              t.emit("progress", r);
          },
          updateSlidesClasses: function () {
            const e = this,
              {
                slides: t,
                params: n,
                $wrapperEl: i,
                activeIndex: r,
                realIndex: o,
              } = e,
              a = e.virtual && n.virtual.enabled;
            let s;
            t.removeClass(
              `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
            ),
              (s = a
                ? e.$wrapperEl.find(
                    `.${n.slideClass}[data-swiper-slide-index="${r}"]`
                  )
                : t.eq(r)),
              s.addClass(n.slideActiveClass),
              n.loop &&
                (s.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${o}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass)
                  : i
                      .children(
                        `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${o}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass));
            let l = s
              .nextAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slideNextClass);
            n.loop &&
              0 === l.length &&
              ((l = t.eq(0)), l.addClass(n.slideNextClass));
            let c = s
              .prevAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slidePrevClass);
            n.loop &&
              0 === c.length &&
              ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
              n.loop &&
                (l.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass),
                c.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)),
              e.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            const t = this,
              n = t.rtlTranslate ? t.translate : -t.translate,
              {
                slidesGrid: i,
                snapGrid: r,
                params: o,
                activeIndex: a,
                realIndex: s,
                snapIndex: l,
              } = t;
            let c,
              u = e;
            if (void 0 === u) {
              for (let e = 0; e < i.length; e += 1)
                void 0 !== i[e + 1]
                  ? n >= i[e] && n < i[e + 1] - (i[e + 1] - i[e]) / 2
                    ? (u = e)
                    : n >= i[e] && n < i[e + 1] && (u = e + 1)
                  : n >= i[e] && (u = e);
              o.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
            }
            if (r.indexOf(n) >= 0) c = r.indexOf(n);
            else {
              const e = Math.min(o.slidesPerGroupSkip, u);
              c = e + Math.floor((u - e) / o.slidesPerGroup);
            }
            if ((c >= r.length && (c = r.length - 1), u === a))
              return void (
                c !== l && ((t.snapIndex = c), t.emit("snapIndexChange"))
              );
            const d = parseInt(
              t.slides.eq(u).attr("data-swiper-slide-index") || u,
              10
            );
            Object.assign(t, {
              snapIndex: c,
              realIndex: d,
              previousIndex: a,
              activeIndex: u,
            }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              s !== d && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) &&
                t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              n = t.params,
              i = P(e).closest(`.${n.slideClass}`)[0];
            let r,
              o = !1;
            if (i)
              for (let e = 0; e < t.slides.length; e += 1)
                if (t.slides[e] === i) {
                  (o = !0), (r = e);
                  break;
                }
            if (!i || !o)
              return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = i),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(
                    P(i).attr("data-swiper-slide-index"),
                    10
                  ))
                : (t.clickedIndex = r),
              n.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
          },
        };
      function F(e) {
        let { swiper: t, runCallbacks: n, direction: i, step: r } = e;
        const { activeIndex: o, previousIndex: a } = t;
        let s = i;
        if (
          (s || (s = o > a ? "next" : o < a ? "prev" : "reset"),
          t.emit(`transition${r}`),
          n && o !== a)
        ) {
          if ("reset" === s) return void t.emit(`slideResetTransition${r}`);
          t.emit(`slideChangeTransition${r}`),
            "next" === s
              ? t.emit(`slideNextTransition${r}`)
              : t.emit(`slidePrevTransition${r}`);
        }
      }
      const R = {
          slideTo: function (e, t, n, i, r) {
            if (
              (void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              "number" != typeof e && "string" != typeof e)
            )
              throw new Error(
                `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
              );
            if ("string" == typeof e) {
              const t = parseInt(e, 10);
              if (!isFinite(t))
                throw new Error(
                  `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
                );
              e = t;
            }
            const o = this;
            let a = e;
            a < 0 && (a = 0);
            const {
              params: s,
              snapGrid: l,
              slidesGrid: c,
              previousIndex: u,
              activeIndex: d,
              rtlTranslate: p,
              wrapperEl: f,
              enabled: h,
            } = o;
            if (
              (o.animating && s.preventInteractionOnTransition) ||
              (!h && !i && !r)
            )
              return !1;
            const m = Math.min(o.params.slidesPerGroupSkip, a);
            let g = m + Math.floor((a - m) / o.params.slidesPerGroup);
            g >= l.length && (g = l.length - 1),
              (d || s.initialSlide || 0) === (u || 0) &&
                n &&
                o.emit("beforeSlideChangeStart");
            const v = -l[g];
            if ((o.updateProgress(v), s.normalizeSlideIndex))
              for (let e = 0; e < c.length; e += 1) {
                const t = -Math.floor(100 * v),
                  n = Math.floor(100 * c[e]),
                  i = Math.floor(100 * c[e + 1]);
                void 0 !== c[e + 1]
                  ? t >= n && t < i - (i - n) / 2
                    ? (a = e)
                    : t >= n && t < i && (a = e + 1)
                  : t >= n && (a = e);
              }
            if (o.initialized && a !== d) {
              if (!o.allowSlideNext && v < o.translate && v < o.minTranslate())
                return !1;
              if (
                !o.allowSlidePrev &&
                v > o.translate &&
                v > o.maxTranslate() &&
                (d || 0) !== a
              )
                return !1;
            }
            let y;
            if (
              ((y = a > d ? "next" : a < d ? "prev" : "reset"),
              (p && -v === o.translate) || (!p && v === o.translate))
            )
              return (
                o.updateActiveIndex(a),
                s.autoHeight && o.updateAutoHeight(),
                o.updateSlidesClasses(),
                "slide" !== s.effect && o.setTranslate(v),
                "reset" !== y &&
                  (o.transitionStart(n, y), o.transitionEnd(n, y)),
                !1
              );
            if (s.cssMode) {
              const e = o.isHorizontal(),
                n = p ? v : -v;
              if (0 === t) {
                const t = o.virtual && o.params.virtual.enabled;
                t &&
                  ((o.wrapperEl.style.scrollSnapType = "none"),
                  (o._immediateVirtual = !0)),
                  (f[e ? "scrollLeft" : "scrollTop"] = n),
                  t &&
                    requestAnimationFrame(() => {
                      (o.wrapperEl.style.scrollSnapType = ""),
                        (o._swiperImmediateVirtual = !1);
                    });
              } else {
                if (!o.support.smoothScroll)
                  return (
                    D({
                      swiper: o,
                      targetPosition: n,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                f.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
              }
              return !0;
            }
            return (
              o.setTransition(t),
              o.setTranslate(v),
              o.updateActiveIndex(a),
              o.updateSlidesClasses(),
              o.emit("beforeTransitionStart", t, i),
              o.transitionStart(n, y),
              0 === t
                ? o.transitionEnd(n, y)
                : o.animating ||
                  ((o.animating = !0),
                  o.onSlideToWrapperTransitionEnd ||
                    (o.onSlideToWrapperTransitionEnd = function (e) {
                      o &&
                        !o.destroyed &&
                        e.target === this &&
                        (o.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          o.onSlideToWrapperTransitionEnd
                        ),
                        o.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          o.onSlideToWrapperTransitionEnd
                        ),
                        (o.onSlideToWrapperTransitionEnd = null),
                        delete o.onSlideToWrapperTransitionEnd,
                        o.transitionEnd(n, y));
                    }),
                  o.$wrapperEl[0].addEventListener(
                    "transitionend",
                    o.onSlideToWrapperTransitionEnd
                  ),
                  o.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    o.onSlideToWrapperTransitionEnd
                  )),
              !0
            );
          },
          slideToLoop: function (e, t, n, i) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0);
            const r = this;
            let o = e;
            return (
              r.params.loop && (o += r.loopedSlides), r.slideTo(o, t, n, i)
            );
          },
          slideNext: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const i = this,
              { animating: r, enabled: o, params: a } = i;
            if (!o) return i;
            let s = a.slidesPerGroup;
            "auto" === a.slidesPerView &&
              1 === a.slidesPerGroup &&
              a.slidesPerGroupAuto &&
              (s = Math.max(i.slidesPerViewDynamic("current", !0), 1));
            const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : s;
            if (a.loop) {
              if (r && a.loopPreventsSlide) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }
            return a.rewind && i.isEnd
              ? i.slideTo(0, e, t, n)
              : i.slideTo(i.activeIndex + l, e, t, n);
          },
          slidePrev: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const i = this,
              {
                params: r,
                animating: o,
                snapGrid: a,
                slidesGrid: s,
                rtlTranslate: l,
                enabled: c,
              } = i;
            if (!c) return i;
            if (r.loop) {
              if (o && r.loopPreventsSlide) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }
            function u(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const d = u(l ? i.translate : -i.translate),
              p = a.map((e) => u(e));
            let f = a[p.indexOf(d) - 1];
            if (void 0 === f && r.cssMode) {
              let e;
              a.forEach((t, n) => {
                d >= t && (e = n);
              }),
                void 0 !== e && (f = a[e > 0 ? e - 1 : e]);
            }
            let h = 0;
            if (
              (void 0 !== f &&
                ((h = s.indexOf(f)),
                h < 0 && (h = i.activeIndex - 1),
                "auto" === r.slidesPerView &&
                  1 === r.slidesPerGroup &&
                  r.slidesPerGroupAuto &&
                  ((h = h - i.slidesPerViewDynamic("previous", !0) + 1),
                  (h = Math.max(h, 0)))),
              r.rewind && i.isBeginning)
            ) {
              const r =
                i.params.virtual && i.params.virtual.enabled && i.virtual
                  ? i.virtual.slides.length - 1
                  : i.slides.length - 1;
              return i.slideTo(r, e, t, n);
            }
            return i.slideTo(h, e, t, n);
          },
          slideReset: function (e, t, n) {
            return (
              void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              this.slideTo(this.activeIndex, e, t, n)
            );
          },
          slideToClosest: function (e, t, n, i) {
            void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              void 0 === i && (i = 0.5);
            const r = this;
            let o = r.activeIndex;
            const a = Math.min(r.params.slidesPerGroupSkip, o),
              s = a + Math.floor((o - a) / r.params.slidesPerGroup),
              l = r.rtlTranslate ? r.translate : -r.translate;
            if (l >= r.snapGrid[s]) {
              const e = r.snapGrid[s];
              l - e > (r.snapGrid[s + 1] - e) * i &&
                (o += r.params.slidesPerGroup);
            } else {
              const e = r.snapGrid[s - 1];
              l - e <= (r.snapGrid[s] - e) * i &&
                (o -= r.params.slidesPerGroup);
            }
            return (
              (o = Math.max(o, 0)),
              (o = Math.min(o, r.slidesGrid.length - 1)),
              r.slideTo(o, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, $wrapperEl: n } = e,
              i =
                "auto" === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let r,
              o = e.clickedIndex;
            if (t.loop) {
              if (e.animating) return;
              (r = parseInt(
                P(e.clickedSlide).attr("data-swiper-slide-index"),
                10
              )),
                t.centeredSlides
                  ? o < e.loopedSlides - i / 2 ||
                    o > e.slides.length - e.loopedSlides + i / 2
                    ? (e.loopFix(),
                      (o = n
                        .children(
                          `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                        )
                        .eq(0)
                        .index()),
                      O(() => {
                        e.slideTo(o);
                      }))
                    : e.slideTo(o)
                  : o > e.slides.length - i
                  ? (e.loopFix(),
                    (o = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    O(() => {
                      e.slideTo(o);
                    }))
                  : e.slideTo(o);
            } else e.slideTo(o);
          },
        },
        W = {
          loopCreate: function () {
            const e = this,
              t = y(),
              { params: n, $wrapperEl: i } = e,
              r = i.children().length > 0 ? P(i.children()[0].parentNode) : i;
            r.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
            let o = r.children(`.${n.slideClass}`);
            if (n.loopFillGroupWithBlank) {
              const e = n.slidesPerGroup - (o.length % n.slidesPerGroup);
              if (e !== n.slidesPerGroup) {
                for (let i = 0; i < e; i += 1) {
                  const e = P(t.createElement("div")).addClass(
                    `${n.slideClass} ${n.slideBlankClass}`
                  );
                  r.append(e);
                }
                o = r.children(`.${n.slideClass}`);
              }
            }
            "auto" !== n.slidesPerView ||
              n.loopedSlides ||
              (n.loopedSlides = o.length),
              (e.loopedSlides = Math.ceil(
                parseFloat(n.loopedSlides || n.slidesPerView, 10)
              )),
              (e.loopedSlides += n.loopAdditionalSlides),
              e.loopedSlides > o.length && (e.loopedSlides = o.length);
            const a = [],
              s = [];
            o.each((t, n) => {
              const i = P(t);
              n < e.loopedSlides && s.push(t),
                n < o.length && n >= o.length - e.loopedSlides && a.push(t),
                i.attr("data-swiper-slide-index", n);
            });
            for (let e = 0; e < s.length; e += 1)
              r.append(P(s[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
            for (let e = a.length - 1; e >= 0; e -= 1)
              r.prepend(P(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
          },
          loopFix: function () {
            const e = this;
            e.emit("beforeLoopFix");
            const {
              activeIndex: t,
              slides: n,
              loopedSlides: i,
              allowSlidePrev: r,
              allowSlideNext: o,
              snapGrid: a,
              rtlTranslate: s,
            } = e;
            let l;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            const c = -a[t] - e.getTranslate();
            t < i
              ? ((l = n.length - 3 * i + t),
                (l += i),
                e.slideTo(l, 0, !1, !0) &&
                  0 !== c &&
                  e.setTranslate((s ? -e.translate : e.translate) - c))
              : t >= n.length - i &&
                ((l = -n.length + t + i),
                (l += i),
                e.slideTo(l, 0, !1, !0) &&
                  0 !== c &&
                  e.setTranslate((s ? -e.translate : e.translate) - c)),
              (e.allowSlidePrev = r),
              (e.allowSlideNext = o),
              e.emit("loopFix");
          },
          loopDestroy: function () {
            const { $wrapperEl: e, params: t, slides: n } = this;
            e
              .children(
                `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
              )
              .remove(),
              n.removeAttr("data-swiper-slide-index");
          },
        };
      function G(e) {
        const t = this,
          n = y(),
          i = w(),
          r = t.touchEventsData,
          { params: o, touches: a, enabled: s } = t;
        if (!s) return;
        if (t.animating && o.preventInteractionOnTransition) return;
        !t.animating && o.cssMode && o.loop && t.loopFix();
        let l = e;
        l.originalEvent && (l = l.originalEvent);
        let c = P(l.target);
        if ("wrapper" === o.touchEventsTarget && !c.closest(t.wrapperEl).length)
          return;
        if (
          ((r.isTouchEvent = "touchstart" === l.type),
          !r.isTouchEvent && "which" in l && 3 === l.which)
        )
          return;
        if (!r.isTouchEvent && "button" in l && l.button > 0) return;
        if (r.isTouched && r.isMoved) return;
        o.noSwipingClass &&
          "" !== o.noSwipingClass &&
          l.target &&
          l.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (c = P(e.path[0]));
        const u = o.noSwipingSelector
            ? o.noSwipingSelector
            : `.${o.noSwipingClass}`,
          d = !(!l.target || !l.target.shadowRoot);
        if (
          o.noSwiping &&
          (d
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(n) {
                    return n && n !== y() && n !== w()
                      ? (n.assignedSlot && (n = n.assignedSlot),
                        n.closest(e) || t(n.getRootNode().host))
                      : null;
                  })(t)
                );
              })(u, l.target)
            : c.closest(u)[0])
        )
          return void (t.allowClick = !0);
        if (o.swipeHandler && !c.closest(o.swipeHandler)[0]) return;
        (a.currentX =
          "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
          (a.currentY =
            "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
        const p = a.currentX,
          f = a.currentY,
          h = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
          m = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
        if (h && (p <= m || p >= i.innerWidth - m)) {
          if ("prevent" !== h) return;
          e.preventDefault();
        }
        if (
          (Object.assign(r, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
          (a.startX = p),
          (a.startY = f),
          (r.touchStartTime = M()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          o.threshold > 0 && (r.allowThresholdMove = !1),
          "touchstart" !== l.type)
        ) {
          let e = !0;
          c.is(r.focusableElements) &&
            ((e = !1), "SELECT" === c[0].nodeName && (r.isTouched = !1)),
            n.activeElement &&
              P(n.activeElement).is(r.focusableElements) &&
              n.activeElement !== c[0] &&
              n.activeElement.blur();
          const i = e && t.allowTouchMove && o.touchStartPreventDefault;
          (!o.touchStartForcePreventDefault && !i) ||
            c[0].isContentEditable ||
            l.preventDefault();
        }
        t.params.freeMode &&
          t.params.freeMode.enabled &&
          t.freeMode &&
          t.animating &&
          !o.cssMode &&
          t.freeMode.onTouchStart(),
          t.emit("touchStart", l);
      }
      function V(e) {
        const t = y(),
          n = this,
          i = n.touchEventsData,
          { params: r, touches: o, rtlTranslate: a, enabled: s } = n;
        if (!s) return;
        let l = e;
        if ((l.originalEvent && (l = l.originalEvent), !i.isTouched))
          return void (
            i.startMoving &&
            i.isScrolling &&
            n.emit("touchMoveOpposite", l)
          );
        if (i.isTouchEvent && "touchmove" !== l.type) return;
        const c =
            "touchmove" === l.type &&
            l.targetTouches &&
            (l.targetTouches[0] || l.changedTouches[0]),
          u = "touchmove" === l.type ? c.pageX : l.pageX,
          d = "touchmove" === l.type ? c.pageY : l.pageY;
        if (l.preventedByNestedSwiper)
          return (o.startX = u), void (o.startY = d);
        if (!n.allowTouchMove)
          return (
            P(l.target).is(i.focusableElements) || (n.allowClick = !1),
            void (
              i.isTouched &&
              (Object.assign(o, {
                startX: u,
                startY: d,
                currentX: u,
                currentY: d,
              }),
              (i.touchStartTime = M()))
            )
          );
        if (i.isTouchEvent && r.touchReleaseOnEdges && !r.loop)
          if (n.isVertical()) {
            if (
              (d < o.startY && n.translate <= n.maxTranslate()) ||
              (d > o.startY && n.translate >= n.minTranslate())
            )
              return (i.isTouched = !1), void (i.isMoved = !1);
          } else if (
            (u < o.startX && n.translate <= n.maxTranslate()) ||
            (u > o.startX && n.translate >= n.minTranslate())
          )
            return;
        if (
          i.isTouchEvent &&
          t.activeElement &&
          l.target === t.activeElement &&
          P(l.target).is(i.focusableElements)
        )
          return (i.isMoved = !0), void (n.allowClick = !1);
        if (
          (i.allowTouchCallbacks && n.emit("touchMove", l),
          l.targetTouches && l.targetTouches.length > 1)
        )
          return;
        (o.currentX = u), (o.currentY = d);
        const p = o.currentX - o.startX,
          f = o.currentY - o.startY;
        if (
          n.params.threshold &&
          Math.sqrt(p ** 2 + f ** 2) < n.params.threshold
        )
          return;
        if (void 0 === i.isScrolling) {
          let e;
          (n.isHorizontal() && o.currentY === o.startY) ||
          (n.isVertical() && o.currentX === o.startX)
            ? (i.isScrolling = !1)
            : p * p + f * f >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(f), Math.abs(p))) / Math.PI),
              (i.isScrolling = n.isHorizontal()
                ? e > r.touchAngle
                : 90 - e > r.touchAngle));
        }
        if (
          (i.isScrolling && n.emit("touchMoveOpposite", l),
          void 0 === i.startMoving &&
            ((o.currentX === o.startX && o.currentY === o.startY) ||
              (i.startMoving = !0)),
          i.isScrolling)
        )
          return void (i.isTouched = !1);
        if (!i.startMoving) return;
        (n.allowClick = !1),
          !r.cssMode && l.cancelable && l.preventDefault(),
          r.touchMoveStopPropagation && !r.nested && l.stopPropagation(),
          i.isMoved ||
            (r.loop && !r.cssMode && n.loopFix(),
            (i.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating &&
              n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (i.allowMomentumBounce = !1),
            !r.grabCursor ||
              (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
              n.setGrabCursor(!0),
            n.emit("sliderFirstMove", l)),
          n.emit("sliderMove", l),
          (i.isMoved = !0);
        let h = n.isHorizontal() ? p : f;
        (o.diff = h),
          (h *= r.touchRatio),
          a && (h = -h),
          (n.swipeDirection = h > 0 ? "prev" : "next"),
          (i.currentTranslate = h + i.startTranslate);
        let m = !0,
          g = r.resistanceRatio;
        if (
          (r.touchReleaseOnEdges && (g = 0),
          h > 0 && i.currentTranslate > n.minTranslate()
            ? ((m = !1),
              r.resistance &&
                (i.currentTranslate =
                  n.minTranslate() -
                  1 +
                  (-n.minTranslate() + i.startTranslate + h) ** g))
            : h < 0 &&
              i.currentTranslate < n.maxTranslate() &&
              ((m = !1),
              r.resistance &&
                (i.currentTranslate =
                  n.maxTranslate() +
                  1 -
                  (n.maxTranslate() - i.startTranslate - h) ** g)),
          m && (l.preventedByNestedSwiper = !0),
          !n.allowSlideNext &&
            "next" === n.swipeDirection &&
            i.currentTranslate < i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
          !n.allowSlidePrev &&
            "prev" === n.swipeDirection &&
            i.currentTranslate > i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
          n.allowSlidePrev ||
            n.allowSlideNext ||
            (i.currentTranslate = i.startTranslate),
          r.threshold > 0)
        ) {
          if (!(Math.abs(h) > r.threshold || i.allowThresholdMove))
            return void (i.currentTranslate = i.startTranslate);
          if (!i.allowThresholdMove)
            return (
              (i.allowThresholdMove = !0),
              (o.startX = o.currentX),
              (o.startY = o.currentY),
              (i.currentTranslate = i.startTranslate),
              void (o.diff = n.isHorizontal()
                ? o.currentX - o.startX
                : o.currentY - o.startY)
            );
        }
        r.followFinger &&
          !r.cssMode &&
          (((r.freeMode && r.freeMode.enabled && n.freeMode) ||
            r.watchSlidesProgress) &&
            (n.updateActiveIndex(), n.updateSlidesClasses()),
          n.params.freeMode &&
            r.freeMode.enabled &&
            n.freeMode &&
            n.freeMode.onTouchMove(),
          n.updateProgress(i.currentTranslate),
          n.setTranslate(i.currentTranslate));
      }
      function X(e) {
        const t = this,
          n = t.touchEventsData,
          {
            params: i,
            touches: r,
            rtlTranslate: o,
            slidesGrid: a,
            enabled: s,
          } = t;
        if (!s) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
          n.allowTouchCallbacks && t.emit("touchEnd", l),
          (n.allowTouchCallbacks = !1),
          !n.isTouched)
        )
          return (
            n.isMoved && i.grabCursor && t.setGrabCursor(!1),
            (n.isMoved = !1),
            void (n.startMoving = !1)
          );
        i.grabCursor &&
          n.isMoved &&
          n.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const c = M(),
          u = c - n.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            u < 300 &&
              c - n.lastClickTime < 300 &&
              t.emit("doubleTap doubleClick", l);
        }
        if (
          ((n.lastClickTime = M()),
          O(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !n.isTouched ||
            !n.isMoved ||
            !t.swipeDirection ||
            0 === r.diff ||
            n.currentTranslate === n.startTranslate)
        )
          return (
            (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
          );
        let d;
        if (
          ((n.isTouched = !1),
          (n.isMoved = !1),
          (n.startMoving = !1),
          (d = i.followFinger
            ? o
              ? t.translate
              : -t.translate
            : -n.currentTranslate),
          i.cssMode)
        )
          return;
        if (t.params.freeMode && i.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: d });
        let p = 0,
          f = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < a.length;
          e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
        ) {
          const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== a[e + t]
            ? d >= a[e] && d < a[e + t] && ((p = e), (f = a[e + t] - a[e]))
            : d >= a[e] && ((p = e), (f = a[a.length - 1] - a[a.length - 2]));
        }
        let h = null,
          m = null;
        i.rewind &&
          (t.isBeginning
            ? (m =
                t.params.virtual && t.params.virtual.enabled && t.virtual
                  ? t.virtual.slides.length - 1
                  : t.slides.length - 1)
            : t.isEnd && (h = 0));
        const g = (d - a[p]) / f,
          v = p < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        if (u > i.longSwipesMs) {
          if (!i.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (g >= i.longSwipesRatio
              ? t.slideTo(i.rewind && t.isEnd ? h : p + v)
              : t.slideTo(p)),
            "prev" === t.swipeDirection &&
              (g > 1 - i.longSwipesRatio
                ? t.slideTo(p + v)
                : null !== m && g < 0 && Math.abs(g) > i.longSwipesRatio
                ? t.slideTo(m)
                : t.slideTo(p));
        } else {
          if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
          !t.navigation ||
          (l.target !== t.navigation.nextEl && l.target !== t.navigation.prevEl)
            ? ("next" === t.swipeDirection && t.slideTo(null !== h ? h : p + v),
              "prev" === t.swipeDirection && t.slideTo(null !== m ? m : p))
            : l.target === t.navigation.nextEl
            ? t.slideTo(p + v)
            : t.slideTo(p);
        }
      }
      function Y() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: i, allowSlidePrev: r, snapGrid: o } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
          e.isEnd &&
          !e.isBeginning &&
          !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.run(),
          (e.allowSlidePrev = r),
          (e.allowSlideNext = i),
          e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
      }
      function U(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function K() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: i } = e;
        if (!i) return;
        let r;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          -0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const o = e.maxTranslate() - e.minTranslate();
        (r = 0 === o ? 0 : (e.translate - e.minTranslate()) / o),
          r !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let J = !1;
      function Q() {}
      const Z = (e, t) => {
          const n = y(),
            {
              params: i,
              touchEvents: r,
              el: o,
              wrapperEl: a,
              device: s,
              support: l,
            } = e,
            c = !!i.nested,
            u = "on" === t ? "addEventListener" : "removeEventListener",
            d = t;
          if (l.touch) {
            const t = !(
              "touchstart" !== r.start ||
              !l.passiveListener ||
              !i.passiveListeners
            ) && { passive: !0, capture: !1 };
            o[u](r.start, e.onTouchStart, t),
              o[u](
                r.move,
                e.onTouchMove,
                l.passiveListener ? { passive: !1, capture: c } : c
              ),
              o[u](r.end, e.onTouchEnd, t),
              r.cancel && o[u](r.cancel, e.onTouchEnd, t);
          } else
            o[u](r.start, e.onTouchStart, !1),
              n[u](r.move, e.onTouchMove, c),
              n[u](r.end, e.onTouchEnd, !1);
          (i.preventClicks || i.preventClicksPropagation) &&
            o[u]("click", e.onClick, !0),
            i.cssMode && a[u]("scroll", e.onScroll),
            i.updateOnWindowResize
              ? e[d](
                  s.ios || s.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  Y,
                  !0
                )
              : e[d]("observerUpdate", Y, !0);
        },
        ee = {
          attachEvents: function () {
            const e = this,
              t = y(),
              { params: n, support: i } = e;
            (e.onTouchStart = G.bind(e)),
              (e.onTouchMove = V.bind(e)),
              (e.onTouchEnd = X.bind(e)),
              n.cssMode && (e.onScroll = K.bind(e)),
              (e.onClick = U.bind(e)),
              i.touch && !J && (t.addEventListener("touchstart", Q), (J = !0)),
              Z(e, "on");
          },
          detachEvents: function () {
            Z(this, "off");
          },
        },
        te = (e, t) => e.grid && t.grid && t.grid.rows > 1,
        ne = {
          addClasses: function () {
            const e = this,
              {
                classNames: t,
                params: n,
                rtl: i,
                $el: r,
                device: o,
                support: a,
              } = e,
              s = (function (e, t) {
                const n = [];
                return (
                  e.forEach((e) => {
                    "object" == typeof e
                      ? Object.keys(e).forEach((i) => {
                          e[i] && n.push(t + i);
                        })
                      : "string" == typeof e && n.push(t + e);
                  }),
                  n
                );
              })(
                [
                  "initialized",
                  n.direction,
                  { "pointer-events": !a.touch },
                  { "free-mode": e.params.freeMode && n.freeMode.enabled },
                  { autoheight: n.autoHeight },
                  { rtl: i },
                  { grid: n.grid && n.grid.rows > 1 },
                  {
                    "grid-column":
                      n.grid && n.grid.rows > 1 && "column" === n.grid.fill,
                  },
                  { android: o.android },
                  { ios: o.ios },
                  { "css-mode": n.cssMode },
                  { centered: n.cssMode && n.centeredSlides },
                ],
                n.containerModifierClass
              );
            t.push(...s),
              r.addClass([...t].join(" ")),
              e.emitContainerClasses();
          },
          removeClasses: function () {
            const { $el: e, classNames: t } = this;
            e.removeClass(t.join(" ")), this.emitContainerClasses();
          },
        },
        ie = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function re(e, t) {
        return function (n) {
          void 0 === n && (n = {});
          const i = Object.keys(n)[0],
            r = n[i];
          "object" == typeof r && null !== r
            ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
                !0 === e[i] &&
                (e[i] = { auto: !0 }),
              i in e && "enabled" in r
                ? (!0 === e[i] && (e[i] = { enabled: !0 }),
                  "object" != typeof e[i] ||
                    "enabled" in e[i] ||
                    (e[i].enabled = !0),
                  e[i] || (e[i] = { enabled: !1 }),
                  j(t, n))
                : j(t, n))
            : j(t, n);
        };
      }
      const oe = {
          eventsEmitter: H,
          update: B,
          translate: {
            getTranslate: function (e) {
              void 0 === e && (e = this.isHorizontal() ? "x" : "y");
              const {
                params: t,
                rtlTranslate: n,
                translate: i,
                $wrapperEl: r,
              } = this;
              if (t.virtualTranslate) return n ? -i : i;
              if (t.cssMode) return i;
              let o = (function (e, t) {
                void 0 === t && (t = "x");
                const n = w();
                let i, r, o;
                const a = (function (e) {
                  const t = w();
                  let n;
                  return (
                    t.getComputedStyle && (n = t.getComputedStyle(e, null)),
                    !n && e.currentStyle && (n = e.currentStyle),
                    n || (n = e.style),
                    n
                  );
                })(e);
                return (
                  n.WebKitCSSMatrix
                    ? ((r = a.transform || a.webkitTransform),
                      r.split(",").length > 6 &&
                        (r = r
                          .split(", ")
                          .map((e) => e.replace(",", "."))
                          .join(", ")),
                      (o = new n.WebKitCSSMatrix("none" === r ? "" : r)))
                    : ((o =
                        a.MozTransform ||
                        a.OTransform ||
                        a.MsTransform ||
                        a.msTransform ||
                        a.transform ||
                        a
                          .getPropertyValue("transform")
                          .replace("translate(", "matrix(1, 0, 0, 1,")),
                      (i = o.toString().split(","))),
                  "x" === t &&
                    (r = n.WebKitCSSMatrix
                      ? o.m41
                      : 16 === i.length
                      ? parseFloat(i[12])
                      : parseFloat(i[4])),
                  "y" === t &&
                    (r = n.WebKitCSSMatrix
                      ? o.m42
                      : 16 === i.length
                      ? parseFloat(i[13])
                      : parseFloat(i[5])),
                  r || 0
                );
              })(r[0], e);
              return n && (o = -o), o || 0;
            },
            setTranslate: function (e, t) {
              const n = this,
                {
                  rtlTranslate: i,
                  params: r,
                  $wrapperEl: o,
                  wrapperEl: a,
                  progress: s,
                } = n;
              let l,
                c = 0,
                u = 0;
              n.isHorizontal() ? (c = i ? -e : e) : (u = e),
                r.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
                r.cssMode
                  ? (a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                      n.isHorizontal() ? -c : -u)
                  : r.virtualTranslate ||
                    o.transform(`translate3d(${c}px, ${u}px, 0px)`),
                (n.previousTranslate = n.translate),
                (n.translate = n.isHorizontal() ? c : u);
              const d = n.maxTranslate() - n.minTranslate();
              (l = 0 === d ? 0 : (e - n.minTranslate()) / d),
                l !== s && n.updateProgress(e),
                n.emit("setTranslate", n.translate, t);
            },
            minTranslate: function () {
              return -this.snapGrid[0];
            },
            maxTranslate: function () {
              return -this.snapGrid[this.snapGrid.length - 1];
            },
            translateTo: function (e, t, n, i, r) {
              void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0),
                void 0 === i && (i = !0);
              const o = this,
                { params: a, wrapperEl: s } = o;
              if (o.animating && a.preventInteractionOnTransition) return !1;
              const l = o.minTranslate(),
                c = o.maxTranslate();
              let u;
              if (
                ((u = i && e > l ? l : i && e < c ? c : e),
                o.updateProgress(u),
                a.cssMode)
              ) {
                const e = o.isHorizontal();
                if (0 === t) s[e ? "scrollLeft" : "scrollTop"] = -u;
                else {
                  if (!o.support.smoothScroll)
                    return (
                      D({
                        swiper: o,
                        targetPosition: -u,
                        side: e ? "left" : "top",
                      }),
                      !0
                    );
                  s.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" });
                }
                return !0;
              }
              return (
                0 === t
                  ? (o.setTransition(0),
                    o.setTranslate(u),
                    n &&
                      (o.emit("beforeTransitionStart", t, r),
                      o.emit("transitionEnd")))
                  : (o.setTransition(t),
                    o.setTranslate(u),
                    n &&
                      (o.emit("beforeTransitionStart", t, r),
                      o.emit("transitionStart")),
                    o.animating ||
                      ((o.animating = !0),
                      o.onTranslateToWrapperTransitionEnd ||
                        (o.onTranslateToWrapperTransitionEnd = function (e) {
                          o &&
                            !o.destroyed &&
                            e.target === this &&
                            (o.$wrapperEl[0].removeEventListener(
                              "transitionend",
                              o.onTranslateToWrapperTransitionEnd
                            ),
                            o.$wrapperEl[0].removeEventListener(
                              "webkitTransitionEnd",
                              o.onTranslateToWrapperTransitionEnd
                            ),
                            (o.onTranslateToWrapperTransitionEnd = null),
                            delete o.onTranslateToWrapperTransitionEnd,
                            n && o.emit("transitionEnd"));
                        }),
                      o.$wrapperEl[0].addEventListener(
                        "transitionend",
                        o.onTranslateToWrapperTransitionEnd
                      ),
                      o.$wrapperEl[0].addEventListener(
                        "webkitTransitionEnd",
                        o.onTranslateToWrapperTransitionEnd
                      ))),
                !0
              );
            },
          },
          transition: {
            setTransition: function (e, t) {
              const n = this;
              n.params.cssMode || n.$wrapperEl.transition(e),
                n.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              const n = this,
                { params: i } = n;
              i.cssMode ||
                (i.autoHeight && n.updateAutoHeight(),
                F({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              const n = this,
                { params: i } = n;
              (n.animating = !1),
                i.cssMode ||
                  (n.setTransition(0),
                  F({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
            },
          },
          slide: R,
          loop: W,
          grabCursor: {
            setGrabCursor: function (e) {
              const t = this;
              if (
                t.support.touch ||
                !t.params.simulateTouch ||
                (t.params.watchOverflow && t.isLocked) ||
                t.params.cssMode
              )
                return;
              const n =
                "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
              (n.style.cursor = "move"),
                (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
                (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
                (n.style.cursor = e ? "grabbing" : "grab");
            },
            unsetGrabCursor: function () {
              const e = this;
              e.support.touch ||
                (e.params.watchOverflow && e.isLocked) ||
                e.params.cssMode ||
                (e[
                  "container" === e.params.touchEventsTarget
                    ? "el"
                    : "wrapperEl"
                ].style.cursor = "");
            },
          },
          events: ee,
          breakpoints: {
            setBreakpoint: function () {
              const e = this,
                {
                  activeIndex: t,
                  initialized: n,
                  loopedSlides: i = 0,
                  params: r,
                  $el: o,
                } = e,
                a = r.breakpoints;
              if (!a || (a && 0 === Object.keys(a).length)) return;
              const s = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
              if (!s || e.currentBreakpoint === s) return;
              const l = (s in a ? a[s] : void 0) || e.originalParams,
                c = te(e, r),
                u = te(e, l),
                d = r.enabled;
              c && !u
                ? (o.removeClass(
                    `${r.containerModifierClass}grid ${r.containerModifierClass}grid-column`
                  ),
                  e.emitContainerClasses())
                : !c &&
                  u &&
                  (o.addClass(`${r.containerModifierClass}grid`),
                  ((l.grid.fill && "column" === l.grid.fill) ||
                    (!l.grid.fill && "column" === r.grid.fill)) &&
                    o.addClass(`${r.containerModifierClass}grid-column`),
                  e.emitContainerClasses());
              const p = l.direction && l.direction !== r.direction,
                f = r.loop && (l.slidesPerView !== r.slidesPerView || p);
              p && n && e.changeDirection(), j(e.params, l);
              const h = e.params.enabled;
              Object.assign(e, {
                allowTouchMove: e.params.allowTouchMove,
                allowSlideNext: e.params.allowSlideNext,
                allowSlidePrev: e.params.allowSlidePrev,
              }),
                d && !h ? e.disable() : !d && h && e.enable(),
                (e.currentBreakpoint = s),
                e.emit("_beforeBreakpoint", l),
                f &&
                  n &&
                  (e.loopDestroy(),
                  e.loopCreate(),
                  e.updateSlides(),
                  e.slideTo(t - i + e.loopedSlides, 0, !1)),
                e.emit("breakpoint", l);
            },
            getBreakpoint: function (e, t, n) {
              if (
                (void 0 === t && (t = "window"),
                !e || ("container" === t && !n))
              )
                return;
              let i = !1;
              const r = w(),
                o = "window" === t ? r.innerHeight : n.clientHeight,
                a = Object.keys(e).map((e) => {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    const t = parseFloat(e.substr(1));
                    return { value: o * t, point: e };
                  }
                  return { value: e, point: e };
                });
              a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
              for (let e = 0; e < a.length; e += 1) {
                const { point: o, value: s } = a[e];
                "window" === t
                  ? r.matchMedia(`(min-width: ${s}px)`).matches && (i = o)
                  : s <= n.clientWidth && (i = o);
              }
              return i || "max";
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              const e = this,
                { isLocked: t, params: n } = e,
                { slidesOffsetBefore: i } = n;
              if (i) {
                const t = e.slides.length - 1,
                  n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                e.isLocked = e.size > n;
              } else e.isLocked = 1 === e.snapGrid.length;
              !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                t && t !== e.isLocked && (e.isEnd = !1),
                t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
            },
          },
          classes: ne,
          images: {
            loadImage: function (e, t, n, i, r, o) {
              const a = w();
              let s;
              function l() {
                o && o();
              }
              P(e).parent("picture")[0] || (e.complete && r)
                ? l()
                : t
                ? ((s = new a.Image()),
                  (s.onload = l),
                  (s.onerror = l),
                  i && (s.sizes = i),
                  n && (s.srcset = n),
                  t && (s.src = t))
                : l();
            },
            preloadImages: function () {
              const e = this;
              function t() {
                null != e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")));
              }
              e.imagesToLoad = e.$el.find("img");
              for (let n = 0; n < e.imagesToLoad.length; n += 1) {
                const i = e.imagesToLoad[n];
                e.loadImage(
                  i,
                  i.currentSrc || i.getAttribute("src"),
                  i.srcset || i.getAttribute("srcset"),
                  i.sizes || i.getAttribute("sizes"),
                  !0,
                  t
                );
              }
            },
          },
        },
        ae = {};
      class se {
        constructor() {
          let e, t;
          for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++)
            i[r] = arguments[r];
          if (
            (1 === i.length &&
            i[0].constructor &&
            "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
              ? (t = i[0])
              : ([e, t] = i),
            t || (t = {}),
            (t = j({}, t)),
            e && !t.el && (t.el = e),
            t.el && P(t.el).length > 1)
          ) {
            const e = [];
            return (
              P(t.el).each((n) => {
                const i = j({}, t, { el: n });
                e.push(new se(i));
              }),
              e
            );
          }
          const o = this;
          var a;
          (o.__swiper__ = !0),
            (o.support = z()),
            (o.device =
              (void 0 === (a = { userAgent: t.userAgent }) && (a = {}),
              q ||
                (q = (function (e) {
                  let { userAgent: t } = void 0 === e ? {} : e;
                  const n = z(),
                    i = w(),
                    r = i.navigator.platform,
                    o = t || i.navigator.userAgent,
                    a = { ios: !1, android: !1 },
                    s = i.screen.width,
                    l = i.screen.height,
                    c = o.match(/(Android);?[\s\/]+([\d.]+)?/);
                  let u = o.match(/(iPad).*OS\s([\d_]+)/);
                  const d = o.match(/(iPod)(.*OS\s([\d_]+))?/),
                    p = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    f = "Win32" === r;
                  let h = "MacIntel" === r;
                  return (
                    !u &&
                      h &&
                      n.touch &&
                      [
                        "1024x1366",
                        "1366x1024",
                        "834x1194",
                        "1194x834",
                        "834x1112",
                        "1112x834",
                        "768x1024",
                        "1024x768",
                        "820x1180",
                        "1180x820",
                        "810x1080",
                        "1080x810",
                      ].indexOf(`${s}x${l}`) >= 0 &&
                      ((u = o.match(/(Version)\/([\d.]+)/)),
                      u || (u = [0, 1, "13_0_0"]),
                      (h = !1)),
                    c && !f && ((a.os = "android"), (a.android = !0)),
                    (u || p || d) && ((a.os = "ios"), (a.ios = !0)),
                    a
                  );
                })(a)),
              q)),
            (o.browser =
              ($ ||
                ($ = (function () {
                  const e = w();
                  return {
                    isSafari: (function () {
                      const t = e.navigator.userAgent.toLowerCase();
                      return (
                        t.indexOf("safari") >= 0 &&
                        t.indexOf("chrome") < 0 &&
                        t.indexOf("android") < 0
                      );
                    })(),
                    isWebView:
                      /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                        e.navigator.userAgent
                      ),
                  };
                })()),
              $)),
            (o.eventsListeners = {}),
            (o.eventsAnyListeners = []),
            (o.modules = [...o.__modules__]),
            t.modules &&
              Array.isArray(t.modules) &&
              o.modules.push(...t.modules);
          const s = {};
          o.modules.forEach((e) => {
            e({
              swiper: o,
              extendParams: re(t, s),
              on: o.on.bind(o),
              once: o.once.bind(o),
              off: o.off.bind(o),
              emit: o.emit.bind(o),
            });
          });
          const l = j({}, ie, s);
          return (
            (o.params = j({}, l, ae, t)),
            (o.originalParams = j({}, o.params)),
            (o.passedParams = j({}, t)),
            o.params &&
              o.params.on &&
              Object.keys(o.params.on).forEach((e) => {
                o.on(e, o.params.on[e]);
              }),
            o.params && o.params.onAny && o.onAny(o.params.onAny),
            (o.$ = P),
            Object.assign(o, {
              enabled: o.params.enabled,
              el: e,
              classNames: [],
              slides: P(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === o.params.direction,
              isVertical: () => "vertical" === o.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: o.params.allowSlideNext,
              allowSlidePrev: o.params.allowSlidePrev,
              touchEvents: (function () {
                const e = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (o.touchEventsTouch = {
                    start: e[0],
                    move: e[1],
                    end: e[2],
                    cancel: e[3],
                  }),
                  (o.touchEventsDesktop = {
                    start: t[0],
                    move: t[1],
                    end: t[2],
                  }),
                  o.support.touch || !o.params.simulateTouch
                    ? o.touchEventsTouch
                    : o.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: o.params.focusableElements,
                lastClickTime: M(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: o.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            o.emit("_swiper"),
            o.params.init && o.init(),
            o
          );
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const i = n.minTranslate(),
            r = (n.maxTranslate() - i) * e + i;
          n.translateTo(r, void 0 === t ? 0 : t),
            n.updateActiveIndex(),
            n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter(
              (t) =>
                0 === t.indexOf("swiper") ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
            )
            .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((n) => {
            const i = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: i }), e.emit("_slideClass", n, i);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e, t) {
          void 0 === e && (e = "current"), void 0 === t && (t = !1);
          const {
            params: n,
            slides: i,
            slidesGrid: r,
            slidesSizesGrid: o,
            size: a,
            activeIndex: s,
          } = this;
          let l = 1;
          if (n.centeredSlides) {
            let e,
              t = i[s].swiperSlideSize;
            for (let n = s + 1; n < i.length; n += 1)
              i[n] &&
                !e &&
                ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
            for (let n = s - 1; n >= 0; n -= 1)
              i[n] &&
                !e &&
                ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
          } else if ("current" === e)
            for (let e = s + 1; e < i.length; e += 1)
              (t ? r[e] + o[e] - r[s] < a : r[e] - r[s] < a) && (l += 1);
          else for (let e = s - 1; e >= 0; e -= 1) r[s] - r[e] < a && (l += 1);
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function i() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let r;
          n.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (i(), e.params.autoHeight && e.updateAutoHeight())
              : ((r =
                  ("auto" === e.params.slidesPerView ||
                    e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)),
                r || i()),
            n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t) {
          void 0 === t && (t = !0);
          const n = this,
            i = n.params.direction;
          return (
            e || (e = "horizontal" === i ? "vertical" : "horizontal"),
            e === i ||
              ("horizontal" !== e && "vertical" !== e) ||
              (n.$el
                .removeClass(`${n.params.containerModifierClass}${i}`)
                .addClass(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              n.emit("changeDirection"),
              t && n.update()),
            n
          );
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const n = P(e || t.params.el);
          if (!(e = n[0])) return !1;
          e.swiper = t;
          const i = () =>
            `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let r = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = P(e.shadowRoot.querySelector(i()));
              return (t.children = (e) => n.children(e)), t;
            }
            return n.children(i());
          })();
          if (0 === r.length && t.params.createElements) {
            const e = y().createElement("div");
            (r = P(e)),
              (e.className = t.params.wrapperClass),
              n.append(e),
              n.children(`.${t.params.slideClass}`).each((e) => {
                r.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: n,
              el: e,
              $wrapperEl: r,
              wrapperEl: r[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
              wrongRTL: "-webkit-box" === r.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          const n = this,
            { params: i, $el: r, $wrapperEl: o, slides: a } = n;
          return (
            void 0 === n.params ||
              n.destroyed ||
              (n.emit("beforeDestroy"),
              (n.initialized = !1),
              n.detachEvents(),
              i.loop && n.loopDestroy(),
              t &&
                (n.removeClasses(),
                r.removeAttr("style"),
                o.removeAttr("style"),
                a &&
                  a.length &&
                  a
                    .removeClass(
                      [
                        i.slideVisibleClass,
                        i.slideActiveClass,
                        i.slideNextClass,
                        i.slidePrevClass,
                      ].join(" ")
                    )
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              n.emit("destroy"),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e &&
                ((n.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          j(ae, e);
        }
        static get extendedDefaults() {
          return ae;
        }
        static get defaults() {
          return ie;
        }
        static installModule(e) {
          se.prototype.__modules__ || (se.prototype.__modules__ = []);
          const t = se.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => se.installModule(e)), se)
            : (se.installModule(e), se);
        }
      }
      Object.keys(oe).forEach((e) => {
        Object.keys(oe[e]).forEach((t) => {
          se.prototype[t] = oe[e][t];
        });
      }),
        se.use([
          function (e) {
            let { swiper: t, on: n, emit: i } = e;
            const r = w();
            let o = null,
              a = null;
            const s = () => {
                t &&
                  !t.destroyed &&
                  t.initialized &&
                  (i("beforeResize"), i("resize"));
              },
              l = () => {
                t && !t.destroyed && t.initialized && i("orientationchange");
              };
            n("init", () => {
              t.params.resizeObserver && void 0 !== r.ResizeObserver
                ? t &&
                  !t.destroyed &&
                  t.initialized &&
                  ((o = new ResizeObserver((e) => {
                    a = r.requestAnimationFrame(() => {
                      const { width: n, height: i } = t;
                      let r = n,
                        o = i;
                      e.forEach((e) => {
                        let {
                          contentBoxSize: n,
                          contentRect: i,
                          target: a,
                        } = e;
                        (a && a !== t.el) ||
                          ((r = i ? i.width : (n[0] || n).inlineSize),
                          (o = i ? i.height : (n[0] || n).blockSize));
                      }),
                        (r === n && o === i) || s();
                    });
                  })),
                  o.observe(t.el))
                : (r.addEventListener("resize", s),
                  r.addEventListener("orientationchange", l));
            }),
              n("destroy", () => {
                a && r.cancelAnimationFrame(a),
                  o && o.unobserve && t.el && (o.unobserve(t.el), (o = null)),
                  r.removeEventListener("resize", s),
                  r.removeEventListener("orientationchange", l);
              });
          },
          function (e) {
            let { swiper: t, extendParams: n, on: i, emit: r } = e;
            const o = [],
              a = w(),
              s = function (e, t) {
                void 0 === t && (t = {});
                const n = new (a.MutationObserver || a.WebkitMutationObserver)(
                  (e) => {
                    if (1 === e.length) return void r("observerUpdate", e[0]);
                    const t = function () {
                      r("observerUpdate", e[0]);
                    };
                    a.requestAnimationFrame
                      ? a.requestAnimationFrame(t)
                      : a.setTimeout(t, 0);
                  }
                );
                n.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  o.push(n);
              };
            n({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              i("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = t.$el.parents();
                    for (let t = 0; t < e.length; t += 1) s(e[t]);
                  }
                  s(t.$el[0], { childList: t.params.observeSlideChildren }),
                    s(t.$wrapperEl[0], { attributes: !1 });
                }
              }),
              i("destroy", () => {
                o.forEach((e) => {
                  e.disconnect();
                }),
                  o.splice(0, o.length);
              });
          },
        ]);
      const le = se;
      function ce(e, t, n, i) {
        const r = y();
        return (
          e.params.createElements &&
            Object.keys(i).forEach((o) => {
              if (!n[o] && !0 === n.auto) {
                let a = e.$el.children(`.${i[o]}`)[0];
                a ||
                  ((a = r.createElement("div")),
                  (a.className = i[o]),
                  e.$el.append(a)),
                  (n[o] = a),
                  (t[o] = a);
              }
            }),
          n
        );
      }
      function ue(e) {
        let { swiper: t, extendParams: n, on: i, emit: r } = e;
        function o(e) {
          let n;
          return (
            e &&
              ((n = P(e)),
              t.params.uniqueNavElements &&
                "string" == typeof e &&
                n.length > 1 &&
                1 === t.$el.find(e).length &&
                (n = t.$el.find(e))),
            n
          );
        }
        function a(e, n) {
          const i = t.params.navigation;
          e &&
            e.length > 0 &&
            (e[n ? "addClass" : "removeClass"](i.disabledClass),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = n),
            t.params.watchOverflow &&
              t.enabled &&
              e[t.isLocked ? "addClass" : "removeClass"](i.lockClass));
        }
        function s() {
          if (t.params.loop) return;
          const { $nextEl: e, $prevEl: n } = t.navigation;
          a(n, t.isBeginning && !t.params.rewind),
            a(e, t.isEnd && !t.params.rewind);
        }
        function l(e) {
          e.preventDefault(),
            (!t.isBeginning || t.params.loop || t.params.rewind) &&
              t.slidePrev();
        }
        function c(e) {
          e.preventDefault(),
            (!t.isEnd || t.params.loop || t.params.rewind) && t.slideNext();
        }
        function u() {
          const e = t.params.navigation;
          if (
            ((t.params.navigation = ce(
              t,
              t.originalParams.navigation,
              t.params.navigation,
              { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
            )),
            !e.nextEl && !e.prevEl)
          )
            return;
          const n = o(e.nextEl),
            i = o(e.prevEl);
          n && n.length > 0 && n.on("click", c),
            i && i.length > 0 && i.on("click", l),
            Object.assign(t.navigation, {
              $nextEl: n,
              nextEl: n && n[0],
              $prevEl: i,
              prevEl: i && i[0],
            }),
            t.enabled ||
              (n && n.addClass(e.lockClass), i && i.addClass(e.lockClass));
        }
        function d() {
          const { $nextEl: e, $prevEl: n } = t.navigation;
          e &&
            e.length &&
            (e.off("click", c),
            e.removeClass(t.params.navigation.disabledClass)),
            n &&
              n.length &&
              (n.off("click", l),
              n.removeClass(t.params.navigation.disabledClass));
        }
        n({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
          },
        }),
          (t.navigation = {
            nextEl: null,
            $nextEl: null,
            prevEl: null,
            $prevEl: null,
          }),
          i("init", () => {
            u(), s();
          }),
          i("toEdge fromEdge lock unlock", () => {
            s();
          }),
          i("destroy", () => {
            d();
          }),
          i("enable disable", () => {
            const { $nextEl: e, $prevEl: n } = t.navigation;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.navigation.lockClass
              ),
              n &&
                n[t.enabled ? "removeClass" : "addClass"](
                  t.params.navigation.lockClass
                );
          }),
          i("click", (e, n) => {
            const { $nextEl: i, $prevEl: o } = t.navigation,
              a = n.target;
            if (t.params.navigation.hideOnClick && !P(a).is(o) && !P(a).is(i)) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === a || t.pagination.el.contains(a))
              )
                return;
              let e;
              i
                ? (e = i.hasClass(t.params.navigation.hiddenClass))
                : o && (e = o.hasClass(t.params.navigation.hiddenClass)),
                r(!0 === e ? "navigationShow" : "navigationHide"),
                i && i.toggleClass(t.params.navigation.hiddenClass),
                o && o.toggleClass(t.params.navigation.hiddenClass);
            }
          }),
          Object.assign(t.navigation, { update: s, init: u, destroy: d });
      }
      function de(e) {
        return (
          void 0 === e && (e = ""),
          `.${e
            .trim()
            .replace(/([\.:!\/])/g, "\\$1")
            .replace(/ /g, ".")}`
        );
      }
      function pe(e) {
        let { swiper: t, extendParams: n, on: i, emit: r } = e;
        const o = "swiper-pagination";
        let a;
        n({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (e) => e,
            formatFractionTotal: (e) => e,
            bulletClass: `${o}-bullet`,
            bulletActiveClass: `${o}-bullet-active`,
            modifierClass: `${o}-`,
            currentClass: `${o}-current`,
            totalClass: `${o}-total`,
            hiddenClass: `${o}-hidden`,
            progressbarFillClass: `${o}-progressbar-fill`,
            progressbarOppositeClass: `${o}-progressbar-opposite`,
            clickableClass: `${o}-clickable`,
            lockClass: `${o}-lock`,
            horizontalClass: `${o}-horizontal`,
            verticalClass: `${o}-vertical`,
          },
        }),
          (t.pagination = { el: null, $el: null, bullets: [] });
        let s = 0;
        function l() {
          return (
            !t.params.pagination.el ||
            !t.pagination.el ||
            !t.pagination.$el ||
            0 === t.pagination.$el.length
          );
        }
        function c(e, n) {
          const { bulletActiveClass: i } = t.params.pagination;
          e[n]().addClass(`${i}-${n}`)[n]().addClass(`${i}-${n}-${n}`);
        }
        function u() {
          const e = t.rtl,
            n = t.params.pagination;
          if (l()) return;
          const i =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            o = t.pagination.$el;
          let u;
          const d = t.params.loop
            ? Math.ceil((i - 2 * t.loopedSlides) / t.params.slidesPerGroup)
            : t.snapGrid.length;
          if (
            (t.params.loop
              ? ((u = Math.ceil(
                  (t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup
                )),
                u > i - 1 - 2 * t.loopedSlides && (u -= i - 2 * t.loopedSlides),
                u > d - 1 && (u -= d),
                u < 0 && "bullets" !== t.params.paginationType && (u = d + u))
              : (u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
            "bullets" === n.type &&
              t.pagination.bullets &&
              t.pagination.bullets.length > 0)
          ) {
            const i = t.pagination.bullets;
            let r, l, d;
            if (
              (n.dynamicBullets &&
                ((a = i
                  .eq(0)
                  [t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                o.css(
                  t.isHorizontal() ? "width" : "height",
                  a * (n.dynamicMainBullets + 4) + "px"
                ),
                n.dynamicMainBullets > 1 &&
                  void 0 !== t.previousIndex &&
                  ((s += u - (t.previousIndex - t.loopedSlides || 0)),
                  s > n.dynamicMainBullets - 1
                    ? (s = n.dynamicMainBullets - 1)
                    : s < 0 && (s = 0)),
                (r = Math.max(u - s, 0)),
                (l = r + (Math.min(i.length, n.dynamicMainBullets) - 1)),
                (d = (l + r) / 2)),
              i.removeClass(
                ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                  .map((e) => `${n.bulletActiveClass}${e}`)
                  .join(" ")
              ),
              o.length > 1)
            )
              i.each((e) => {
                const t = P(e),
                  i = t.index();
                i === u && t.addClass(n.bulletActiveClass),
                  n.dynamicBullets &&
                    (i >= r &&
                      i <= l &&
                      t.addClass(`${n.bulletActiveClass}-main`),
                    i === r && c(t, "prev"),
                    i === l && c(t, "next"));
              });
            else {
              const e = i.eq(u),
                o = e.index();
              if ((e.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                const e = i.eq(r),
                  a = i.eq(l);
                for (let e = r; e <= l; e += 1)
                  i.eq(e).addClass(`${n.bulletActiveClass}-main`);
                if (t.params.loop)
                  if (o >= i.length) {
                    for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                      i.eq(i.length - e).addClass(
                        `${n.bulletActiveClass}-main`
                      );
                    i.eq(i.length - n.dynamicMainBullets - 1).addClass(
                      `${n.bulletActiveClass}-prev`
                    );
                  } else c(e, "prev"), c(a, "next");
                else c(e, "prev"), c(a, "next");
              }
            }
            if (n.dynamicBullets) {
              const r = Math.min(i.length, n.dynamicMainBullets + 4),
                o = (a * r - a) / 2 - d * a,
                s = e ? "right" : "left";
              i.css(t.isHorizontal() ? s : "top", `${o}px`);
            }
          }
          if (
            ("fraction" === n.type &&
              (o.find(de(n.currentClass)).text(n.formatFractionCurrent(u + 1)),
              o.find(de(n.totalClass)).text(n.formatFractionTotal(d))),
            "progressbar" === n.type)
          ) {
            let e;
            e = n.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
              ? "horizontal"
              : "vertical";
            const i = (u + 1) / d;
            let r = 1,
              a = 1;
            "horizontal" === e ? (r = i) : (a = i),
              o
                .find(de(n.progressbarFillClass))
                .transform(`translate3d(0,0,0) scaleX(${r}) scaleY(${a})`)
                .transition(t.params.speed);
          }
          "custom" === n.type && n.renderCustom
            ? (o.html(n.renderCustom(t, u + 1, d)), r("paginationRender", o[0]))
            : r("paginationUpdate", o[0]),
            t.params.watchOverflow &&
              t.enabled &&
              o[t.isLocked ? "addClass" : "removeClass"](n.lockClass);
        }
        function d() {
          const e = t.params.pagination;
          if (l()) return;
          const n =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            i = t.pagination.$el;
          let o = "";
          if ("bullets" === e.type) {
            let r = t.params.loop
              ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup)
              : t.snapGrid.length;
            t.params.freeMode &&
              t.params.freeMode.enabled &&
              !t.params.loop &&
              r > n &&
              (r = n);
            for (let n = 0; n < r; n += 1)
              e.renderBullet
                ? (o += e.renderBullet.call(t, n, e.bulletClass))
                : (o += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
            i.html(o), (t.pagination.bullets = i.find(de(e.bulletClass)));
          }
          "fraction" === e.type &&
            ((o = e.renderFraction
              ? e.renderFraction.call(t, e.currentClass, e.totalClass)
              : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            i.html(o)),
            "progressbar" === e.type &&
              ((o = e.renderProgressbar
                ? e.renderProgressbar.call(t, e.progressbarFillClass)
                : `<span class="${e.progressbarFillClass}"></span>`),
              i.html(o)),
            "custom" !== e.type && r("paginationRender", t.pagination.$el[0]);
        }
        function p() {
          t.params.pagination = ce(
            t,
            t.originalParams.pagination,
            t.params.pagination,
            { el: "swiper-pagination" }
          );
          const e = t.params.pagination;
          if (!e.el) return;
          let n = P(e.el);
          0 !== n.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              n.length > 1 &&
              ((n = t.$el.find(e.el)),
              n.length > 1 &&
                (n = n.filter((e) => P(e).parents(".swiper")[0] === t.el))),
            "bullets" === e.type && e.clickable && n.addClass(e.clickableClass),
            n.addClass(e.modifierClass + e.type),
            n.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
            "bullets" === e.type &&
              e.dynamicBullets &&
              (n.addClass(`${e.modifierClass}${e.type}-dynamic`),
              (s = 0),
              e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
            "progressbar" === e.type &&
              e.progressbarOpposite &&
              n.addClass(e.progressbarOppositeClass),
            e.clickable &&
              n.on("click", de(e.bulletClass), function (e) {
                e.preventDefault();
                let n = P(this).index() * t.params.slidesPerGroup;
                t.params.loop && (n += t.loopedSlides), t.slideTo(n);
              }),
            Object.assign(t.pagination, { $el: n, el: n[0] }),
            t.enabled || n.addClass(e.lockClass));
        }
        function f() {
          const e = t.params.pagination;
          if (l()) return;
          const n = t.pagination.$el;
          n.removeClass(e.hiddenClass),
            n.removeClass(e.modifierClass + e.type),
            n.removeClass(
              t.isHorizontal() ? e.horizontalClass : e.verticalClass
            ),
            t.pagination.bullets &&
              t.pagination.bullets.removeClass &&
              t.pagination.bullets.removeClass(e.bulletActiveClass),
            e.clickable && n.off("click", de(e.bulletClass));
        }
        i("init", () => {
          p(), d(), u();
        }),
          i("activeIndexChange", () => {
            (t.params.loop || void 0 === t.snapIndex) && u();
          }),
          i("snapIndexChange", () => {
            t.params.loop || u();
          }),
          i("slidesLengthChange", () => {
            t.params.loop && (d(), u());
          }),
          i("snapGridLengthChange", () => {
            t.params.loop || (d(), u());
          }),
          i("destroy", () => {
            f();
          }),
          i("enable disable", () => {
            const { $el: e } = t.pagination;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.pagination.lockClass
              );
          }),
          i("lock unlock", () => {
            u();
          }),
          i("click", (e, n) => {
            const i = n.target,
              { $el: o } = t.pagination;
            if (
              t.params.pagination.el &&
              t.params.pagination.hideOnClick &&
              o.length > 0 &&
              !P(i).hasClass(t.params.pagination.bulletClass)
            ) {
              if (
                t.navigation &&
                ((t.navigation.nextEl && i === t.navigation.nextEl) ||
                  (t.navigation.prevEl && i === t.navigation.prevEl))
              )
                return;
              const e = o.hasClass(t.params.pagination.hiddenClass);
              r(!0 === e ? "paginationShow" : "paginationHide"),
                o.toggleClass(t.params.pagination.hiddenClass);
            }
          }),
          Object.assign(t.pagination, {
            render: d,
            update: u,
            init: p,
            destroy: f,
          });
      }
      function fe(e) {
        let t,
          { swiper: n, extendParams: i, on: r, emit: o } = e;
        function a() {
          const e = n.slides.eq(n.activeIndex);
          let i = n.params.autoplay.delay;
          e.attr("data-swiper-autoplay") &&
            (i = e.attr("data-swiper-autoplay") || n.params.autoplay.delay),
            clearTimeout(t),
            (t = O(() => {
              let e;
              n.params.autoplay.reverseDirection
                ? n.params.loop
                  ? (n.loopFix(),
                    (e = n.slidePrev(n.params.speed, !0, !0)),
                    o("autoplay"))
                  : n.isBeginning
                  ? n.params.autoplay.stopOnLastSlide
                    ? l()
                    : ((e = n.slideTo(
                        n.slides.length - 1,
                        n.params.speed,
                        !0,
                        !0
                      )),
                      o("autoplay"))
                  : ((e = n.slidePrev(n.params.speed, !0, !0)), o("autoplay"))
                : n.params.loop
                ? (n.loopFix(),
                  (e = n.slideNext(n.params.speed, !0, !0)),
                  o("autoplay"))
                : n.isEnd
                ? n.params.autoplay.stopOnLastSlide
                  ? l()
                  : ((e = n.slideTo(0, n.params.speed, !0, !0)), o("autoplay"))
                : ((e = n.slideNext(n.params.speed, !0, !0)), o("autoplay")),
                ((n.params.cssMode && n.autoplay.running) || !1 === e) && a();
            }, i));
        }
        function s() {
          return (
            void 0 === t &&
            !n.autoplay.running &&
            ((n.autoplay.running = !0), o("autoplayStart"), a(), !0)
          );
        }
        function l() {
          return (
            !!n.autoplay.running &&
            void 0 !== t &&
            (t && (clearTimeout(t), (t = void 0)),
            (n.autoplay.running = !1),
            o("autoplayStop"),
            !0)
          );
        }
        function c(e) {
          n.autoplay.running &&
            (n.autoplay.paused ||
              (t && clearTimeout(t),
              (n.autoplay.paused = !0),
              0 !== e && n.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                    n.$wrapperEl[0].addEventListener(e, d);
                  })
                : ((n.autoplay.paused = !1), a())));
        }
        function u() {
          const e = y();
          "hidden" === e.visibilityState && n.autoplay.running && c(),
            "visible" === e.visibilityState &&
              n.autoplay.paused &&
              (a(), (n.autoplay.paused = !1));
        }
        function d(e) {
          n &&
            !n.destroyed &&
            n.$wrapperEl &&
            e.target === n.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            }),
            (n.autoplay.paused = !1),
            n.autoplay.running ? a() : l());
        }
        function p() {
          n.params.autoplay.disableOnInteraction
            ? l()
            : (o("autoplayPause"), c()),
            ["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            });
        }
        function f() {
          n.params.autoplay.disableOnInteraction ||
            ((n.autoplay.paused = !1), o("autoplayResume"), a());
        }
        (n.autoplay = { running: !1, paused: !1 }),
          i({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          }),
          r("init", () => {
            n.params.autoplay.enabled &&
              (s(),
              y().addEventListener("visibilitychange", u),
              n.params.autoplay.pauseOnMouseEnter &&
                (n.$el.on("mouseenter", p), n.$el.on("mouseleave", f)));
          }),
          r("beforeTransitionStart", (e, t, i) => {
            n.autoplay.running &&
              (i || !n.params.autoplay.disableOnInteraction
                ? n.autoplay.pause(t)
                : l());
          }),
          r("sliderFirstMove", () => {
            n.autoplay.running &&
              (n.params.autoplay.disableOnInteraction ? l() : c());
          }),
          r("touchEnd", () => {
            n.params.cssMode &&
              n.autoplay.paused &&
              !n.params.autoplay.disableOnInteraction &&
              a();
          }),
          r("destroy", () => {
            n.$el.off("mouseenter", p),
              n.$el.off("mouseleave", f),
              n.autoplay.running && l(),
              y().removeEventListener("visibilitychange", u);
          }),
          Object.assign(n.autoplay, { pause: c, run: a, start: s, stop: l });
      }
      function he(e) {
        let { swiper: t, extendParams: n, on: i } = e;
        n({
          thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs",
          },
        });
        let r = !1,
          o = !1;
        function a() {
          const e = t.thumbs.swiper;
          if (!e) return;
          const n = e.clickedIndex,
            i = e.clickedSlide;
          if (i && P(i).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
          if (null == n) return;
          let r;
          if (
            ((r = e.params.loop
              ? parseInt(P(e.clickedSlide).attr("data-swiper-slide-index"), 10)
              : n),
            t.params.loop)
          ) {
            let e = t.activeIndex;
            t.slides.eq(e).hasClass(t.params.slideDuplicateClass) &&
              (t.loopFix(),
              (t._clientLeft = t.$wrapperEl[0].clientLeft),
              (e = t.activeIndex));
            const n = t.slides
                .eq(e)
                .prevAll(`[data-swiper-slide-index="${r}"]`)
                .eq(0)
                .index(),
              i = t.slides
                .eq(e)
                .nextAll(`[data-swiper-slide-index="${r}"]`)
                .eq(0)
                .index();
            r = void 0 === n ? i : void 0 === i ? n : i - e < e - n ? i : n;
          }
          t.slideTo(r);
        }
        function s() {
          const { thumbs: e } = t.params;
          if (r) return !1;
          r = !0;
          const n = t.constructor;
          if (e.swiper instanceof n)
            (t.thumbs.swiper = e.swiper),
              Object.assign(t.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              Object.assign(t.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              });
          else if (A(e.swiper)) {
            const i = Object.assign({}, e.swiper);
            Object.assign(i, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
              (t.thumbs.swiper = new n(i)),
              (o = !0);
          }
          return (
            t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass),
            t.thumbs.swiper.on("tap", a),
            !0
          );
        }
        function l(e) {
          const n = t.thumbs.swiper;
          if (!n) return;
          const i =
              "auto" === n.params.slidesPerView
                ? n.slidesPerViewDynamic()
                : n.params.slidesPerView,
            r = t.params.thumbs.autoScrollOffset,
            o = r && !n.params.loop;
          if (t.realIndex !== n.realIndex || o) {
            let a,
              s,
              l = n.activeIndex;
            if (n.params.loop) {
              n.slides.eq(l).hasClass(n.params.slideDuplicateClass) &&
                (n.loopFix(),
                (n._clientLeft = n.$wrapperEl[0].clientLeft),
                (l = n.activeIndex));
              const e = n.slides
                  .eq(l)
                  .prevAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                  .eq(0)
                  .index(),
                i = n.slides
                  .eq(l)
                  .nextAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                  .eq(0)
                  .index();
              (a =
                void 0 === e
                  ? i
                  : void 0 === i
                  ? e
                  : i - l == l - e
                  ? n.params.slidesPerGroup > 1
                    ? i
                    : l
                  : i - l < l - e
                  ? i
                  : e),
                (s = t.activeIndex > t.previousIndex ? "next" : "prev");
            } else
              (a = t.realIndex), (s = a > t.previousIndex ? "next" : "prev");
            o && (a += "next" === s ? r : -1 * r),
              n.visibleSlidesIndexes &&
                n.visibleSlidesIndexes.indexOf(a) < 0 &&
                (n.params.centeredSlides
                  ? (a =
                      a > l
                        ? a - Math.floor(i / 2) + 1
                        : a + Math.floor(i / 2) - 1)
                  : a > l && n.params.slidesPerGroup,
                n.slideTo(a, e ? 0 : void 0));
          }
          let a = 1;
          const s = t.params.thumbs.slideThumbActiveClass;
          if (
            (t.params.slidesPerView > 1 &&
              !t.params.centeredSlides &&
              (a = t.params.slidesPerView),
            t.params.thumbs.multipleActiveThumbs || (a = 1),
            (a = Math.floor(a)),
            n.slides.removeClass(s),
            n.params.loop || (n.params.virtual && n.params.virtual.enabled))
          )
            for (let e = 0; e < a; e += 1)
              n.$wrapperEl
                .children(`[data-swiper-slide-index="${t.realIndex + e}"]`)
                .addClass(s);
          else
            for (let e = 0; e < a; e += 1)
              n.slides.eq(t.realIndex + e).addClass(s);
        }
        (t.thumbs = { swiper: null }),
          i("beforeInit", () => {
            const { thumbs: e } = t.params;
            e && e.swiper && (s(), l(!0));
          }),
          i("slideChange update resize observerUpdate", () => {
            t.thumbs.swiper && l();
          }),
          i("setTransition", (e, n) => {
            const i = t.thumbs.swiper;
            i && i.setTransition(n);
          }),
          i("beforeDestroy", () => {
            const e = t.thumbs.swiper;
            e && o && e && e.destroy();
          }),
          Object.assign(t.thumbs, { init: s, update: l });
      }
      function me(e, t) {
        return e.transformEl
          ? t
              .find(e.transformEl)
              .css({
                "backface-visibility": "hidden",
                "-webkit-backface-visibility": "hidden",
              })
          : t;
      }
      function ge(e) {
        let { swiper: t, extendParams: n, on: i } = e;
        n({ fadeEffect: { crossFade: !1, transformEl: null } }),
          (function (e) {
            const {
              effect: t,
              swiper: n,
              on: i,
              setTranslate: r,
              setTransition: o,
              overwriteParams: a,
              perspective: s,
            } = e;
            let l;
            i("beforeInit", () => {
              if (n.params.effect !== t) return;
              n.classNames.push(`${n.params.containerModifierClass}${t}`),
                s &&
                  s() &&
                  n.classNames.push(`${n.params.containerModifierClass}3d`);
              const e = a ? a() : {};
              Object.assign(n.params, e), Object.assign(n.originalParams, e);
            }),
              i("setTranslate", () => {
                n.params.effect === t && r();
              }),
              i("setTransition", (e, i) => {
                n.params.effect === t && o(i);
              }),
              i("virtualUpdate", () => {
                n.slides.length || (l = !0),
                  requestAnimationFrame(() => {
                    l && n.slides.length && (r(), (l = !1));
                  });
              });
          })({
            effect: "fade",
            swiper: t,
            on: i,
            setTranslate: () => {
              const { slides: e } = t,
                n = t.params.fadeEffect;
              for (let i = 0; i < e.length; i += 1) {
                const e = t.slides.eq(i);
                let r = -e[0].swiperSlideOffset;
                t.params.virtualTranslate || (r -= t.translate);
                let o = 0;
                t.isHorizontal() || ((o = r), (r = 0));
                const a = t.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(e[0].progress), 0)
                  : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                me(n, e)
                  .css({ opacity: a })
                  .transform(`translate3d(${r}px, ${o}px, 0px)`);
              }
            },
            setTransition: (e) => {
              const { transformEl: n } = t.params.fadeEffect;
              (n ? t.slides.find(n) : t.slides).transition(e),
                (function (e) {
                  let {
                    swiper: t,
                    duration: n,
                    transformEl: i,
                    allSlides: r,
                  } = e;
                  const { slides: o, activeIndex: a, $wrapperEl: s } = t;
                  if (t.params.virtualTranslate && 0 !== n) {
                    let e,
                      n = !1;
                    (e = r
                      ? i
                        ? o.find(i)
                        : o
                      : i
                      ? o.eq(a).find(i)
                      : o.eq(a)),
                      e.transitionEnd(() => {
                        if (n) return;
                        if (!t || t.destroyed) return;
                        (n = !0), (t.animating = !1);
                        const e = ["webkitTransitionEnd", "transitionend"];
                        for (let t = 0; t < e.length; t += 1) s.trigger(e[t]);
                      });
                  }
                })({ swiper: t, duration: e, transformEl: n, allSlides: !0 });
            },
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !t.params.cssMode,
            }),
          });
      }
      function ve(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      var ye = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.slider();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "slider",
              value: function () {
                document
                  .querySelectorAll("[data-index-hero-swiper]")
                  .forEach(function (e) {
                    new le(e, {
                      modules: [pe],
                      loop: !0,
                      roundLengths: !0,
                      pagination: { el: ".swiper-pagination", clickable: !0 },
                    });
                  });
              },
            },
          ]) && ve(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function be(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      document.querySelector("[data-index-hero]") && new ye();
      var we = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.slider();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "slider",
              value: function () {
                document
                  .querySelectorAll("[data-index-review-swiper]")
                  .forEach(function (e) {
                    new le(e, {
                      speed: 800,
                      modules: [pe, fe, ge],
                      loop: !0,
                      roundLengths: !0,
                      autoplay: { delay: 5e3 },
                      pagination: { el: ".swiper-pagination", clickable: !0 },
                    });
                  });
              },
            },
          ]) && be(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      document.querySelector("[data-index-review]") && new we();
      var xe = n(755),
        Ce = n.n(xe);
      function Te(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      n(729);
      var Se = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            document.querySelector("[data-main-product]") &&
              (this.form(),
              this.gallery(),
              this.addToCart(),
              this.sticky(),
              this.popup());
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "popup",
              value: function () {
                document.querySelector("[data-product-popup]") &&
                  Ce()("[data-product-popup]").magnificPopup({
                    type: "inline",
                  });
              },
            },
            {
              key: "gallery",
              value: function () {
                var e = document.querySelector("[data-product-images]"),
                  t = document.querySelector("[data-product-thumbs]");
                if (e && t) {
                  var n = new le(t, {
                    spaceBetween: 12,
                    slidesPerView: 4,
                    watchSlidesProgress: !0,
                    roundLengths: !0,
                    breakpoints: {
                      1024: { slidesPerView: 5, spaceBetween: 24 },
                    },
                  });
                  new le(e, {
                    modules: [he, ue],
                    spaceBetween: 12,
                    roundLengths: !0,
                    thumbs: { swiper: n },
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                    breakpoints: { 1024: { spaceBetween: 24 } },
                  });
                }
              },
            },
            {
              key: "form",
              value: function () {
                new Shopify.OptionSelectors("productform-select", {
                  product: JSON.parse(
                    document.querySelector("[data-product-json]").textContent
                  ),
                  onVariantSelected: this.selectCallback,
                  enableHistoryState: !0,
                }),
                  document
                    .querySelectorAll("[data-product-option]")
                    .forEach(function (e) {
                      e.addEventListener("click", function (t) {
                        Ce()(
                          '.single-option-selector[data-option="'.concat(
                            e.dataset.option,
                            '"]'
                          )
                        ).val(e.value),
                          Ce()(
                            '.single-option-selector[data-option="'.concat(
                              e.dataset.option,
                              '"]'
                            )
                          ).trigger("change");
                      });
                    }),
                  document.querySelectorAll("[data-qty]").forEach(function (e) {
                    var t = e.querySelector("[data-qty-minus]"),
                      n = e.querySelector("[data-qty-input]"),
                      i = e.querySelector("[data-qty-plus]");
                    t.addEventListener("click", function (e) {
                      e.preventDefault();
                      var t = parseInt(n.value) - 1;
                      n.value = Math.min(Math.max(t, 1), 50);
                    }),
                      i.addEventListener("click", function (e) {
                        e.preventDefault();
                        var t = parseInt(n.value) + 1;
                        n.value = Math.min(Math.max(t, 1), 50);
                      });
                  });
              },
            },
            {
              key: "selectCallback",
              value: function (e, t) {
                Ce()("[data-product-price]").text("$".concat(e.price / 100));
              },
            },
            {
              key: "addToCart",
              value: function () {
                var e = document.querySelector('form[action$="/cart/add"]');
                e.addEventListener("submit", function (t) {
                  t.preventDefault();
                  var n = new FormData(e);
                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    body: n,
                  })
                    .then(function (e) {
                      return (
                        Ce()("[data-cart-open]").addClass("has-items"),
                        window.CartDrawer.fetchCart(),
                        window.CartDrawer.open(),
                        e.json()
                      );
                    })
                    .catch(function (e) {
                      console.error("Error:", e);
                    });
                });
              },
            },
            {
              key: "sticky",
              value: function () {
                new IntersectionObserver(function (e) {
                  e[0].isIntersecting
                    ? Ce()("[data-sticky-atc]").removeClass("active")
                    : Ce()("[data-sticky-atc]").addClass("active");
                  if(document.getElementById("smile-ui-lite-launcher-frame-container")){
                    if(!e[0].isIntersecting){
                      document.getElementById("smile-ui-lite-launcher-frame-container").style.bottom="90px";
                    }else{
                       document.getElementById("smile-ui-lite-launcher-frame-container").style.bottom="20px";
                    }
                  }
                  
                }).observe(document.querySelector("[data-product-form]")),
                  Ce()("[data-sticky-atc] [data-product-option]").on(
                    "click",
                    function () {
                      Ce()("[data-product-form] [data-product-option]").prop(
                        "checked",
                        !1
                      ),
                        Ce()(
                          '[data-product-form] [data-product-option][value="'.concat(
                            Ce()(this).val(),
                            '"]'
                          )
                        ).prop("checked", !0);
                    }
                  ),
                  Ce()("[data-product-form] [data-product-option]").on(
                    "click",
                    function () {
                      Ce()("[data-sticky-atc] [data-product-option]").prop(
                        "checked",
                        !1
                      ),
                        Ce()(
                          '[data-sticky-atc] [data-product-option][value="'.concat(
                            Ce()(this).val(),
                            '"]'
                          )
                        ).prop("checked", !0);
                    }
                  ),
                  Ce()("[data-sticky-atc-button]").on("click", function () {
                    Ce()("[data-add-to-cart]").trigger("click");
                  });
              },
            },
          ]) && Te(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Ee(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      window.Product = new Se();
      var ke = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.filters(),
            this.sort();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "filters",
              value: function () {
                var e = document.querySelector("[data-filter]"),
                  t = document.querySelector("[data-collection-tags]");
                e &&
                  t &&
                  e.addEventListener("click", function (e) {
                    e.preventDefault(), t.classList.toggle("active");
                  });
              },
            },
            {
              key: "sort",
              value: function () {
                var e = document.querySelector("#sort-by");
                e.addEventListener("change", function (t) {
                  window.location.href = e.value;
                });
              },
            },
          ]) && Ee(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Le(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      document.querySelector("[data-main-collection]") && new ke();
      var Pe = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.events();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "events",
              value: function () {
                Ce()("[data-faq-toggle]").on("click", function (e) {
                  e.preventDefault(),
                    Ce()("[data-faq-content]").removeClass("active"),
                    Ce()(this).find("[data-faq-content]").addClass("active");
                });
              },
            },
          ]) && Le(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Oe(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      document.querySelector("[data-faq]") && new Pe();
      var Me = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.events();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "events",
              value: function () {
        
                document
                  .querySelectorAll("[data-quick-shop]")
                  .forEach(function (e) {
                    e.addEventListener("click", function (t) {
                      t.preventDefault();
                      console.log("fire")
                      var n = e.dataset.quickShop.substring(1),
                        i = Number(e.dataset.productId);
                        fetch(
                          window.Shopify.routes.root +
                            n +
                            "?section_id=eq-main-product"
                        )
                        .then(function (e) {
                          return e.text();
                        })
                        .then(function (e) {
                          Ce().magnificPopup.open({
                            mainClass: "quick-shop",
                            items: { src: e, type: "inline" },
                            callbacks: {
                              open: function () {
                                window.ReChargeWidget.createWidget({
                                      productId: i,
                                      injectionParent: 
                                        ".rc-widget-injection-parent",
                                    });

                                    
                                // window.Product.form(),
                                //   window.Product.addToCart(),
                                //   window.ReChargeWidget.createWidget({
                                //     productId: i,
                                //     injectionParent: 
                                //       ".rc-widget-injection-parent",
                                //   });
                                
                                setTimeout(function(){
                                  
                                  let sellingPlanId = jQuery('.rc_widget__option__plans__dropdown').val();
                                  let discountText = jQuery('.quick-shop .rc-container-wrapper .rc_widget__option__discount').text();
                                    jQuery('.rc_widget__option__plans__dropdown').trigger('change');
                                    jQuery('.js-button-add-to-cart').attr("selling-plan-id",sellingPlanId);
                                    jQuery(`<p class="subscribe-text">Free Shipping. Pause or cancel anytime</p>`).insertAfter('.quick-shop .rc-container-wrapper .rc-selling-plans__dropdown'); 
                                    jQuery('.rc-container-wrapper .rc_widget__option__discount').text(`SAVE ${discountText}`);
                                    jQuery(`<label class="eq-product-banner__subscribe-label">Buying Options</label>`).insertBefore('.quick-shop .rc-container-wrapper .rc-template__legacy-radio');
                                  },1000)
                                //   let yotpoWidgetInterval = setInterval (function(){ 
                                //     if(typeof (window.yotpo) != undefined){
                                //         window.yotpo.refreshWidgets()
                                //         clearInterval(yotpoWidgetInterval) 
                                //     }
                                // },10);
                                  var ProductMainSwiper = new Swiper(".eqjsProductNavSlider", {
                                    slidesPerView: 5, 
                                    freeMode: false,
                                    watchSlidesProgress: true,
                                    lazy: true,
                                    breakpoints: { 
                                        250: {
                                            slidesPerView: 4,
                                        },
                                        768: {
                                            slidesPerView: 5,
                                        },
                                    },
                                  });
                                  var ProductNavSwiper = new Swiper(".eqjsProductMainSlider", {
                                    slidesPerView: 1,
                                    lazy: true,
                                    navigation: {
                                      nextEl: ".swiper-button-next",
                                      prevEl: ".swiper-button-prev",
                                    },
                                    thumbs: {
                                      swiper: ProductMainSwiper,
                                    },
                                });

                                jQuery(document).on('click','.js-button-add-to-cart',function(e){
                                  e.preventDefault();
                                  let data = {};
                                  let id = jQuery(this).attr('data-id');
                                  let quantity = JSON.parse(jQuery('.eq-product-banner__qty').val());
                                  if(jQuery('.eq-product-form input.rc-radio__input:checked').val() == 'subsave'){
                                      data.quantity = quantity;
                                      data.id = id;
                                      data.selling_plan = jQuery(this).attr('selling-plan-id')
                                  }else{
                                      data.quantity = quantity;
                                      data.id = id;
                                  }
                                  console.log(data);
                                  jQuery.ajax({
                                      type: 'POST',
                                      url: '/cart/add.js',
                                      data,
                                      dataType: 'json', 
                                      success: function (data) { 
                                          window.CartDrawer.fetchCart();
                                          window.CartDrawer.open()
                                      }
                                  })
                              })
                              
                              let selectedVariant = [];
                              jQuery(document).on('change','.eq-product-form .eq-product-banner__product-option input',function(){
                                let SelectedVariantimage =  jQuery('#productform-select option:selected').attr('data-image');
                                  selectedVariant = [];
                                  jQuery(this).parents('.eq-product-banner__values').find('input:checked').each(function(){
                                      selectedVariant.push(jQuery(this).val());
                                  });
                                  jQuery('#productform-select').val(selectedVariant.join('/')).trigger('change');
                                jQuery('.eqjsProductMainSlider .swiper-wrapper .swiper-slide').each(function() {
                                  console.log(SelectedVariantimage)
                                  if (jQuery(this).find('img').attr('src') == SelectedVariantimage) {
                                      let selectedIndex = parseInt(jQuery(this).find('img').attr('data-index'));
                                      ProductNavSwiper.slideTo(selectedIndex - 1);
                                      // jQuery(this).trigger('click');
                                  }
                              });
                              })
                              },
                            },
                          });
                        });
                    });
                  });
                
              },
            },
          ]) && Oe(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Ae(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      if(document.querySelector("body.template-product")){
        function loadQuickShopButton(){
          
          new Me();
          console.log("updated");
        }
        waitForElement("[data-quick-shop]", loadQuickShopButton, 50, 15000);
      }else{
        document.querySelector("[data-quick-shop]") && new Me();
      }
      
      var Ie = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.events();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "events",
              value: function () {
                var e = document.querySelector("[data-mobile-menu-toggle]"),
                  t = document.querySelector("[data-mobile-menu]"),
                  n = document.querySelector("[data-mobile-menu-tint]");
                e &&
                  t &&
                  n &&
                  (e.addEventListener("click", function (e) {
                    e.preventDefault(),
                      t.classList.add("active"),
                      n.classList.add("active");
                  }),
                  n.addEventListener("click", function (e) {
                    e.preventDefault(),
                      t.classList.remove("active"),
                      n.classList.remove("active");
                  }));
              },
            },
          ]) && Ae(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function je(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      document.querySelector("[data-mobile-menu]") && new Ie();
      var _e = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.init();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "init",
              value: function () {
                (this.cart = document.querySelector("[data-cart-drawer]")),
                  this.fetchCart();
              },
            },
            {
              key: "events",
              value: function () {
                var e = this;
                this.timeout;
                var t = document.querySelector("[data-cart-open]"),
                  n = document.querySelector("[data-cart-close]");
                t &&
                  this.cart &&
                  n &&
                  (t.addEventListener("click", function (t) {
                    t.preventDefault(), e.cart.classList.add("active");
                    console.log("dd");
                    document.querySelector("#smile-ui-lite-container").style.zIndex="888";
                  }),
                  n.addEventListener("click", function (t) {
                    t.preventDefault(), e.cart.classList.remove("active");
                    document.querySelector("#smile-ui-lite-container").style.zIndex="2147483647";
                  })),
                  this.cart.addEventListener("click", function (t) {
                    if (t.target.matches(".cart-item__remove"))
                      t.preventDefault(),
                        e.cart.classList.add("updating"),
                        fetch(window.Shopify.routes.root + "cart/change.js", {
                          method: "POST",
                          credentials: "same-origin",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({
                            line: parseInt(t.target.dataset.line),
                            quantity: 0,
                          }),
                        })
                          .then(function (e) {
                            return e.json();
                          })
                          .then(function (t) {
                            0 == t.item_count &&
                              Ce()("[data-cart-open]").removeClass("has-items"),
                              e.fetchCart();
                          });
                    else if (
                      t.target.matches(
                        "[data-qty-minus-cart], [data-qty-minus-cart] *"
                      )
                    ) {
                      t.preventDefault(),
                        t.stopImmediatePropagation(),
                        clearTimeout(e.timeout);
                      var n = t.target
                          .closest("[data-qty-cart]")
                          .querySelector("input"),
                        i = parseInt(n.value) - 1;
                      (n.value = Math.min(Math.max(i, 1), 50)),
                        (e.timeout = setTimeout(function () {
                          e.changeQty(n.value, n.dataset.line);
                        }, 250));
                    } else if (
                      t.target.matches(
                        "[data-qty-plus-cart], [data-qty-plus-cart] *"
                      )
                    ) {
                      t.preventDefault(),
                        t.stopImmediatePropagation(),
                        clearTimeout(e.timeout);
                      var r = t.target
                          .closest("[data-qty-cart]")
                          .querySelector("input"),
                        o = parseInt(r.value) + 1;
                      (r.value = Math.min(Math.max(o, 1), 50)),
                        (e.timeout = setTimeout(function () {
                          e.changeQty(r.value, r.dataset.line);
                        }, 250));
                    }
                    e.cart.addEventListener("change", function (t) {
                      t.target.matches("[data-qty-input-cart]") &&
                        (clearTimeout(e.timeout),
                        (e.timeout = setTimeout(function () {
                          e.changeQty(t.target.value, t.target.dataset.line);
                        }, 250)));
                    });
                  }),
                  document.addEventListener(
                    "quizKitAddToCartSuccess",
                    function (t) {
                      e.fetchCart(), e.open();
                    },
                    !1
                  );
              },
            },
            {
              key: "changeQty",
              value: function (e, t) {
                var n = this;
                this.cart.classList.add("updating"),
                  fetch(window.Shopify.routes.root + "cart/change.js", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      line: parseInt(t),
                      quantity: e,
                      sections: "cart",
                    }),
                  })
                    .then(function (e) {
                      return e.json();
                    })
                    .then(function (e) {
                      (n.cart.innerHTML = e.sections.cart),
                        n.events(),
                        n.cart.classList.remove("updating");
                    });
              },
            },
            {
              key: "open",
              value: function () {
                Ce().magnificPopup.close(), this.cart.classList.add("active");
              },
            },
            {
              key: "fetchCart",
              value: function () {
                var e = this;
                fetch(window.Shopify.routes.root + "?section_id=cart")
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    (e.cart.innerHTML = t),
                      e.events(),
                      e.cart.classList.remove("updating");
                  });
              },
            },
            {
              key: "addToCart",
              value: function (e) {
                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    items: [{ id: Number(e), quantity: 1 }],
                  }),
                })
                  .then(function (e) {
                    return (
                      Ce()("[data-cart-open]").addClass("has-items"),
                      window.CartDrawer.fetchCart(),
                      window.CartDrawer.open(),
                      e.json()
                    );
                  })
                  .catch(function (e) {
                    console.error("Error:", e);
                  });
              },
            },
          ]) && je(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      document.querySelector("[data-cart-drawer]") &&
        (window.CartDrawer = new _e()),
        (window.lazy = new (t())({ threshold: 1e3 })),
        a().init({ delay: 150, once: !0 }),
        new r({
          container: "#AjaxinateContainer",
          pagination: "#AjaxinatePagination",
          loadingText: "Loading...",
          method: "click",
          callback: function () {
            window.lazy.update();
          },
        }),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.money_format = "${{amount}}"),
        (window.Shopify.formatMoney = function (e, t) {
          "string" == typeof e && (e = e.replace(".", ""));
          var n = "",
            i = /\{\{\s*(\w+)\s*\}\}/,
            r = t || this.money_format;
          function o(e, t) {
            return void 0 === e ? t : e;
          }
          function a(e, t, n, i) {
            if (
              ((t = o(t, 2)),
              (n = o(n, ",")),
              (i = o(i, ".")),
              isNaN(e) || null == e)
            )
              return 0;
            var r = (e = (e / 100).toFixed(t)).split(".");
            return (
              r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
              (r[1] ? i + r[1] : "")
            );
          }
          switch (r.match(i)[1]) {
            case "amount":
              n = a(e, 2);
              break;
            case "amount_no_decimals":
              n = a(e, 0);
              break;
            case "amount_with_comma_separator":
              n = a(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n = a(e, 0, ".", ",");
          }
          return r.replace(i, n);
        });
    })();
})();
